// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../nodevenv/pathak/24/lib/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../nodevenv/pathak/24/lib/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../nodevenv/pathak/24/lib/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 22 16%27><path d=%27M18,0h-8C8.9,0,7.9,0.5,7.1,1.2c0,0,0,0,0,0L1,7.2C0.6,7.7,0.6,8.4,1,8.8l4.9,4.7L7,14.6c0,0,0,0,0,0c0.7,0.9,1.8,1.4,3,1.4 h8c2.2,0,4-1.8,4-4V4C22,1.8,20.2,0,18,0z M17.3,11.2l-0.7,0.7l-3.2-3.2l-3.2,3.2l-0.7-0.7L12.8,8L9.6,4.8l0.7-0.7l3.2,3.2l3.2-3.2 l0.7,0.7L14.2,8L17.3,11.2z%27 fill=%27%23FFFFFF%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjAwJyBoZWlnaHQ9JzIwMCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNMTAwIDBDMjAgMCAwIDIwIDAgMTAwczIwIDEwMCAxMDAgMTAwIDEwMC0yMCAxMDAtMTAwUzE4MCAwIDEwMCAwWicvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
|------------------------------------------------------------------------------
| TABLE OF CONTENTS
|------------------------------------------------------------------------------
| Accordion
| Action Sheet
| Audio
| Autocomplete
| Badge
| Bars
| Body
| Breadcrumb
| Button
| Card
| Chart
| Checkbox & Radio
| Chip
| Color Picker
| Content Block
| Data Table
| Date-Time Picker
| Dialog
| Dropcap
| Elevation
| Empty State
| Expandable Card
| Flip Card
| Floating Action Button
| Form Input
| Form Validator
| Gauge
| Grid
| Icon
| Image
| Image Compare
| Image Hotspot
| Infinite Scroll
| Integrations
| Keypad
| Line Divider
| Link
| List Index
| List View
| Margin & Padding
| Marquee
| Menu
| Menu List
| Message
| Navbar
| Note
| Notification
| Overlay Container
| Page
| Pagination
| Photo Browser
| Picker
| Popover
| Popup
| Position
| Preloader
| Progress Bar
| Pull-to-Refresh
| Quote
| Range Slider
| Rating
| Responsive Container
| Ribbon
| Scroll Bar
| Searchbar
| Shape & Size
| Sheet Modal
| Show More/Less
| Side Panel
| Signature Pad
| Skeleton
| Smart Select
| Sortable List
| State Toggle
| Stepper
| Subnavbar
| Swipeout
| Swiper Slider
| Syntax Highlighter
| Tab
| Text Editor
| Theme
| Timeline
| Timer
| Toast
| Toggle
| Toolbar
| Tooltip
| Tour Guide
| Tree View
| Video
| Virtual List
| Utilities
|------------------------------------------------------------------------------
*/

/*
|------------------------------------------------------------------------------
| Accordion
|------------------------------------------------------------------------------
*/

[dir=rtl] .accordion-opposite .accordion-item-toggle.item-content:before,
[dir=rtl] .accordion-opposite .accordion-item-toggle > .item-content:before,
[dir=rtl] .accordion-opposite .accordion-item > .item-content:before,
[dir=rtl] .accordion-opposite .accordion-item > .item-link > .item-content:before,
[dir=rtl] .accordion-opposite.links-list .accordion-item > a:before {
    transform: translateX(50%);
}

.accordion-item.custom-toggle-icon > .item-content > .item-inner,
.accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner {
    --f7-list-chevron-icon-area: 0px;
}

.accordion-item.custom-toggle-icon > .item-content > .item-inner:before,
.accordion-item.custom-toggle-icon > .item-content > .item-inner > .item-title-row:before ,
.accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner:before,
.accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner > .item-title-row:before {
    display: none;
}

.accordion-opposite .accordion-item.custom-toggle-icon > .item-content,
.accordion-opposite .accordion-item.custom-toggle-icon > .item-link > .item-content {
    --f7-list-chevron-icon-area: 0px;
}

.accordion-opposite .accordion-item.custom-toggle-icon > .item-content:before,
.accordion-opposite .accordion-item.custom-toggle-icon > .item-link > .item-content:before {
    display: none;
}

.accordion-item.accordion-item-opened.custom-toggle-icon .toggle-icon-open {
    display: none;
}

.accordion-item.accordion-item-opened.custom-toggle-icon .toggle-icon-close {
    display: inline-block;
}

.accordion-item:not(.accordion-item-opened).custom-toggle-icon .toggle-icon-open {
    display: inline-block;
}

.accordion-item:not(.accordion-item-opened).custom-toggle-icon .toggle-icon-close {
    display: none;
}

.accordion-opposite .accordion-item.custom-toggle-icon > .item-content > .item-inner,
.accordion-opposite .accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner {
    justify-content: flex-start;
}

.accordion-opposite .accordion-item.custom-toggle-icon > .item-content > .item-inner .item-title,
.accordion-opposite .accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner .item-title {
    order: 2;
}

.accordion-opposite .accordion-item.custom-toggle-icon > .item-content > .item-inner .item-after,
.accordion-opposite .accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner .item-after {
    margin-left: 0;
    margin-right: 0;
    order: 1;
    padding-left: 0;
    padding-right: var(--f7-list-item-after-padding);
}

[dir=rtl] .accordion-opposite .accordion-item.custom-toggle-icon > .item-content > .item-inner .item-after,
[dir=rtl] .accordion-opposite .accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner .item-after {
    padding-left: var(--f7-list-item-after-padding);
    padding-right: 0;
}

.cards-list li.accordion-item {
    margin: calc(var(--f7-list-margin-vertical) / 4) 0;
}

.accordion-item-opened .item-title[class*='color-'] {
    color: var(--f7-theme-color);
}

.accordion-item-content {
    font-size: 15px;
}

/*
|------------------------------------------------------------------------------
| Action Sheet
|------------------------------------------------------------------------------
*/

:root {
    --f7-actions-grid-button-font-size: 14px;
    --f7-actions-grid-button-icon-size: 24px;
}

.aurora, .ios, .md {
    --f7-actions-button-font-size: var(--f7-font-size);
    --f7-actions-button-icon-size: 24px;
    --f7-actions-label-font-size: var(--f7-font-size);
}

.md {
    --f7-actions-border-radius: 4px;
    --f7-actions-group-margin: 8px;
}

[dir=rtl].md {
    --f7-actions-button-text-align: right;
}

.actions-group:after {
    display: none;
}

.actions-button {
    align-items: center;
    height: auto;
    min-height: var(--f7-actions-button-height);
}

.aurora .actions-button-media {
    margin-left: 0;
}

[dir=rtl].ios .actions-button-media {
    margin-left: 0;
    margin-right: 16px;
}

.md .actions-button-media {
    min-width: var(--f7-actions-button-icon-size);
}

[dir=rtl].aurora .actions-button-media + .actions-button-text,
[dir=rtl].md .actions-button-media + .actions-button-text {
    margin-left: 0;
    margin-right: 16px;
    text-align: right;
}

[dir=rtl].ios .actions-button-media + .actions-button-text {
    margin-right: 16px;
    text-align: right;
}

.md .actions-button-media + .actions-button-text {
    text-align: left;
}

.actions-grid .actions-button {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.actions-grid .actions-button[class*=color-] {
    color: var(--f7-theme-color);
}

.actions-grid .actions-button-media {
    height: auto;
    width: auto;
}

.actions-grid .actions-button-text {
    margin-right: 0 !important;
}

.actions-grid .actions-label {
    --f7-actions-label-justify-content: center;
}

/*
|------------------------------------------------------------------------------
| Audio
|------------------------------------------------------------------------------
*/

audio {
    display: block;
    width: 100%;
}

.dark audio::-webkit-media-controls-panel {
    background-color: var(--color-gray-800);
}

.dark audio::-webkit-media-controls-play-button,
.dark audio::-webkit-media-controls-mute-button {
    background-color: var(--color-gray-400);
    border-radius: 50%;
}

.dark audio::-webkit-media-controls-current-time-display,
.dark audio::-webkit-media-controls-time-remaining-display {
    color: #FFFFFF;
}

.dark audio::-webkit-media-controls-timeline {
    background-color: var(--color-gray-600);
    border-radius: 24px;
    margin-left: 16px;
    margin-right: 16px;
}

.dark audio::-webkit-media-controls-volume-slider {
    background-color: var(--color-gray-400);
    border-radius: 24px;
    margin-right: 8px;
    padding-left: 8px;
    padding-right: 8px;
}

/*
|------------------------------------------------------------------------------
| Autocomplete
|------------------------------------------------------------------------------
*/

.autocomplete-dropdown {
    border-radius: 4px;
}

.autocomplete-popup .searchbar-backdrop {
    display: none;
}

/*
|------------------------------------------------------------------------------
| Badge
|------------------------------------------------------------------------------
*/

:root {
    --f7-badge-bg-color: var(--color-gray-500);
}

:root .dark, :root.dark {
    --f7-badge-bg-color: var(--color-gray-700);
}

.aurora, .ios, .md {
    --f7-badge-font-weight: normal;
    --f7-badge-size: 20px;
}

.badge {
    border-radius: 4px;
    height: auto;
    line-height: 1;
    margin: 3px;
    min-height: var(--f7-badge-size);
    overflow: hidden;
    --f7-touch-ripple-color: rgba(var(--f7-color-gray-rgb), 0.25);
}

.badge[class*=color-] {
    --f7-touch-ripple-color: rgba(var(--f7-theme-color-rgb), 0.25);
}

.badge > :not(.ripple-wave) + * {
    margin-left: 3px;
    margin-right: 0;
}

[dir=rtl] .badge > :not(.ripple-wave) + * {
    margin-left: 0;
    margin-right: 3px;
}

.badge-round {
    border-radius: var(--f7-badge-size);
    --f7-badge-padding: 0px 8px;
}

.badge-outline {
    background: none;
    border: 1px solid var(--f7-badge-bg-color);
    color: var(--f7-badge-bg-color);
}

.badge-fade {
    background-color: rgba(var(--color-gray-rgb-500), 0.2);
    color: var(--color-gray-600);
}

.badge-fade[class*='color-'] {
    background-color: rgba(var(--f7-theme-color-rgb), 0.2);
    color: var(--f7-theme-color);
}

.badge.badge-dot {
    border-radius: 50%;
    height: var(--f7-badge-size);
    overflow: hidden;
    width: var(--f7-badge-size);
    --f7-badge-padding: 0px;
    --f7-badge-size: 10px;
    --f7-badge-text-color: transparent;
}

.badge .icon {
    font-size: var(--f7-badge-font-size) !important;
}

.icon .badge {
    margin-top: 0;
}

[dir=rtl] .icon .badge {
    left: auto;
    margin-left: 0;
    margin-right: -10px;
    right: 100%;
}

.button .badge {
    --f7-badge-bg-color: #FFFFFF;
    --f7-badge-font-size: var(--f7-button-font-size);
    --f7-badge-font-weight: var(--f7-button-font-weight);
    --f7-badge-text-color: var(--f7-theme-color);
    margin: 0 8px !important;
}

.badge-wrapper {
    overflow: visible;
    position: relative;
}

.badge-wrapper .badge {
    left: 100%;
    margin: 0;
    position: absolute;
    top: calc(var(--f7-badge-size) / -2);
    transform: translateX(calc(var(--f7-badge-size) / -2));
    --f7-badge-font-size: 0.625rem;
    --f7-badge-size: 0.625rem;
}

[dir=rtl] .badge-wrapper .badge {
    left: auto;
    right: 100%;
    transform: translateX(calc(var(--f7-badge-size) / 2));
}

.badge-wrapper .badge-bottom {
    bottom: calc(var(--f7-badge-size) / -2);
    top: auto;
}

/*
|------------------------------------------------------------------------------
| Bars
|------------------------------------------------------------------------------
*/

:root {
    --f7-bars-bg-color: #FFFFFF;
    --f7-bars-bg-color-rgb: 255, 255, 255;
}

:root {
    --f7-bars-shadow-bottom-image: linear-gradient(to bottom, rgba(158, 158, 158, 0.1) 0%, rgba(158, 158, 158, 0.05) 40%, rgba(158, 158, 158, 0.025) 50%, rgba(158, 158, 158, 0.0125) 90%, rgba(158, 158, 158, 0.0) 100%);
    --f7-bars-shadow-top-image: linear-gradient(to top, rgba(158, 158, 158, 0.1) 0%, rgba(158, 158, 158, 0.05) 40%, rgba(158, 158, 158, 0.025) 50%, rgba(158, 158, 158, 0.0125) 90%, rgba(158, 158, 158, 0.0) 100%);
}

:root .dark, :root.dark {
    --f7-bars-shadow-bottom-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.16) 0%, rgba(0, 0, 0, 0.08) 40%, rgba(0, 0, 0, 0.04) 50%, rgba(0, 0, 0, 0.02) 90%, rgba(0, 0, 0, 0) 100%);
    --f7-bars-shadow-top-image: linear-gradient(to top, rgba(0, 0, 0, 0.16) 0%, rgba(0, 0, 0, 0.08) 40%, rgba(0, 0, 0, 0.04) 50%, rgba(0, 0, 0, 0.02) 90%, rgba(0, 0, 0, 0) 100%);
}

.aurora .dark, .aurora.dark, .ios .dark, .ios.dark, .md .dark, .md.dark {
    --f7-bars-bg-color: #1C1C1C;
    --f7-bars-bg-color-rgb: 28, 28, 28;
}

.aurora, .ios {
    --f7-bars-border-color: rgba(0, 0, 0, 0.12);
}

.aurora .dark, .aurora.dark, .ios .dark, .ios.dark {
    --f7-bars-border-color: rgba(255, 255, 255, 0.12);
}

/*
|------------------------------------------------------------------------------
| Body
|------------------------------------------------------------------------------
*/

:root {
    --f7-font-size: 16px;
    --f7-body-bg-color: #ECEFF1;
}

:root .dark, :root.dark {
    --f7-body-bg-color: #000000;
}

html {
    overscroll-behavior-y: contain;
}

body {
    background: var(--f7-body-bg-color);
}

.bg-color-body {
    background-color: var(--f7-body-bg-color) !important;
}

.text-color-body {
    color: var(--f7-text-color) !important;
}

/*
|------------------------------------------------------------------------------
| Breadcrumb
|------------------------------------------------------------------------------
*/

.breadcrumbs[class*='color-'] {
    --f7-breadcrumbs-item-color: rgba(var(--f7-theme-color-rgb), 0.55);
    --f7-breadcrumbs-item-active-color: var(--f7-theme-color);
    --f7-breadcrumbs-separator-color: rgba(var(--f7-theme-color-rgb), 0.35);
    --f7-breadcrumbs-collapsed-color: rgba(var(--f7-theme-color-rgb), 0.75);
    --f7-breadcrumbs-collapsed-bg-color: rgba(var(--f7-theme-color-rgb), 0.15);
}

.breadcrumbs-item a {
    border-radius: var(--f7-button-border-radius);
    overflow: hidden;
    padding: 0 4px;
}

.breadcrumbs-item a {
    --f7-touch-ripple-color: rgba(var(--f7-color-gray-rgb), 0.25) !important;
}

.breadcrumbs[class*='color-'] .breadcrumbs-item a {
    --f7-touch-ripple-color: rgba(var(--f7-theme-color-rgb), 0.25) !important;
}

[dir=rtl] .breadcrumbs-collapsed + .breadcrumbs-collapsed, [dir=rtl] .breadcrumbs-collapsed + .breadcrumbs-item, [dir=rtl] .breadcrumbs-collapsed + .breadcrumbs-separator,
[dir=rtl] .breadcrumbs-item + .breadcrumbs-collapsed, [dir=rtl] .breadcrumbs-item + .breadcrumbs-item, [dir=rtl] .breadcrumbs-item + .breadcrumbs-separator,
[dir=rtl] .breadcrumbs-separator + .breadcrumbs-collapsed, [dir=rtl] .breadcrumbs-separator + .breadcrumbs-item, [dir=rtl] .breadcrumbs-separator + .breadcrumbs-separator {
    margin-left: 0;
    margin-right: var(--f7-breadcrumbs-spacing);
}

.breadcrumbs-separator.separator-dot:after {
    content: '\\2022';
    font-family: var(--f7-font-family);
    font-weight: bold;
}

.breadcrumbs-separator.separator-slash:after {
    content: '\\002F';
    font-family: var(--f7-font-family);
    font-weight: bold;
}

[dir=rtl] .breadcrumbs-separator:after {
    transform: scaleX(-1);
}

/*
|------------------------------------------------------------------------------
| Button
|------------------------------------------------------------------------------
*/

:root {
    --f7-button-min-width: auto;
    --f7-button-small-outline-border-width: 1px;
}

:root .dark, :root.dark {
    --f7-button-raised-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24), 0 1px 2px rgba(0, 0, 0, 0.48);
}

.aurora, .ios, .md {
    --f7-button-font-size: 14px;
    --f7-button-font-weight: 500;
    --f7-button-large-font-size: 14px;
    --f7-button-large-font-weight: 600;
    --f7-button-small-font-size: 12px;
    --f7-button-small-font-weight: normal;
    --f7-button-padding-horizontal: 16px;
}

.aurora {
    --f7-button-letter-spacing: 0.025em;
}

.ios {
    --f7-button-height: 36px;
    --f7-button-letter-spacing: 0.01em;
    --f7-segmented-strong-button-text-transform: uppercase;
}

.ios .button-small-ios.button-fill, .ios .button-small.button-fill, .ios .button-small.button-fill-ios {
    --f7-button-pressed-bg-color: var(--f7-theme-color-tint);
    --f7-button-pressed-text-color: var(--f7-button-text-color);
}

.button-fade {
    --f7-button-bg-color: rgba(var(--f7-theme-color-rgb), 0.125);
}

.button-preloader.button-loading {
    pointer-events: none;
}

.button-icon {
    height: var(--f7-button-height);
    width: var(--f7-button-height);
}

.button > :not(.ripple-wave) + * {
    margin-left: 4px;
    margin-right: 0;
}

[dir=rtl] .button > :not(.ripple-wave) + * {
    margin-left: 0;
    margin-right: 4px;
}

.button-social {
    justify-content: space-between;
}

.button-social > span:not(.icon) {
    flex-grow: 1;
}

.button > img, .button > svg {
    height: calc((var(--f7-button-height) - var(--f7-button-padding-horizontal)) / 1.5);
}

.button-large > img, .button-large > svg {
    height: calc((var(--f7-button-height) - var(--f7-button-padding-horizontal)) / 1.75);
}

.button-small > img, .button-small > svg {
    height: calc((var(--f7-button-height) - var(--f7-button-padding-horizontal)) / 1.25);
}

.segmented-strong .button {
    --f7-touch-ripple-color: rgba(var(--f7-color-gray-rgb), 0.25);
}

.aurora .segmented-round, .ios .segmented-round, .md .segmented-round {
    border-radius: var(--f7-button-large-height);
}

.segmented-round .segmented-highlight {
    border-radius: inherit;
}

[dir=rtl] .aurora .segmented-strong-aurora .segmented-highlight,
[dir=rtl] .ios .segmented-strong-ios .segmented-highlight,
[dir=rtl] .md .segmented-strong-md .segmented-highlight,
[dir=rtl] .segmented-strong .segmented-highlight {
    left: auto;
    transform: translateX(calc(var(--f7-segmented-highlight-active) * -100% - var(--f7-segmented-highlight-active) * var(--f7-segmented-highlight-between)));
}

.segmented-strong .button.button-active,
.segmented-strong .button.tab-link-active {
    --f7-button-hover-bg-color: transparent;
}

.segmented-strong[class*='color-'] .button.button-active,
.segmented-strong[class*='color-'] .button.tab-link-active {
    --f7-button-bg-color: var(--f7-theme-color);
    color: #FFFFFF;
}

.segmented-strong[class*='color-'] .segmented-highlight {
    --f7-segmented-strong-button-active-box-shadow: 0px 2px 2px rgba(var(--f7-theme-color-rgb), 0.25);
}

.aurora.device-desktop .segmented-strong[class*='color-'] .button:not(.active-state):not(.no-hover):hover {
    background-color: var(--f7-theme-color);
}

.aurora.device-desktop .segmented-strong[class*='color-'] .button:not(.button-active):not(.tab-link-active):not(.active-state):not(.no-hover):hover {
    background-color: rgba(0, 0, 0, 0.04);
}

/*
|------------------------------------------------------------------------------
| Card
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-card-border-radius: var(--f7-block-inset-border-radius);
    --f7-card-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    --f7-card-header-font-size: 18px;
    --f7-card-header-font-weight: bold;
    --f7-card-header-min-height: 48px;
    --f7-card-header-padding-vertical: 8px;
    --f7-card-footer-font-size: 14px;
    --f7-card-footer-min-height: 48px;
    --f7-card-footer-padding-vertical: 12px;
}

.card-media {
    align-items: flex-start;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-end;
    overflow: hidden;
    position: relative;
    width: 100%;
}

.card > .card-media:first-child {
    border-top-left-radius: var(--f7-card-border-radius);
    border-top-right-radius: var(--f7-card-border-radius);
}

.card > .card-media:last-child {
    border-bottom-left-radius: var(--f7-card-border-radius);
    border-bottom-right-radius: var(--f7-card-border-radius);
}

.card-media-content {
    box-sizing: border-box;
    color: #FFFFFF;
    padding: var(--f7-card-content-padding-vertical) var(--f7-card-content-padding-horizontal);
    position: relative;
    width: 100%;
    z-index: 1000;
}

.card-media > * ~ .card-media-content {
    position: absolute;
}

.card-title {
    font-size: 22px;
    font-weight: bold;
}

.card-subtitle {
    font-size: 16px;
}

.card-text {
    color: var(--f7-card-footer-text-color);
    font-size: 14px;
}

.card-title + .card-subtitle, .card-title + .card-text, .card-subtitle + .card-text {
    margin-top: 4px;
}

.card-footer > * + * {
    margin-left: 4px;
    margin-right: 0;
}

[dir=rtl] .card-footer > * + * {
    margin-left: 0;
    margin-right: 4px;
}

/*
|------------------------------------------------------------------------------
| Chart
|------------------------------------------------------------------------------
*/

:root .dark, :root.dark {
    --f7-area-chart-tooltip-total-label-text-color: rgba(0, 0, 0, 0.5);
}

[dir=rtl] .area-chart svg {
    transform: scaleX(-1);
}

[dir=rtl] .area-chart-tooltip,
[dir=rtl] .pie-chart-tooltip {
    text-align: right;
}

[dir=rtl] .area-chart-tooltip-list span,
[dir=rtl] .area-chart-legend-item span,
[dir=rtl] .pie-chart-tooltip-color {
    margin-left: 4px;
    margin-right: 0;
}

/*
|------------------------------------------------------------------------------
| Checkbox & Radio
|------------------------------------------------------------------------------
*/

.checkbox,
.radio {
    --f7-touch-ripple-color: transparent;
}

.checkbox-inline,
.radio-inline {
    display: inline-flex;
}

.aurora .checkbox-inline, .md .checkbox-inline,
.aurora .radio-inline, .md .radio-inline {
    line-height: 1;
}

.checkbox-inline > .icon-checkbox,
.radio-inline > .icon-radio {
    margin-left: 0;
    margin-right: 4px;
}

[dir=rtl] .checkbox-inline > .icon-checkbox,
[dir=rtl] .radio-inline > .icon-radio {
    margin-left: 4px;
    margin-right: 0;
}

.checkbox-list .item-checkbox,
.radio-list .item-radio {
    padding: 0;
}

.checkbox-list .item-inner,
.radio-list .item-inner {
    margin: 0;
    padding: var(--f7-list-item-padding-vertical) calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left) - var(--menu-list-offset)) !important;
}

.checkbox-list .item-checkbox, .checkbox-list .item-checkbox .item-inner,
.radio-list .item-radio, .radio-list .item-radio .item-inner {
    border-radius: inherit;
}

.checkbox-list.checkbox-fill .item-checkbox input:checked ~ .item-inner,
.radio-list.radio-fill .item-radio input:checked ~ .item-inner {
    background-color: var(--f7-theme-color) !important;
    color: #FFFFFF !important;
}

.checkbox-list.checkbox-fill .item-checkbox input:checked ~ .item-inner .icon-checkbox {
    --f7-checkbox-active-color: #FFFFFF;
    --f7-checkbox-icon-color: var(--f7-theme-color);
}

.radio-list.radio-fill .item-radio input:checked ~ .item-inner .icon-radio {
    --f7-radio-active-color: #FFFFFF;
}

.aurora .radio-list.radio-fill .item-radio input:checked ~ .item-inner .icon-radio:after {
    background-color: var(--f7-theme-color);
}

.checkbox-list.checkbox-outline .item-checkbox input ~ .item-inner,
.radio-list.radio-outline .item-radio input ~ .item-inner {
    border: 2px solid rgba(var(--f7-color-gray-rgb), 0.25);
}

.checkbox-list.checkbox-outline .item-checkbox input:checked ~ .item-inner,
.radio-list.radio-outline .item-radio input:checked ~ .item-inner {
    border-color: var(--f7-theme-color) !important;
}

.checkbox-media,
.radio-media {
    display: inline-block;
    font-size: 14px;
    position: relative;
    text-align: center;
    --f7-checkbox-radio-media-border-color: var(--f7-color-gray);
    --f7-checkbox-radio-media-icon-color: var(--f7-color-gray);
    --f7-checkbox-radio-media-text-color: var(--f7-color-gray);
}

.checkbox-media input,
.radio-media input {
    display: none;
}

.checkbox-media .checkbox-inner,
.radio-media .radio-inner {
    align-items: center;
    border-color: var(--f7-checkbox-radio-media-border-color);
    border-style: solid;
    border-width: 4px;
    box-sizing: border-box;
    color: var(--f7-checkbox-radio-media-text-color);
    display: flex;
    filter: grayscale(1);
    flex-direction: column;
    justify-content: center;
    position: relative;
    text-align: center;
}

.checkbox-media .checkbox-inner:after,
.radio-media .radio-inner:after {
    align-items: center;
    background-color: var(--f7-checkbox-radio-media-icon-color);
    border-radius: 50%;
    color: #FFFFFF;
    content: 'checkbox_md';
    display: flex;
    font-family: framework7-core-icons;
    font-size: 10px;
    height: 16px;
    justify-content: center;
    left: auto;
    opacity: 0;
    position: absolute;
    right: 6px;
    top: 6px;
    width: 16px;
}

[dir=rtl] .checkbox-media .checkbox-inner:after,
[dir=rtl] .radio-media .radio-inner:after {
    left: 6px;
    right: auto;
}

.checkbox-media .checkbox-inner img,
.radio-media .radio-inner img {
    border-radius: inherit;
}

.checkbox-media .checkbox-label,
.radio-media .radio-label {
    color: var(--f7-checkbox-radio-media-text-color);
    margin-top: 2px;
}

.checkbox-media input:checked ~ .checkbox-inner,
.radio-media input:checked ~ .radio-inner {
    --f7-checkbox-radio-media-border-color: var(--f7-theme-color);
    --f7-checkbox-radio-media-text-color: var(--f7-theme-color);
    filter: grayscale(0);
}

.checkbox-media input:checked ~ .checkbox-inner:after,
.radio-media input:checked ~ .radio-inner:after {
    --f7-checkbox-radio-media-icon-color: var(--f7-theme-color);
    opacity: 1;
}

.checkbox-media input:checked ~ .checkbox-label,
.radio-media input:checked ~ .radio-label {
    --f7-checkbox-radio-media-text-color: var(--f7-theme-color);
}

.checkbox-media.no-outline .checkbox-inner,
.radio-media.no-outline .radio-inner {
    border-width: 0;
}

.checkbox-media.no-tick .checkbox-inner:after,
.radio-media.no-tick .radio-inner:after {
    display: none;
}

.checkbox-media.no-grayscale input ~ .checkbox-inner,
.radio-media.no-grayscale input ~ .radio-inner {
    filter: grayscale(0);
}

/*
|------------------------------------------------------------------------------
| Chip
|------------------------------------------------------------------------------
*/

:root {
    --f7-chip-delete-button-color: inherit;
}

:root .dark, :root.dark {
    --f7-chip-delete-button-color: inherit;
}

.aurora, .ios, .md {
    --f7-chip-height: 28px;
    --f7-chip-padding-horizontal: 12px;
}

.chip {
    margin: 3px;
    max-width: 100%;
    overflow: hidden;
    --f7-touch-ripple-color: rgba(var(--f7-color-gray-rgb), 0.25);
}

.chip[class*='color-'] {
    --f7-touch-ripple-color: rgba(var(--f7-theme-color-rgb), 0.25);
}

.chip-fade[class*='color-'] {
    background-color: rgba(var(--f7-theme-color-rgb), 0.15);
    color: var(--f7-theme-color);
}

.chip-media {
    background-color: rgba(0, 0, 0, 0.125);
    color: var(--color-gray-700);
    font-weight: 600;
}

.chip[class*='color-'] .chip-media {
    color: #FFFFFF;
}

.chip-outline .chip-media {
    background-color: transparent;
    border: 1px solid var(--f7-chip-outline-border-color);
}

.chip-outline[class*='color-'] .chip-media {
    color: var(--f7-theme-color);
}

.chip-fade[class*='color-'] .chip-media {
    background-color: inherit;
    color: var(--f7-theme-color);
}

.chip-media i.icon {
    font-size: calc(var(--f7-chip-height) - 12px);
    height: calc(var(--f7-chip-height) - 12px);
}

.chip-selectable {
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-flex;
    max-width: 100%;
}

.chip-selectable .chip {
    --f7-chip-bg-color: rgba(0, 0, 0, 0.12);
    --f7-chip-outline-border-color: rgba(0, 0, 0, 0.125);
}

.dark .chip-selectable .chip {
    --f7-chip-bg-color: #333333;
    --f7-chip-outline-border-color: rgba(255, 255, 255, 0.125);
}

.aurora .chip-selectable .chip, .ios .chip-selectable .chip {
    --f7-chip-text-color: #000000;
}

.aurora .dark .chip-selectable .chip, .aurora.dark .chip-selectable .chip,
.ios .dark .chip-selectable .chip, .ios.dark .chip-selectable .chip {
    --f7-chip-text-color: #FFFFFF;
}

.md .chip-selectable .chip {
    --f7-chip-text-color: rgba(0, 0, 0, 0.87);
}

.md .dark .chip-selectable .chip, .md.dark .chip-selectable .chip {
    --f7-chip-text-color: rgba(255, 255, 255, 0.87);
}

.chip-selectable .chip .chip-media {
    color: var(--f7-chip-text-color);
}

.chip-selectable input {
    display: none;
}

.chip-selectable input:checked ~ .chip {
    --f7-chip-bg-color: var(--f7-theme-color);
    --f7-chip-text-color: #FFFFFF;
    --f7-chip-outline-border-color: var(--f7-theme-color);
}

.chip-selectable.selectable-fade input:checked ~ .chip {
    --f7-chip-bg-color: rgba(var(--f7-theme-color-rgb), 0.15);
    --f7-chip-text-color: var(--f7-theme-color);
    --f7-chip-outline-border-color: var(--f7-theme-color);
}

.chip-selectable.selectable-fade input:checked ~ .chip .chip-media {
    background-color: inherit;
}

.chip-selectable.selectable-fill input:checked ~ .chip {
    background-color: var(--f7-theme-color);
    --f7-chip-text-color: #FFFFFF;
    --f7-chip-outline-border-color: var(--f7-theme-color);
}

.chip-selectable.selectable-fill input:checked ~ .chip .chip-media {
    background-color: rgba(0, 0, 0, 0.25);
}

.chip-selectable input:checked ~ .chip-outline {
    --f7-chip-text-color: var(--f7-theme-color);
}

.chip-selectable.selectable-fade input:checked ~ .chip-outline {
    background-color: rgba(var(--f7-theme-color-rgb), 0.15);
}

.chip-selectable .chip-media img {
    filter: grayscale(1);
}

.chip-selectable input:checked ~ .chip .chip-media img {
    filter: grayscale(0);
}

.chip-delete {
    margin-top: 2px;
    opacity: 0.75;
}

.md .chip-delete {
    margin-right: calc(-1 * var(--f7-chip-padding-horizontal));
}

[dir=rtl].md .chip-delete {
    margin-left: calc(-1 * var(--f7-chip-padding-horizontal));
}

.aurora .chip-delete:after, .ios .chip-delete:after, .md .chip-delete:after {
    font-size: 10px;
}

/*
|------------------------------------------------------------------------------
| Color Picker
|------------------------------------------------------------------------------
*/

.color-picker-page .color-picker-module,
.color-picker-popup .color-picker-module,
.color-picker-sheet-modal .color-picker-module {
    padding-left: var(--f7-safe-area-left);
    padding-right: var(--f7-safe-area-right);
}

/*
|------------------------------------------------------------------------------
| Content Block
|------------------------------------------------------------------------------
*/

:root {
    --f7-block-header-font-size: 15px;
    --f7-block-footer-font-size: 15px;
}

.aurora, .ios, .md {
    --f7-block-title-font-size: 18px;
    --f7-block-title-font-weight: bold;
    --f7-block-title-line-height: 1.5;
    --f7-block-margin-vertical: 32px;
    --f7-block-title-margin-bottom: 10px;
    --f7-block-title-text-color: #000000;
    --f7-block-title-white-space: normal;
    --f7-block-title-medium-font-size: 22px;
    --f7-block-title-medium-font-weight: bold;
    --f7-block-title-medium-line-height: 1.4;
    --f7-block-title-large-font-size: 30px;
    --f7-block-title-large-font-weight: bold;
    --f7-block-title-large-line-height: 1.4;
}

.block-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: unset;
}

/*
|------------------------------------------------------------------------------
| Data Table
|------------------------------------------------------------------------------
*/

:root {
    --f7-table-card-header-height: var(--f7-table-body-cell-height);
}

.aurora, .ios, .md {
    --f7-table-head-bg-color: #F6F6F7;
    --f7-table-head-font-size: 13px;
    --f7-table-card-header-bg-color: #F6F6F7;
    --f7-table-title-font-size: 18px;
    --f7-table-title-font-weight: bold;
    --f7-table-cell-padding-horizontal: 16px;
    --f7-table-edge-cell-padding-horizontal: 16px;
    --f7-table-label-cell-padding-horizontal: 16px;
}

.aurora .dark, .aurora.dark,
.ios .dark, .ios.dark,
.md .dark, .md.dark {
    --f7-table-head-bg-color: var(--color-gray-900);
    --f7-table-card-header-bg-color: var(--color-gray-900);
}

.data-table tbody th {
    background-color: var(--f7-table-head-bg-color);
    font-size: var(--f7-table-head-font-size);
    font-weight: var(--f7-table-head-font-weight);
    height: var(--f7-table-head-cell-height);
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

[dir=rtl] .data-table .data-table-footer {
    justify-content: flex-end;
}

@media (max-width: 480px) and (orientation: portrait) {
    .data-table.data-table-collapsible tr:first-child:before {
        display: none;
    }
}

.data-table-fixed-header thead th, .data-table-fixed-first-column thead th {
    position: sticky;
    top: 0;
    z-index: 100;
}

.data-table-fixed-first-column thead th:first-child {
    z-index: 110;
}

.data-table-fixed-first-column tbody th {
    z-index: 100;
}

.data-table-fixed-first-column tbody th {
    color: var(--f7-table-head-text-color);
}

.data-table-fixed-first-column tbody th, .data-table-fixed-first-column thead th:first-child {
    height: var(--f7-table-body-cell-height);
    left: 0;
    position: sticky;
    right: auto;
}

[dir=rtl]:not(.ios) .data-table-fixed-first-column tbody th, [dir=rtl]:not(.ios) .data-table-fixed-first-column thead th:first-child {
    left: auto;
    position: sticky;
    right: 0;
}

/*
|------------------------------------------------------------------------------
| Date-Time Picker
|------------------------------------------------------------------------------
*/

[dir=rtl] .calendar-day-selected-left:before, [dir=rtl] .calendar-day-selected-range:first-child:before {
    border-radius: 0 var(--f7-calendar-day-size) var(--f7-calendar-day-size) 0;
    left: 0;
    right: auto;
}

[dir=rtl] .calendar-day-selected-right:before, [dir=rtl] .calendar-day-selected-range:last-child:before {
    border-radius: var(--f7-calendar-day-size) 0 0 var(--f7-calendar-day-size);
    left: auto;
    right: 0;
}

.calendar {
    --f7-bars-bg-color: transparent;
}

.aurora .calendar, .ios .calendar, .md .calendar {
    --f7-toolbar-font-size: 16px;
}

.calendar-inline .toolbar-top {
    top: 0;
}

.calendar .toolbar-top:after {
    display: none;
}

.calendar-footer:before {
    display: none;
}

.calendar-year-picker {
    overflow: unset;
}

/*
|------------------------------------------------------------------------------
| Dialog
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-dialog-font-size: 14px;
    --f7-dialog-inner-padding: 16px;
    --f7-dialog-title-font-size: 18px;
    --f7-dialog-title-font-weight: 600;
    --f7-dialog-title-line-height: inherit;
    --f7-dialog-input-font-size: var(--f7-input-font-size);
}

.md {
    --f7-dialog-text-color: rgba(0, 0, 0, 0.87);
}

.dialog-inner {
    max-height: 75vh;
    overflow-y: auto;
}

.ios .dialog-inner:after {
    content: none;
}

.aurora .dialog-title + .dialog-text, .ios .dialog-title + .dialog-text, .md .dialog-title + .dialog-text {
    margin-top: 12px;
}

.aurora .dialog-buttons {
    padding: 12px var(--f7-dialog-inner-padding);
}

.ios .dialog-buttons:before {
    background-color: var(--f7-dialog-border-divider-color);
    bottom: auto;
    content: '';
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    right: auto;
    top: 0;
    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
    transform-origin: 50% 100%;
    width: 100%;
    z-index: 15;
}

.md .dialog-buttons-vertical .dialog-button + .dialog-button {
    margin-left: 0;
    margin-right: 0;
}

.md .dialog-button {
    min-width: auto;
}

.dialog .list ul {
    --f7-list-bg-color: transparent;
}

/*
|------------------------------------------------------------------------------
| Dropcap
|------------------------------------------------------------------------------
*/

.dropcap:first-letter {
    color: var(--f7-text-color);
    float: left;
    font-family: 'Georgia', 'Times New Roman', serif;
    font-size: 5em;
    font-weight: bold;
    line-height: 0.83;
    margin-right: 0.125em;
    text-transform: uppercase;
}

.dropcap[class*='color-']:first-letter {
    color: var(--f7-theme-color);
}

.aurora .dropcap:first-letter, .md .dropcap:first-letter {
    margin-top: 0.05em;
}

.dropcap.dropcap-fill:first-letter {
    background-color: var(--f7-color-mono);
    color: var(--f7-color-mono-invert);
    font-size: 4.25em;
    padding: 0.22em;
}

.dropcap.dropcap-fill[class*='color-']:first-letter {
    background-color: var(--f7-theme-color);
    color: #FFFFFF;
}

.dropcap.dropcap-outline:first-letter {
    border: 2px solid var(--f7-text-color);
    border-radius: 4px;
    font-size: 4.25em;
    padding: 0.2em;
}

.dropcap.dropcap-outline[class*='color-']:first-letter {
    border-color: var(--f7-theme-color);
}

.dropcap.dropcap-fill:first-letter, .dropcap.dropcap-outline:first-letter {
    margin-top: 0.1em;
}

.ios .dropcap.dropcap-fill:first-letter, .ios .dropcap.dropcap-outline:first-letter {
    line-height: 0.75;
}

[dir=rtl] .dropcap:first-letter, [dir=rtl] .dropcap[class*='color-']:first-letter {
    background-color: unset;
    border: unset;
    border-radius: unset;
    color: unset;
    float: unset;
    font-family: unset;
    font-size: unset;
    font-weight: unset;
    line-height: unset;
    margin: unset;
    padding: unset;
    text-transform: unset;
}

/*
|------------------------------------------------------------------------------
| Elevation
|------------------------------------------------------------------------------
*/

[class*='elevation-'][class*='color-'] {
    --f7-elevation-0: 0px 0px 0px 0px rgba(var(--f7-theme-color-rgb), 0);
    --f7-elevation-1: 0px 2px 1px -1px rgba(var(--f7-theme-color-rgb), 0.2), 0px 1px 1px 0px rgba(var(--f7-theme-color-rgb), 0.14), 0px 1px 3px 0px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-2: 0px 3px 1px -2px rgba(var(--f7-theme-color-rgb), 0.2), 0px 2px 2px 0px rgba(var(--f7-theme-color-rgb), 0.14), 0px 1px 5px 0px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-3: 0px 3px 3px -2px rgba(var(--f7-theme-color-rgb), 0.2), 0px 3px 4px 0px rgba(var(--f7-theme-color-rgb), 0.14), 0px 1px 8px 0px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-4: 0px 2px 4px -1px rgba(var(--f7-theme-color-rgb), 0.2), 0px 4px 5px 0px rgba(var(--f7-theme-color-rgb), 0.14), 0px 1px 10px 0px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-5: 0px 3px 5px -1px rgba(var(--f7-theme-color-rgb), 0.2), 0px 5px 8px 0px rgba(var(--f7-theme-color-rgb), 0.14), 0px 1px 14px 0px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-6: 0px 3px 5px -1px rgba(var(--f7-theme-color-rgb), 0.2), 0px 6px 10px 0px rgba(var(--f7-theme-color-rgb), 0.14), 0px 1px 18px 0px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-7: 0px 4px 5px -2px rgba(var(--f7-theme-color-rgb), 0.2), 0px 7px 10px 1px rgba(var(--f7-theme-color-rgb), 0.14), 0px 2px 16px 1px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-8: 0px 5px 5px -3px rgba(var(--f7-theme-color-rgb), 0.2), 0px 8px 10px 1px rgba(var(--f7-theme-color-rgb), 0.14), 0px 3px 14px 2px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-9: 0px 5px 6px -3px rgba(var(--f7-theme-color-rgb), 0.2), 0px 9px 12px 1px rgba(var(--f7-theme-color-rgb), 0.14), 0px 3px 16px 2px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-10: 0px 6px 6px -3px rgba(var(--f7-theme-color-rgb), 0.2), 0px 10px 14px 1px rgba(var(--f7-theme-color-rgb), 0.14), 0px 4px 18px 3px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-11: 0px 6px 7px -4px rgba(var(--f7-theme-color-rgb), 0.2), 0px 11px 15px 1px rgba(var(--f7-theme-color-rgb), 0.14), 0px 4px 20px 3px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-12: 0px 7px 8px -4px rgba(var(--f7-theme-color-rgb), 0.2), 0px 12px 17px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 5px 22px 4px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-13: 0px 7px 8px -4px rgba(var(--f7-theme-color-rgb), 0.2), 0px 13px 19px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 5px 24px 4px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-14: 0px 7px 9px -4px rgba(var(--f7-theme-color-rgb), 0.2), 0px 14px 21px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 5px 26px 4px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-15: 0px 8px 9px -5px rgba(var(--f7-theme-color-rgb), 0.2), 0px 15px 22px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 6px 28px 5px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-16: 0px 8px 10px -5px rgba(var(--f7-theme-color-rgb), 0.2), 0px 16px 24px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 6px 30px 5px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-17: 0px 8px 11px -5px rgba(var(--f7-theme-color-rgb), 0.2), 0px 17px 26px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 6px 32px 5px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-18: 0px 9px 11px -5px rgba(var(--f7-theme-color-rgb), 0.2), 0px 18px 28px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 7px 34px 6px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-19: 0px 9px 12px -6px rgba(var(--f7-theme-color-rgb), 0.2), 0px 19px 29px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 7px 36px 6px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-20: 0px 10px 13px -6px rgba(var(--f7-theme-color-rgb), 0.2), 0px 20px 31px 3px rgba(var(--f7-theme-color-rgb), 0.14), 0px 8px 38px 7px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-21: 0px 10px 13px -6px rgba(var(--f7-theme-color-rgb), 0.2), 0px 21px 33px 3px rgba(var(--f7-theme-color-rgb), 0.14), 0px 8px 40px 7px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-22: 0px 10px 14px -6px rgba(var(--f7-theme-color-rgb), 0.2), 0px 22px 35px 3px rgba(var(--f7-theme-color-rgb), 0.14), 0px 8px 42px 7px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-23: 0px 11px 14px -7px rgba(var(--f7-theme-color-rgb), 0.2), 0px 23px 36px 3px rgba(var(--f7-theme-color-rgb), 0.14), 0px 9px 44px 8px rgba(var(--f7-theme-color-rgb), 0.12);
    --f7-elevation-24: 0px 11px 15px -7px rgba(var(--f7-theme-color-rgb), 0.2), 0px 24px 38px 3px rgba(var(--f7-theme-color-rgb), 0.14), 0px 9px 46px 8px rgba(var(--f7-theme-color-rgb), 0.12);
}

.no-shadow {
    box-shadow: none !important;
}

/*
|------------------------------------------------------------------------------
| Empty State
|------------------------------------------------------------------------------
*/

.empty-state {
    align-items: center;
    box-sizing: border-box;
    color: inherit;
    display: flex;
    flex-direction: column;
    font-size: inherit;
    justify-content: center;
    margin: var(--f7-typography-margin) 0;
    padding-bottom: 0;
    padding-left: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-left));
    padding-right: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-right));
    padding-top: 0;
    position: relative;
    text-align: center;
    z-index: 1;
}

.empty-state-strong {
    background-color: var(--f7-block-strong-bg-color);
    color: var(--f7-block-strong-text-color);
    padding-bottom: var(--f7-block-padding-vertical);
    padding-top: var(--f7-block-padding-vertical);
}

.empty-state.inset {
    border-radius: var(--f7-block-inset-border-radius);
    margin-left: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-left));
    margin-right: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-right));
    --f7-safe-area-left: 0px;
    --f7-safe-area-right: 0px;
}

.page-content > .empty-state {
    padding-bottom: var(--f7-block-padding-vertical);
    padding-top: var(--f7-block-padding-vertical);
}

.page-content > .empty-state:not(.inset) {
    height: 100%;
    margin-bottom: 0;
    margin-top: 0;
}

.page-content > .empty-state.inset {
    min-height: calc(100% - var(--f7-typography-margin) * 2);
}

.empty-state > :first-child {
    margin-top: 0;
}

.empty-state > :last-child {
    margin-bottom: 0;
}

.empty-state-media {
    margin-top: calc(var(--f7-typography-margin) / 2);
}

.empty-state-title {
    font-size: 22px;
    font-weight: bold;
    line-height: 1.3;
    margin-top: calc(var(--f7-typography-margin) / 1);
}

.empty-state-subtitle {
    margin-top: calc(var(--f7-typography-margin) / 2);
}

.empty-state-text {
    color: var(--f7-block-header-text-color);
    margin-top: calc(var(--f7-typography-margin) / 2);
}

.empty-state-actions {
    display: flex;
    margin-top: calc(var(--f7-typography-margin) / 1);
}

.empty-state-actions.actions-vertical {
    flex-direction: column;
}

.empty-state-action {
    min-width: 144px;
    width: auto;
}

.empty-state-actions.actions-vertical .empty-state-action + .empty-state-action {
    margin-top: 8px;
}

.empty-state-actions:not(.actions-vertical) .empty-state-action + .empty-state-action {
    margin-left: 8px;
    margin-right: 0;
}

[dir=rtl] .empty-state-actions:not(.actions-vertical) .empty-state-action + .empty-state-action {
    margin-left: 0;
    margin-right: 8px;
}

/*
|------------------------------------------------------------------------------
| Expandable Card
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-card-expandable-border-radius: var(--f7-card-border-radius);
    --f7-card-expandable-box-shadow: none;
    --f7-card-expandable-margin-horizontal: var(--f7-card-margin-horizontal);
    --f7-card-expandable-margin-vertical: var(--f7-card-margin-vertical);
    --f7-card-expandable-tablet-border-radius: var(--f7-card-border-radius);
    --f7-card-expandable-tablet-height: 568px;
    --f7-card-expandable-tablet-width: 568px;
}

.card-expandable {
    height: 304px;
}

.card-expandable:not(.card-opened) {
    cursor: pointer;
}

.card-expandable .card-expandable-inner {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    height: 304px;
    justify-content: flex-start;
    min-height: 304px;
    position: relative;
}

.card-expandable.card-opened .card-expandable-inner {
    height: auto;
}

.card-expandable .card-close-link .icon {
    font-size: 32px;
}

/*
|------------------------------------------------------------------------------
| Flip Card
|------------------------------------------------------------------------------
*/

.flip-card {
    background: transparent;
    border-radius: var(--f7-card-border-radius);
    box-shadow: none;
    box-sizing: border-box;
    font-size: var(--f7-card-font-size);
    margin-bottom: var(--f7-card-margin-vertical);
    margin-left: calc(var(--f7-card-margin-horizontal) + var(--f7-safe-area-left));
    margin-right: calc(var(--f7-card-margin-horizontal) + var(--f7-safe-area-right));
    margin-top: var(--f7-card-margin-vertical);
    min-height: 256px;
    overflow: hidden;
    perspective: 1000px;
    position: relative;
}

.flip-card-inner {
    border-radius: inherit;
    height: 100%;
    position: absolute;
    transform-style: preserve-3d;
    transition: transform 0.75s;
    width: 100%;
}

.flip-card-flipped .flip-card-inner {
    transform: rotateY(-180deg);
}

[dir=rtl] .flip-card-flipped .flip-card-inner {
    transform: rotateY(180deg);
}

.flip-card-inner .flip-card-front, .flip-card-inner .flip-card-back {
    align-items: flex-start;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    background-color: var(--f7-card-bg-color);
    border-radius: inherit;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-start;
    overflow-y: auto;
    position: absolute;
    width: 100%;
}

.flip-card-inner .flip-card-back {
    transform: rotateY(180deg) translateZ(1px);
}

.flip-card-content {
    box-sizing: border-box;
    padding: var(--f7-card-content-padding-vertical) var(--f7-card-content-padding-horizontal);
    position: relative;
    z-index: 10;
}

/*
|------------------------------------------------------------------------------
| Floating Action Button
|------------------------------------------------------------------------------
*/

:root {
    --f7-fab-label-font-size: 14px;
}

.aurora, .ios, .md {
    --f7-fab-extended-text-font-weight: 600;
    --f7-fab-extended-text-letter-spacing: 0.05em;
}

.fab:not(.fa-brands) {
    font-family: var(--f7-font-family);
}

.fab-label-button > span:not(.fab-label) {
    overflow: hidden;
    white-space: nowrap;
}

.fab-label {
    max-width: 192px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.fab-center-top .fab-buttons-bottom .fab-label, .fab-center-top .fab-buttons-top .fab-label,
.fab-center-center .fab-buttons-bottom .fab-label, .fab-center-center .fab-buttons-top .fab-label,
.fab-center-bottom .fab-buttons-bottom .fab-label, .fab-center-bottom .fab-buttons-top .fab-label {
    left: 125%;
}

[dir=rtl] .fab-center-top .fab-buttons-bottom .fab-label, [dir=rtl] .fab-center-top .fab-buttons-top .fab-label,
[dir=rtl] .fab-center-center .fab-buttons-bottom .fab-label, [dir=rtl] .fab-center-center .fab-buttons-top .fab-label,
[dir=rtl] .fab-center-bottom .fab-buttons-bottom .fab-label, [dir=rtl] .fab-center-bottom .fab-buttons-top .fab-label {
    left: auto;
    right: 125%;
}

.fab-buttons-left a:nth-child(even) .fab-label, .fab-buttons-right a:nth-child(even) .fab-label,
.fab-buttons-left a:nth-child(even) .fab-label, .fab-buttons-right a:nth-child(even) .fab-label,
.fab-buttons-left a:nth-child(even) .fab-label, .fab-buttons-right a:nth-child(even) .fab-label {
    top: 150%;
}

.fab-buttons-left a:nth-child(odd) .fab-label, .fab-buttons-right a:nth-child(odd) .fab-label,
.fab-buttons-left a:nth-child(odd) .fab-label, .fab-buttons-right a:nth-child(odd) .fab-label,
.fab-buttons-left a:nth-child(odd) .fab-label, .fab-buttons-right a:nth-child(odd) .fab-label {
    top: -50%;
}

.fab-buttons-left .fab-label, .fab-buttons-right .fab-label {
    left: auto;
    margin-left: 0;
    margin-right: 0;
    right: auto;
}

.fab-center-center .fab-buttons-center a:nth-child(1) .fab-label {
    top: -50%;
}

.fab-center-center .fab-buttons-center a:nth-child(2) .fab-label {
    left: 125%;
}

.fab-center-center .fab-buttons-center a:nth-child(3) .fab-label {
    top: 150%;
}

.fab-center-center .fab-buttons-center a:nth-child(4) .fab-label {
    right: 125%;
}

/*
|------------------------------------------------------------------------------
| Form Input
|------------------------------------------------------------------------------
*/

:root {
    --f7-input-fill-bg-color: rgba(var(--f7-color-gray-rgb), 0.25);
}

.aurora, .ios, .md {
    --f7-input-font-size: 14px;
    --f7-inline-label-font-size: 14px;
    --f7-floating-label-scale: calc(14 / 12);
    --f7-textarea-padding-vertical: 8px;
}

.ios {
    --f7-label-focused-text-color: var(--f7-theme-color);
    --f7-label-invalid-text-color: var(--f7-input-error-text-color );
    --f7-input-focused-border-color: var(--f7-theme-color);
    --f7-input-invalid-border-color: var(--f7-input-error-text-color);
}

.aurora .item-input .item-media, .ios .item-input .item-media, .md .item-input .item-media {
    color: var(--f7-color-gray);
}

.ios .input-focused:not(.input-outline):after, .ios .input-invalid:not(.input-outline):after,
.ios .item-input-focused:not(.item-input-outline) .item-inner:after, .ios .item-input-invalid:not(.item-input-outline) .item-inner:after {
    transform: scaleY(2) !important;
}

.list .item-floating-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.item-input-wrap {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
}

.item-input-wrap > * + * {
    margin-left: 8px !important;
    margin-right: 0 !important;
}

[dir=rtl] .item-input-wrap > * + * {
    margin-left: 0 !important;
    margin-right: 8px !important;
}

.item-input-wrap input, .item-input-wrap select, .item-input-wrap textarea {
    flex-basis: 0;
    flex-grow: 1;
    flex-shrink: 1;
}

.item-input-wrap > textarea ~ * {
    align-self: flex-start;
    margin-top: 8px;
}

.item-input-wrap .input-clear-button {
    bottom: unset;
    left: unset;
    margin-top: unset;
    position: relative;
    right: unset;
    top: unset;
}

.item-input-wrap .input-clear-button .ripple-wave {
    position: absolute;
}

.item-input-wrap > textarea ~ .input-clear-button {
    margin-top: calc(var(--f7-textarea-padding-vertical) * 1.375);
}

.input-outline .item-input-wrap, .input-outline .item-input-wrap, .input-outline .item-input-wrap,
.item-input-outline .item-input-wrap, .item-input-outline .item-input-wrap, .item-input-outline .item-input-wrap,
.list .item-input-outline .item-input-wrap, .list .item-input-outline .item-input-wrap, .list .item-input-outline .item-input-wrap {
    padding-left: var(--f7-input-outline-padding-horizontal);
    padding-right: var(--f7-input-outline-padding-horizontal);
}

.item-input-outline.item-input-fill .item-input-wrap:after {
    background-color: var(--f7-input-fill-bg-color);
    border: none;
}

.item-input-outline.item-input-round .item-input-wrap:after {
    border-radius: var(--f7-input-height);
}

.input-outline input, .input-outline select, .input-outline textarea,
.item-input-outline input, .item-input-outline select, .item-input-outline textarea,
.list .item-input-outline input, .list .item-input-outline select, .list .item-input-outline textarea {
    --f7-input-outline-padding-horizontal: 0px;
}

.item-input-wrap .input-info, .item-input-wrap .item-input-info,
.item-input-wrap .input-error-message, .item-input-wrap .item-input-error-message {
    display: flex;
    flex-basis: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
    order: 99;
}

.item-input-outline .item-input-info,
.item-input-outline .item-input-error-message {
    left: unset;
    padding-left: 0;
    padding-right: 0;
    right: unset;
}

.aurora .input-outline .input-info, .aurora .input-outline .item-input-info,
.aurora .item-input-outline .input-info, .aurora .item-input-outline .item-input-info,
.ios .input-outline .input-info, .ios .input-outline .item-input-info,
.ios .item-input-outline .input-info, .ios .item-input-outline .item-input-info {
    margin-bottom: calc(-1.25 * var(--f7-input-info-font-size) * var(--f7-input-info-line-height));
}

.aurora .input-outline .input-error-message, .aurora .input-outline .item-input-error-message,
.aurora .item-input-outline .input-error-message, .aurora .item-input-outline .item-input-error-message,
.ios .input-outline .input-error-message, .ios .input-outline .item-input-error-message,
.ios .item-input-outline .input-error-message, .ios .item-input-outline .item-input-error-message {
    margin-bottom: calc(-1.25 * var(--f7-input-error-font-size) * var(--f7-input-error-line-height));
}

.aurora .input-outline .input-info, .aurora .input-outline .input-error-message,
.aurora .input-outline .item-input-info, .aurora .input-outline .item-input-error-message,
.aurora .item-input-outline .input-info, .aurora .item-input-outline .input-error-message,
.aurora .item-input-outline .item-input-info, .aurora .item-input-outline .item-input-error-message,
.ios .input-outline .input-info, .ios .input-outline .input-error-message,
.ios .input-outline .item-input-info, .ios .input-outline .item-input-error-message,
.ios .item-input-outline .input-info, .ios .item-input-outline .input-error-message,
.ios .item-input-outline .item-input-info, .ios .item-input-outline .item-input-error-message {
    white-space: nowrap;
}

.item-input-wrap :not(.input-invalid) ~ .input-error-message,
.item-input-wrap :not(.input-invalid) ~ .item-input-error-message {
    display: none;
}

.button-file {
    cursor: pointer;
    overflow: hidden;
    position: relative;
}

.button-file [type=file] {
    cursor: pointer;
    opacity: 0;
    position: absolute;
}

.button-file [type=file]:valid ~ .file-status-icon .status-invalid {
    display: none;
}

.button-file [type=file]:invalid ~ .file-status-icon .status-valid {
    display: none;
}

input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus,
textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus,
select:-webkit-autofill, select:-webkit-autofill:hover, select:-webkit-autofill:focus {
    -webkit-text-fill-color: var(--f7-input-text-color) !important;
    transition: background-color 5000s ease-in-out 0s !important;
}

/*
|------------------------------------------------------------------------------
| Form Validator
|------------------------------------------------------------------------------
*/

:root {
    --f7-input-error-text-color: var(--f7-color-red);
}

/*
|------------------------------------------------------------------------------
| Gauge
|------------------------------------------------------------------------------
*/

.gauge {
    position: relative;
}

/*
|------------------------------------------------------------------------------
| Grid
|------------------------------------------------------------------------------
*/

[dir=rtl] .col > .resize-handler, [dir=rtl] [class*=col-] > .resize-handler {
    left: auto;
    right: 100%;
}

@media (max-width: 479.98px) {
    .xsmall-show {
        display: none !important;
    }
}

@media (min-width: 480px) {
    .xsmall-hide {
        display: none !important;
    }
}

@media (max-width: 567.98px) {
    .small-show {
        display: none !important;
    }
}

@media (min-width: 568px) {
    .small-hide {
        display: none !important;
    }
}

@media (max-width: 767.98px) {
    .medium-show {
        display: none !important;
    }
}

@media (min-width: 768px) {
    .medium-hide {
        display: none !important;
    }
}

@media (max-width: 1023.98px) {
    .large-show {
        display: none !important;
    }
}

@media (min-width: 1024px) {
    .large-hide {
        display: none !important;
    }
}

@media (max-width: 1199.98px) {
    .xlarge-show {
        display: none !important;
    }
}

@media (min-width: 1200px) {
    .xlarge-hide {
        display: none !important;
    }
}

/*
|------------------------------------------------------------------------------
| Icon
|------------------------------------------------------------------------------
*/

.aurora .f7-icons, .ios .f7-icons, .md .f7-icons,
.aurora .material-icons, .ios .material-icons, .md .material-icons {
    font-size: 24px;
}

.fa-stack {
    width: 2em;
}

/*
|------------------------------------------------------------------------------
| Image
|------------------------------------------------------------------------------
*/

:root {
    --f7-avatar-group-avatar-size: 48px;
    --f7-avatar-group-space-multiplier: -2.5;
}

img {
    max-width: 100%;
    object-fit: cover;
    object-position: center;
    vertical-align: bottom;
}

.avatar {
    background-image: linear-gradient(to bottom right, var(--f7-theme-color-shade), var(--f7-theme-color), var(--f7-theme-color-tint));
    box-sizing: border-box;
    padding: 3.5px;
}

.avatar-group {
    align-items: center;
    display: flex;
    justify-content: flex-start;
}

.avatar-group .avatar, .avatar-group .avatar-count {
    align-items: center;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    height: var(--f7-avatar-group-avatar-size);
    justify-content: center;
    overflow: hidden;
    position: relative;
    text-align: center;
    width: var(--f7-avatar-group-avatar-size);
}

.avatar-group-hover .avatar:hover {
    z-index: 10;
}

.avatar-group .avatar img {
    border-radius: 50%;
}

.avatar-group .avatar-count {
    background-color: var(--color-gray-800);
    border-radius: var(--f7-avatar-group-avatar-size);
    color: #FFFFFF;
    font-size: 12px;
    font-weight: bold;
    min-width: var(--f7-avatar-group-avatar-size);
    padding: 0 8px;
    width: auto;
}

.avatar-group .avatar-count * {
    color: #FFFFFF;
}

.avatar-group .avatar:not(:first-child), .avatar-group .avatar-count:not(:first-child) {
    margin-left: calc(var(--f7-avatar-group-avatar-size) / var(--f7-avatar-group-space-multiplier));
    margin-right: 0;
}

[dir=rtl] .avatar-group .avatar:not(:first-child), [dir=rtl] .avatar-group .avatar-count:not(:first-child) {
    margin-left: 0;
    margin-right: calc(var(--f7-avatar-group-avatar-size) / var(--f7-avatar-group-space-multiplier));
}

.bg-cover {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
}

.no-object-fit {
    object-fit: unset;
}

/*
|------------------------------------------------------------------------------
| Image Compare
|------------------------------------------------------------------------------
*/

div.juxtapose {
    font-family: var(--f7-font-family);
    width: 100% !important;
}

div.juxtapose a.jx-knightlab {
    display: none;
}

div.juxtapose div.jx-credit {
    color: var(--f7-color-gray-shade);
    font-size: 10px;
    letter-spacing: 0.375px;
    line-height: inherit;
}

.dark div.juxtapose div.jx-credit {
    color: var(--f7-color-gray-tint);
}

div.juxtapose div.jx-credit em {
    color: var(--f7-text-color);
    font-weight: 600;
}

/*
|------------------------------------------------------------------------------
| Image Hotspot
|------------------------------------------------------------------------------
*/

.hotspots {
    display: inline-block;
    position: relative;
    vertical-align: bottom;
}

.hotspot-image {
    display: block;
    height: 100%;
    object-fit: scale-down;
    width: 100%;
}

.hotspot-point {
    -webkit-animation: hotspot 600ms linear infinite alternate;
    animation: hotspot 600ms linear infinite alternate;
    border-radius: 50%;
    box-shadow: inset 0 0 6px 4px rgba(var(--f7-theme-color-rgb), 0.6);
    height: 32px;
    position: absolute;
    width: 32px;
}

.hotspot-point:before {
    background-color: rgba(var(--f7-theme-color-rgb), 0.8);
    border: 2px solid var(--f7-theme-color);
    border-radius: 50%;
    content: '';
    display: block;
    height: 16px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 16px;
}

@-webkit-keyframes hotspot {
    from {
        box-shadow: inset 0 0 12px 6px rgba(var(--f7-theme-color-rgb), 0.6);
    }
    to {
        box-shadow: inset 0 0 4px 2px rgba(var(--f7-theme-color-rgb), 0.4);
    }
}

@keyframes hotspot {
    from {
        box-shadow: inset 0 0 12px 6px rgba(var(--f7-theme-color-rgb), 0.6);
    }
    to {
        box-shadow: inset 0 0 4px 2px rgba(var(--f7-theme-color-rgb), 0.4);
    }
}

/*
|------------------------------------------------------------------------------
| Infinite Scroll
|------------------------------------------------------------------------------
*/

.infinite-scroll-preloader.preloader {
    display: block;
}

/*
|------------------------------------------------------------------------------
| Integrations
|------------------------------------------------------------------------------
*/

.disqus-thread {
    background-color: #FFFFFF;
    border-radius: var(--f7-block-inset-border-radius);
    padding: calc(var(--f7-typography-padding) / 4) var(--f7-typography-padding);
}

.embedly-card {
    background-color: #FFFFFF;
    border-radius: var(--f7-block-inset-border-radius);
    padding: calc(var(--f7-typography-padding) / 4) var(--f7-typography-padding);
}

.fb-comments {
    background-color: #FFFFFF;
    border-radius: var(--f7-block-inset-border-radius);
    box-sizing: border-box;
    padding: calc(var(--f7-typography-padding) / 2);
}

iframe[id*='comments-app-'] {
    border-radius: var(--f7-block-inset-border-radius);
}

.pac-container {
    background-color: var(--f7-list-bg-color);
    border-radius: var(--f7-list-inset-border-radius);
    border-top: none;
    font-family: var(--f7-font-family);
    z-index: 9999;
}

.pac-item {
    border-top: none;
    color: var(--f7-list-item-text-text-color);
    cursor: pointer;
    font-size: 12px;
}

.pac-item:hover {
    background-color: var(--f7-list-link-pressed-bg-color);
}

.pac-item-query {
    color: var(--f7-text-color);
    font-size: 14px;
}

.pac-matched {
    font-weight: bold;
}

.pac-logo:after {
    margin: 4px 8px;
    padding: 0;
}

/*
|------------------------------------------------------------------------------
| Keypad
|------------------------------------------------------------------------------
*/

:root {
    --f7-keypad-inline-height: 210px;
    --f7-keypad-landscape-height: 260px;
    --f7-keypad-bg-color: #CED4DC;
    --f7-keypad-button-bg-color: #FFFFFF;
    --f7-keypad-button-pressed-bg-color: #ADBBCA;
    --f7-keypad-button-dark-bg-color: transparent;
    --f7-keypad-button-dark-pressed-bg-color: var(--f7-keypad-button-pressed-bg-color);
    --f7-keypad-button-number-font-size: 22px;
    --f7-keypad-button-letters-font-size: 10px;
    --f7-keypad-button-spacing: 4px;
}

:root .dark, :root.dark {
    --f7-keypad-bg-color: #292930;
    --f7-keypad-button-bg-color: #6A6E71;
    --f7-keypad-button-pressed-bg-color: #464646;
    --f7-keypad-button-text-color: #FFFFFF;
}

.keypad {
    background-color: var(--f7-keypad-bg-color);
}

.keypad-buttons {
    padding: var(--f7-keypad-button-spacing);
}

.keypad-button {
    border-radius: 6px;
    height: calc(25% - calc(var(--f7-keypad-button-spacing) * 2));
    margin: var(--f7-keypad-button-spacing);
    width: calc(calc(100% / 3) - calc(var(--f7-keypad-button-spacing) * 2));
}

.keypad-button:before, .keypad-button:after {
    content: none;
}

.keypad-button-letters {
    font-weight: 600;
    height: 16px;
    letter-spacing: 1px;
    line-height: 16px;
}

.dark i.icon-keypad-delete {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

[dir=rtl] i.icon-keypad-delete {
    transform: scaleX(-1);
}

.keypad-inline {
    --f7-keypad-bg-color: transparent;
}

.keypad-inline .keypad-buttons {
    height: calc(var(--f7-keypad-inline-height) - calc(var(--f7-keypad-button-spacing) * 2));
}

.keypad-popover .popover-angle.on-bottom:after {
    background: var(--f7-keypad-bg-color);
}

.keypad-popover .popover-angle.on-top:after {
    background: var(--f7-bars-bg-color);
}

.keypad-popover .toolbar {
    border-radius: var(--f7-popover-border-radius) var(--f7-popover-border-radius) 0 0;
}

.ios .keypad-popover .toolbar {
    background-color: var(--f7-bars-bg-color);
}

.keypad-popover .keypad {
    border-radius: var(--f7-popover-border-radius);
    overflow: hidden;
    position: relative;
}

@media (orientation: landscape) and (max-height: 415px) {
    .keypad-sheet {
        height: calc(var(--f7-safe-area-bottom) + var(--f7-keypad-landscape-height));
    }
}

.keypad-inline .toolbar ~ .keypad-buttons, .keypad-popover .keypad .toolbar ~ .keypad-buttons, .keypad-sheet .toolbar ~ .keypad-buttons {
    height: calc(100% - var(--f7-toolbar-height) - calc(var(--f7-keypad-button-spacing) * 2));
}

.keypad-inline .keypad-buttons, .keypad-sheet .keypad-buttons {
    padding-left: calc(var(--f7-keypad-button-spacing) + var(--f7-safe-area-left));
    padding-right: calc(var(--f7-keypad-button-spacing) + var(--f7-safe-area-right));
}

.keypad-type-custom .keypad-buttons {
    overflow-y: auto;
}

.keypad-type-calculator {
    --f7-keypad-button-dark-bg-color: var(--color-gray-300);
    --f7-keypad-button-dark-pressed-bg-color: var(--color-gray-400);
}

.keypad-type-calculator .keypad-button.keypad-button-dark {
    color: #000000;
}

.keypad-type-calculator .keypad-button {
    height: calc(20% - calc(var(--f7-keypad-button-spacing) * 2));
    width: calc(calc(100% / 4) - calc(var(--f7-keypad-button-spacing) * 2));
}

.keypad-type-calculator .keypad-button.keypad-button-double {
    width: calc(50% - calc(var(--f7-keypad-button-spacing) * 2));
}

.keypad-button.calc-operator-button.calc-operator-active {
    background-color: #FFFFFF;
    border: none;
    color: var(--f7-keypad-calc-button-bg-color);
}

/*
|------------------------------------------------------------------------------
| Line Divider
|------------------------------------------------------------------------------
*/

.line-divider {
    align-items: center;
    border: none;
    color: var(--f7-color-gray);
    display: flex;
    flex-direction: row;
    font-size: 14px;
    justify-content: center;
    text-align: center;
}

.line-divider[class*='color-'] {
    color: var(--f7-theme-color);
}

.line-divider:before, .line-divider:after {
    border-top-color: var(--f7-list-border-color);
    border-top-style: solid;
    border-top-width: 1px;
    content: '';
    flex-grow: 1;
    margin: 0.75em 0;
    position: relative;
}

.line-divider.line-dashed:before, .line-divider.line-dashed:after {
    border-top-style: dashed;
}

.line-divider.line-dotted:before, .line-divider.line-dotted:after {
    border-top-style: dotted;
}

.line-divider[class*='color-']:before, .line-divider[class*='color-']:after {
    border-top-color: var(--f7-theme-color);
}

.line-divider > * {
    margin: 0 var(--f7-typography-margin);
}

/*
|------------------------------------------------------------------------------
| Link
|------------------------------------------------------------------------------
*/

.link-button {
    border-radius: var(--f7-button-border-radius);
    overflow: hidden;
    padding: 0 4px;
}

.cursor-default {
    cursor: default;
}

.cursor-pointer {
    cursor: pointer;
}

/*
|------------------------------------------------------------------------------
| List Index
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-list-index-font-size: 11px;
    --f7-list-index-skip-dot-size: 4px;
}

[dir=rtl] .list-index:before {
    left: 100%;
    right: auto;
}

[dir=rtl] .list-index .list-index-label {
    left: 100%;
    right: auto;
}

[dir=rtl].aurora .list-index .list-index-label {
    margin-left: calc(var(--f7-list-index-width) - 4px);
    margin-right: 0;
}

[dir=rtl].ios .list-index .list-index-label {
    margin-left: calc(var(--f7-list-index-width) - 2px);
    margin-right: 0;
}

[dir=rtl].md .list-index .list-index-label {
    border-radius: 50% 50% 50% 0;
}

[dir=rtl].aurora .list-index .list-index-label:before {
    border-radius: 50% 50% 50% 1px;
}

[dir=rtl].ios .list-index .list-index-label:before {
    border-radius: 50% 50% 50% 0;
}

/*
|------------------------------------------------------------------------------
| List View
|------------------------------------------------------------------------------
*/

:root {
    --f7-list-item-title-white-space: normal;
    --f7-list-item-text-max-lines: unset;
}

.aurora, .ios, .md {
    --f7-list-font-size: var(--f7-font-size);
    --f7-list-item-after-font-size: 14px;
    --f7-list-item-subtitle-font-size: 14px;
    --f7-list-item-text-font-size: 14px;
    --f7-list-media-item-padding-vertical: 16px;
    --f7-list-media-item-title-font-weight: 600;
    --f7-list-group-title-font-size: inherit;
    --f7-list-group-title-font-weight: normal;
    --f7-list-group-title-height: var(--f7-list-item-min-height);
    --f7-list-item-divider-border-color: transparent;
    --f7-list-item-divider-font-size: inherit;
    --f7-list-item-divider-font-weight: normal;
    --f7-list-item-divider-height: var(--f7-list-item-min-height);
    --f7-list-item-header-text-color: var(--f7-block-header-text-color);
    --f7-list-item-footer-text-color: var(--f7-block-footer-text-color);
}

.aurora, .ios, .md {
    --f7-list-item-border-color: rgba(0, 0, 0, 0.12);
}

.aurora .dark, .aurora.dark, .ios .dark, .ios.dark, .md .dark, .md.dark {
    --f7-list-item-border-color: rgba(255, 255, 255, 0.12);
    --f7-list-item-divider-border-color: transparent;
    --f7-list-item-header-text-color: var(--f7-block-header-text-color);
    --f7-list-item-footer-text-color: var(--f7-block-footer-text-color);
}

ul {
    padding-inline-start: 32px;
}

.list .item-after {
    flex-shrink: 1;
    text-align: right;
    white-space: normal;
}

[dir=rtl] .list .item-after {
    text-align: left;
}

.list .item-subtitle {
    white-space: normal;
}

.aurora .list .item-media, .ios .list .item-media, .md .list .item-media {
    justify-content: center;
    min-width: 24px;
}

.list.inset .item-divider:first-child {
    border-radius: var(--f7-list-inset-border-radius) var(--f7-list-inset-border-radius) 0 0;
}

.list.inset .item-divider:last-child {
    border-radius: 0 0 var(--f7-list-inset-border-radius) var(--f7-list-inset-border-radius);
}

.list.inset .list-group ul {
    border-radius: 0;
}

.list.inset .list-group:first-child ul {
    border-radius: var(--f7-list-inset-border-radius) var(--f7-list-inset-border-radius) 0 0;
}

.list.inset .list-group:last-child ul {
    border-radius: 0 0 var(--f7-list-inset-border-radius) var(--f7-list-inset-border-radius);
}

.list.inset .list-group:first-child .list-group-title:first-child {
    border-radius: var(--f7-list-inset-border-radius) var(--f7-list-inset-border-radius) 0 0;
}

.simple-list li {
    height: auto;
    line-height: inherit;
    padding-bottom: 8px;
    padding-top: 8px;
    white-space: normal;
}

.cards-list li {
    background-color: var(--f7-list-bg-color);
    border-radius: inherit;
    margin: calc(var(--f7-typography-margin) / 2) 0;
}

.cards-list li:first-child {
    margin-top: 0;
}

.cards-list li:last-child {
    margin-bottom: 0;
}

.cards-list.inset li {
    border-radius: var(--f7-list-inset-border-radius);
}

.cards-list > ul.row > li {
    margin: calc(var(--f7-typography-margin) / 2) 0;
}

.cards-list .item-link.active-state {
    border-radius: inherit !important;
}

.aurora.device-desktop .links-list a:hover:not(.active-state):not(.no-hover), .aurora.device-desktop .list .item-link:not(.item-selected):hover:not(.active-state):not(.no-hover) {
    border-radius: inherit;
}

.cards-list .item-inner:after {
    display: none !important;
}

/*
|------------------------------------------------------------------------------
| Margin & Padding
|------------------------------------------------------------------------------
*/

.margin-bottom-auto {
    margin-bottom: auto !important;
}

.margin-left-auto {
    margin-left: auto !important;
}

.margin-right-auto {
    margin-right: auto !important;
}

.margin-top-auto {
    margin-top: auto !important;
}

.margin-horizontal-auto {
    margin-left: auto !important;
    margin-right: auto !important;
}

@media (min-width: 768px) {
    .medium-margin-vertical {
        margin-top: var(--f7-typography-margin) !important;
        margin-bottom: var(--f7-typography-margin) !important;
    }
    .medium-margin-top {
        margin-top: var(--f7-typography-margin) !important;
    }
    .medium-margin-bottom {
        margin-bottom: var(--f7-typography-margin) !important;
    }
    .medium-no-margin-vertical {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }
    .medium-no-margin-top {
        margin-top: 0 !important;
    }
    .medium-no-margin-bottom {
        margin-bottom: 0 !important;
    }
}

@media (min-width: 768px) {
    .medium-padding-vertical {
        padding-top: var(--f7-typography-padding) !important;
        padding-bottom: var(--f7-typography-padding) !important;
    }
    .medium-no-padding-horizontal {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
}

/*
|------------------------------------------------------------------------------
| Marquee
|------------------------------------------------------------------------------
*/

.marquee {
    overflow: hidden;
}

[dir=rtl] .marquee[data-direction=left] .js-marquee, [dir=rtl] .marquee[data-direction=right] .js-marquee {
    float: right !important;
    margin-left: 0 !important;
    margin-right: unset !important;
}

/*
|------------------------------------------------------------------------------
| Menu
|------------------------------------------------------------------------------
*/

:root .dark, :root.dark {
    --f7-menu-bg-color: rgba(255, 255, 255, 0.9);
    --f7-menu-text-color: #000000;
    --f7-menu-dropdown-divider-color: rgba(0, 0, 0, 0.2);
    --f7-menu-item-dropdown-icon-color: rgba(0, 0, 0, 0.4);
}

.menu-inner:after {
    width: 0;
}

.menu[class*='color-'], .menu-item[class*='color-'] {
    --f7-menu-bg-color: rgba(var(--f7-theme-color-rgb), 0.9);
    --f7-menu-text-color: #FFFFFF;
    --f7-menu-dropdown-divider-color: rgba(255, 255, 255, 0.2);
    --f7-menu-item-dropdown-icon-color: rgba(255, 255, 255, 0.4);
}

.dark .menu-item.active-state:not(.menu-item-dropdown-opened), .dark.menu-item.active-state:not(.menu-item-dropdown-opened) {
    background-color: rgba(255, 255, 255, 0.7);
}

.menu[class*='color-'] .menu-item.active-state:not(.menu-item-dropdown-opened), .menu-item[class*='color-'].active-state:not(.menu-item-dropdown-opened) {
    background-color: rgba(var(--f7-theme-color-rgb), 0.7);
}

.menu-dropdown-link:before {
    background: rgba(0, 0, 0, 0.8);
}

.dark .menu-dropdown-link:before {
    background: rgba(255, 255, 255, 0.8);
}

.menu[class*='color-'] .menu-dropdown-link:before, .menu-item[class*='color-'] .menu-dropdown-link:before {
    background: rgba(var(--f7-theme-color-rgb), 0.8);
}

[dir=rtl] .menu-dropdown-left:after, [dir=rtl] .menu-item-dropdown-left .menu-dropdown:after {
    background-image: radial-gradient(ellipse at 0% 0%,transparent 0%,transparent 70%,var(--f7-menu-bg-color) 72%);
    left: 0;
    right: 100%;
}

[dir=rtl] .menu-dropdown-right:before, [dir=rtl] .menu-item-dropdown-right .menu-dropdown:before {
    background-image: radial-gradient(ellipse at 100% 0%, transparent 0%, transparent 70%, var(--f7-menu-bg-color) 72%);
    left: 100%;
    right: 0;
}

[dir=rtl] .menu-dropdown-left .menu-dropdown-content, [dir=rtl] .menu-item-dropdown-left .menu-dropdown-content {
    border-top-left-radius: var(--f7-menu-item-border-radius);
    border-top-right-radius: 0;
    left: auto;
    right: 0;
}

[dir=rtl] .menu-dropdown-right .menu-dropdown-content, [dir=rtl] .menu-item-dropdown-right .menu-dropdown-content {
    border-top-left-radius: 0;
    border-top-right-radius: var(--f7-menu-item-border-radius);
    left: 0;
    right: auto;
}

.menu-dropdown-content {
    max-height: 256px;
    max-width: 144px;
}

.menu-overlay {
    bottom: var(--f7-typography-margin);
    position: absolute;
    right: var(--f7-typography-margin);
}

[dir=rtl] .menu-overlay {
    left: var(--f7-typography-margin);
    right: auto;
}

.menu-overlay .menu-inner {
    padding: 0;
}

/*
|------------------------------------------------------------------------------
| Menu List
|------------------------------------------------------------------------------
*/

.menu-list[class*='color-'] .item-selected .item-link,
.menu-list[class*='color-'] .item-selected.item-link,
.menu-list[class*='color-'] .tab-link-active .item-link,
.menu-list[class*='color-'] .tab-link-active.item-link {
    --f7-menu-list-selected-text-color: var(--f7-theme-color);
    --f7-menu-list-selected-bg-color: rgba(var(--f7-theme-color-rgb), 0.15);
}

.menu-list .item-selected .item-link[class*='color-'],
.menu-list .item-selected.item-link[class*='color-'],
.menu-list .tab-link-active .item-link[class*='color-'],
.menu-list .tab-link-active.item-link[class*='color-'] {
    --f7-menu-list-selected-text-color: var(--f7-theme-color);
    --f7-menu-list-selected-bg-color: rgba(var(--f7-theme-color-rgb), 0.15);
}

.item-selected .icons .icon + .icon-active, .item-selected .icons .icon-active + .icon {
    margin: 0;
}

.menu-list .item-link:not(.item-selected):not(.tab-link-active) .icons .icon-active {
    display: none;
}

.menu-list .item-selected .icons .icon:not(.icon-active), .menu-list .tab-link-active .icons .icon:not(.icon-active) {
    display: none;
}

/*
|------------------------------------------------------------------------------
| Message
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-message-bubble-font-size: 14px;
    --f7-message-name-font-size: 12px;
    --f7-messagebar-textarea-font-size: 14px;
    --f7-messagebar-textarea-line-height: 20px;
}

.aurora, .ios {
    --f7-message-bubble-border-radius: 12px;
}

.aurora .message-text-footer, .ios .message-text-footer, .md .message-text-footer {
    margin-top: 4px;
}

.messagebar a.link {
    align-self: center;
}

/*
|------------------------------------------------------------------------------
| Navbar
|------------------------------------------------------------------------------
*/

:root {
    --f7-navbar-title-line-height: normal;
}

.aurora, .ios, .md {
    --f7-navbar-font-size: 20px;
    --f7-navbar-title-font-weight: bold;
    --f7-navbar-title-text-align: center;
    --f7-navbar-subtitle-line-height: 1.3;
    --f7-navbar-large-title-font-size: 30px;
    --f7-navbar-large-title-font-weight: bold;
    --f7-navbar-large-title-letter-spacing: 0px;
}

.ios {
    --f7-navbar-height: 52px;
    --f7-navbar-tablet-height: 52px;
    --f7-navbar-inner-padding-left: 16px;
    --f7-navbar-inner-padding-right: 16px;
    --f7-navbar-subtitle-font-size: 12px;
}

.aurora .navbar .title img, .aurora .navbar .title svg {
    height: calc(var(--f7-navbar-tablet-height) - 32px);
}

.ios .navbar .title img, .ios .navbar .title svg {
    height: calc(var(--f7-navbar-tablet-height) - 24px);
}

.md .navbar .title img, .md .navbar .title svg {
    height: calc(var(--f7-navbar-tablet-height) - 40px);
}

.aurora .navbar a.icon-only, .ios .navbar a.icon-only {
    width: 32px;
}

.navbars, .navbar {
    z-index: 1500;
}

.tabs-routable .navbars .navbar:first-of-type .link.back,
.tabs-routable .page:first-of-type .navbar .link.back {
    display: none;
}

.views .navbars .navbar:first-of-type .link.back,
.views .page:first-of-type .navbar .link.back {
    display: none;
}

/*
|------------------------------------------------------------------------------
| Note
|------------------------------------------------------------------------------
*/

.note {
    align-items: flex-start;
    background-color: var(--f7-block-strong-bg-color);
    box-sizing: border-box;
    color: var(--f7-text-color);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: calc(var(--f7-block-margin-vertical) / 2) 0;
    padding-bottom: calc(var(--f7-block-padding-vertical) / 1.5);
    padding-left: calc(var(--f7-block-padding-horizontal) / 1.5 + var(--f7-safe-area-left));
    padding-right: calc(var(--f7-block-padding-horizontal) / 1.5 + var(--f7-safe-area-right));
    padding-top: calc(var(--f7-block-padding-vertical) / 1.5);
}

.block-strong .note {
    border: 2px solid var(--f7-color-mono);
    border-radius: var(--f7-block-inset-border-radius);
}

.block-strong .note[class*='color-'] {
    border-color: var(--f7-theme-color);
}

.note.inset {
    border-radius: var(--f7-block-inset-border-radius);
    margin-left: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-left));
    margin-right: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-right));
    --f7-safe-area-left: 0px;
    --f7-safe-area-right: 0px;
}

.note-fade[class*='color-'] {
    background-color: rgba(var(--f7-theme-color-rgb), 0.15);
}

.note-fill[class*='color-'] {
    background-color: var(--f7-theme-color);
}

.note-outline {
    border: 2px solid var(--f7-color-mono);
}

.note-outline[class*='color-'] {
    border-color: var(--f7-theme-color);
}

.note > * + * {
    margin-left: 8px;
    margin-right: 0;
}

[dir=rtl] .note > * + * {
    margin-left: 0;
    margin-right: 8px;
}

.note > .note-media i, .note > .note-media .icon {
    font-size: 40px;
}

.note[class*='color-'] > .note-media i, .note[class*='color-'] > .note-media .icon {
    color: var(--f7-theme-color);
}

.note-fill[class*='color-'] > .note-media i, .note-fill[class*='color-'] > .note-media .icon {
    color: #FFFFFF;
}

.note-media img, .note-media > svg {
    height: auto;
    width: 40px;
}

.note-content {
    flex: 1;
    font-size: 16px;
    width: 100%;
}

.note[class*='color-'] .note-content {
    color: var(--f7-theme-color);
}

.note-fill[class*='color-'] .note-content {
    color: #FFFFFF;
}

.note-title {
    font-size: 16px;
    font-weight: 600;
}

.note[class*='color-'] .note-title {
    color: var(--f7-theme-color);
}

.note-fill[class*='color-'] .note-title {
    color: #FFFFFF;
}

.note-title + .note-message {
    color: var(--f7-block-header-text-color);
    font-size: 14px;
}

.note[class*='color-'] .note-title + .note-message {
    color: rgba(var(--f7-theme-color-rgb), 0.75);
}

.note-fill[class*='color-'] .note-title + .note-message {
    color: rgba(255, 255, 255, 0.75);
}

.note-actions {
    align-self: center;
    display: flex;
}

.note-content .note-actions {
    margin-top: 8px;
}

.note-action + .note-action {
    margin-left: 8px;
    margin-right: 0;
}

[dir=rtl] .note-action + .note-action {
    margin-left: 0;
    margin-right: 8px;
}

.note-close {
    color: var(--f7-color-mono);
    height: 18px;
    line-height: 1;
    --f7-touch-ripple-color: rgba(var(--f7-color-black-rgb), 0.25);
}

.note[class*='color-'] .note-close {
    color: var(--f7-theme-color);
    --f7-touch-ripple-color: rgba(var(--f7-theme-color-rgb), 0.25);
}

.note-fill[class*='color-'] .note-close {
    color: #FFFFFF;
}

.note-close:after {
    color: inherit;
    content: 'notification_close_ios';
    font-family: 'framework7-core-icons';
    font-size: 8px;
}

.note-actions + .note-close:after {
    content: 'delete_md';
    font-size: 12px;
}

/*
|------------------------------------------------------------------------------
| Notification
|------------------------------------------------------------------------------
*/

:root {
    --f7-notification-subtitle-line-height: 1.4;
}

.aurora, .ios, .md {
    --f7-notification-icon-size: 24px;
    --f7-notification-subtitle-font-size: var(--f7-notification-title-font-size);
    --f7-notification-subtitle-font-weight: 600;
    --f7-notification-text-font-size: 14px;
    --f7-notification-text-line-height: 1.4;
}

.ios {
    --f7-notification-title-font-size: 15px;
    --f7-notification-title-font-weight: 600;
    --f7-notification-title-right-font-size: 14px;
}

.md {
    --f7-notification-title-color: #000000;
    --f7-notification-title-font-size: 16px;
    --f7-notification-title-font-weight: 600;
}

.md .dark, .md.dark {
    --f7-notification-title-color: #FFFFFF;
}

[dir=rtl] .notification {
    direction: rtl;
}

.notification-icon {
    flex-shrink: 0;
    font-size: var(--f7-notification-title-font-size);
}

[dir=rtl].aurora .notification-icon, [dir=rtl].ios .notification-icon, [dir=rtl].md .notification-icon {
    margin-left: 8px;
    margin-right: 0;
}

.notification-icon i {
    vertical-align: baseline;
}

[dir=rtl] .notification-title {
    margin-left: 8px;
}

.md .notification-title-right-text {
    margin-top: 2px;
}

[dir=rtl].aurora .notification-title-right-text,
[dir=rtl].ios .notification-title-right-text {
    margin-right: auto;
    margin-left: 0;
}

[dir=rtl].md .notification-title-right-text:before {
    margin-left: 4px;
    margin-right: 0;
}

.aurora .notification-subtitle + .notification-text,
.ios .notification-subtitle + .notification-text,
.md .notification-subtitle + .notification-text {
    margin-top: 4px;
}

[dir=rtl] .notification-close-button {
    margin-left: unset;
    margin-right: auto;
}

.md .notification-close-button.active-state:before {
    opacity: 0;
}

[dir=rtl].aurora .notification-title-right-text + .notification-close-button,
[dir=rtl].ios .notification-title-right-text + .notification-close-button {
    margin-left: 0;
    margin-right: 8px;
}

.notification-media {
    margin-top: var(--f7-notification-padding);
}

.notification-media img {
    max-height: 288px;
    width: 100%;
}

.notification-actions {
    display: flex;
    justify-content: flex-start;
    margin-top: var(--f7-notification-padding);
}

.notification-action {
    min-width: 128px;
    width: auto;
}

.notification-action + .notification-action {
    margin-left: 8px;
    margin-right: 0;
}

[dir=rtl] .notification-action + .notification-action {
    margin-left: 0;
    margin-right: 8px;
}

.notification-action.button {
    background-color: rgba(var(--f7-theme-color-rgb), 0.125);
    color: var(--f7-theme-color);
}

.notification-input {
    margin-top: var(--f7-notification-padding);
}

.notification-input .list {
    margin: 0;
}

.notification-input .list ul {
    background: transparent;
}

.notification-input .list .item-content, .notification-input .list .item-inner {
    padding-left: 0;
    padding-right: 0;
}

/*
|------------------------------------------------------------------------------
| Overlay Container
|------------------------------------------------------------------------------
*/

.overlay-container {
    position: relative;
}

.overlay-container:after {
    border-radius: inherit;
    bottom: 0;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    width: 100%;
    z-index: 10;
}

.overlay-container > img, .overlay-container > video {
    border-radius: inherit;
    height: 100%;
    object-fit: cover;
    object-position: center;
    width: 100%;
}

.overlay-content {
    align-items: center;
    border-radius: inherit;
    box-sizing: border-box;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    position: absolute;
    padding: var(--f7-block-padding-vertical) var(--f7-block-padding-horizontal);
    text-align: center;
    top: 0;
    width: 100%;
    z-index: 100;
}

.bg-overlay:after {
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 25%, rgba(0, 0, 0, 0.5) 50%, rgba(0, 0, 0, 0.75) 75%, rgba(0, 0, 0, 1) 100%);
    border-radius: inherit;
    bottom: 0;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    width: 100%;
    z-index: 10;
}

.no-overlay:after {
    content: none;
}

/*
|------------------------------------------------------------------------------
| Page
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-page-bg-color: #ECEFF1;
}

.aurora .dark, .ios .dark, .md .dark,
.aurora.dark, .ios.dark, .md.dark {
    --f7-page-bg-color: #000000;
}

.page.no-tabbar {
    --f7-page-toolbar-bottom-offset: 0px;
}

/*
|------------------------------------------------------------------------------
| Pagination
|------------------------------------------------------------------------------
*/

:root {
    --f7-pagination-item-size: 36px;
}

.paginated-list li.visible {
    display: list-item !important;
}

.paginated-data-table tr.visible {
    display: table-row !important;
}

.pagination {
    box-sizing: border-box;
    color: var(--f7-theme-color);
    font-size: 14px;
    margin: var(--f7-block-margin-vertical) 0;
    padding-bottom: 0;
    padding-left: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-left));
    padding-right: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-right));
    padding-top: 0;
    position: relative;
    z-index: 1;
}

.pagination ul {
    display: flex;
    flex-wrap: nowrap;
    list-style: none;
    margin: 0;
    overflow-x: auto;
    padding: 0;
}

.pagination li {
    display: inline-block;
}

.pagination li:first-child {
    margin-left: auto;
}

.pagination li:last-child {
    margin-right: auto;
}

[dir=rtl] .pagination li:first-child {
    margin-left: initial;
    margin-right: auto;
}

[dir=rtl] .pagination li:last-child {
    margin-left: auto;
}

.pagination li + li {
    margin-left: 12px;
}

[dir=rtl] .pagination li + li {
    margin-left: 0;
    margin-right: 12px;
}

.pagination li a {
    align-items: center;
    background-color: #FFFFFF;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    height: var(--f7-pagination-item-size);
    justify-content: center;
    min-width: var(--f7-pagination-item-size);
    padding: 4px 8px;
    text-align: center;
    white-space: nowrap;
}

.dark .pagination li a, .dark.pagination li a {
    background-color: #1C1C1D;
}

.pagination li.active a {
    background-color: var(--f7-theme-color);
    color: #FFFFFF;
}

.pagination-round li a {
    border-radius: var(--f7-pagination-item-size);
}

/*
|------------------------------------------------------------------------------
| Photo Browser
|------------------------------------------------------------------------------
*/

.photo-browser {
    position: absolute;
}

/*
|------------------------------------------------------------------------------
| Picker
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-picker-column-font-size: 18px;
}

[dir=rtl] .picker-columns {
    text-align: left;
}

[dir=rtl] .picker-column.picker-column-left {
    text-align: right;
}

[dir=rtl] .picker-column.picker-column-right {
    text-align: left;
}

/*
|------------------------------------------------------------------------------
| Popover
|------------------------------------------------------------------------------
*/

:root {
    --f7-popover-width: auto;
}

.popover {
    min-width: 128px;
    max-width: 384px;
}

.popover-inner {
    max-height: 75vh;
    overflow-y: auto;
}

/*
|------------------------------------------------------------------------------
| Popup
|------------------------------------------------------------------------------
*/

.popup-router-open-in .row:first-of-type > [class*='col-'],
.popup-router-open-in .row:first-of-type > [class*='xsmall-'],
.popup-router-open-in .row:first-of-type > [class*='small-'],
.popup-router-open-in .row:first-of-type > [class*='medium-'],
.popup-router-open-in .row:first-of-type > [class*='large-'],
.popup-router-open-in .row:first-of-type > [class*='xlarge-'] {
    --f7-cols-per-row: 1 !important;
}

/*
|------------------------------------------------------------------------------
| Position
|------------------------------------------------------------------------------
*/

.position-relative {
    position: relative !important;
}

.position-absolute {
    position: absolute;
    z-index: 9999;
}

.position-left-top,
.position-left-center,
.position-left-bottom {
    left: 0;
}

.position-right-top,
.position-right-center,
.position-right-bottom {
    right: 0;
}

.position-left-top,
.position-center-top,
.position-right-top {
    top: 0;
}

.position-left-bottom,
.position-center-bottom,
.position-right-bottom {
    bottom: 0;
}

.position-center-top,
.position-center-center,
.position-center-bottom {
    left: 50%;
    transform: translateX(-50%);
}

.position-left-center,
.position-center-center,
.position-right-center {
    top: 50%;
    transform: translateY(-50%);
}

.position-center-center {
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
}

.sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0px;
    z-index: 1000;
}

.sticky.sticky-top {
    top: 0px;
}

.sticky.sticky-bottom {
    bottom: 0px;
}

@media (min-width: 768px) {
    .medium-sticky {
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
        z-index: 1000;
    }
}

/*
|------------------------------------------------------------------------------
| Preloader
|------------------------------------------------------------------------------
*/

.preloader-backdrop {
    border-radius: inherit;
}

.with-modal-preloader:not(html) .preloader-backdrop {
    background: rgba(0, 0, 0, 0.4);
    opacity: 1;
}

.dark .with-modal-preloader:not(html) .preloader-backdrop, .dark.with-modal-preloader:not(html) .preloader-backdrop {
    background: rgba(0, 0, 0, 0.6);
}

/*
|------------------------------------------------------------------------------
| Progress Bar
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-progressbar-bg-color: rgba(0, 0, 0, 0.15);
    --f7-progressbar-border-radius: 4px;
    --f7-progressbar-height: 8px;
}

.aurora .dark, .aurora.dark, .ios .dark, .ios.dark, .md .dark, .md.dark {
    --f7-progressbar-bg-color: rgba(255, 255, 255, 0.15);
}

.aurora .progressbar, .aurora .progressbar-infinite, .aurora .progressbar span, .aurora .progressbar-infinite:before {
    box-shadow: none;
}

.progressbar[class*='color-'] {
    --f7-progressbar-bg-color: rgba(var(--f7-theme-color-rgb), 0.15);
}

.progressbar:after {
    align-items: center;
    color: #FFFFFF;
    content: attr(data-label);
    display: flex;
    font-size: 10px;
    height: 100%;
    letter-spacing: 0.5px;
    justify-content: center;
    padding: 0 4px;
}

.progressbar span {
    z-index: -1;
}

.progressbar-round {
    border-radius: var(--f7-progressbar-height);
}

.progressbar-round:after {
    padding: 0 8px;
}

.progressbar[data-label] {
    --f7-progressbar-height: 16px;
}

.progressbar[data-label-position=start]:after {
    justify-content: flex-start;
}

.progressbar[data-label-position=end]:after {
    justify-content: flex-end;
}

.framework7-root > .progressbar, .framework7-root > .progressbar-infinite,
.page > .progressbar, .page > .progressbar-infinite,
.panel > .progressbar, .panel > .progressbar-infinite,
.popup > .progressbar, .popup > .progressbar-infinite,
.view > .progressbar, .view > .progressbar-infinite,
.views > .progressbar, .views > .progressbar-infinite,
body > .progressbar, body > .progressbar-infinite {
    --f7-progressbar-height: 4px;
}

[dir=rtl].ios .progressbar-infinite.color-multi:before {
    animation: rtl-ios-progressbar-infinite-multicolor 3s linear infinite;
}

@keyframes rtl-ios-progressbar-infinite-multicolor {
    0% {
        transform: translate3d(0%, 0, 0);
    }
    100% {
        transform: translate3d(50%, 0, 0);
    }
}

/*
|------------------------------------------------------------------------------
| Pull-to-Refresh
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-ptr-preloader-size: 24px;
}

/*
|------------------------------------------------------------------------------
| Quote
|------------------------------------------------------------------------------
*/

:root {
    --f7-quote-border-width: 6px;
}

q {
    font-style: italic;
}

blockquote, .quote {
    background-color: var(--f7-block-strong-bg-color);
    border-color: var(--f7-color-mono);
    border-style: solid;
    border-width: 0 0 0 var(--f7-quote-border-width);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    font-size: inherit;
    font-style: italic;
    margin: calc(var(--f7-block-margin-vertical) / 2) 0;
    padding-bottom: var(--f7-block-padding-vertical);
    padding-left: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-left));
    padding-right: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-right));
    padding-top: 4em;
    position: relative;
}

[dir=rtl] blockquote, [dir=rtl] .quote {
    border-width: 0 var(--f7-quote-border-width) 0 0;
}

.block-strong blockquote, .block-strong .quote {
    margin: 0;
}

blockquote.inset, .quote.inset {
    border-radius: 0 var(--f7-block-inset-border-radius) var(--f7-block-inset-border-radius) 0;
    margin-left: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-left));
    margin-right: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-right));
    --f7-safe-area-left: 0px;
    --f7-safe-area-right: 0px;
}

[dir=rtl] blockquote.inset, [dir=rtl] .quote.inset {
    border-radius: var(--f7-block-inset-border-radius) 0 0 var(--f7-block-inset-border-radius);
}

blockquote.pull-quote, .quote.pull-quote {
    border-width: 0;
    text-align: center;
}

blockquote.inset.pull-quote, .quote.inset.pull-quote {
    border-radius: var(--f7-block-inset-border-radius);
}

blockquote.pull-quote:before, .quote.pull-quote:before {
    left: 0;
    right: 0;
}

blockquote.border-left, .quote.border-left {
    border-width: 0 0 0 var(--f7-quote-border-width);
}

blockquote.inset.border-left, .quote.inset.border-left {
    border-radius: 0 var(--f7-block-inset-border-radius) var(--f7-block-inset-border-radius) 0;
}

blockquote.border-right, .quote.border-right {
    border-width: 0 var(--f7-quote-border-width) 0 0;
}

blockquote.inset.border-right, .quote.inset.border-right {
    border-radius: var(--f7-block-inset-border-radius) 0 0 var(--f7-block-inset-border-radius);
}

blockquote.border-vertical, .quote.border-vertical {
    border-width: 0 var(--f7-quote-border-width) 0 var(--f7-quote-border-width);
}

blockquote.inset.border-vertical, .quote.inset.border-vertical {
    border-radius: 0;
}

blockquote.border-top, .quote.border-top {
    border-width: var(--f7-quote-border-width) 0 0 0;
}

blockquote.inset.border-top, .quote.inset.border-top {
    border-radius: 0 0 var(--f7-block-inset-border-radius) var(--f7-block-inset-border-radius);
}

blockquote.border-bottom, .quote.border-bottom {
    border-width: 0 0 var(--f7-quote-border-width) 0;
}

blockquote.inset.border-bottom, .quote.inset.border-bottom {
    border-radius: var(--f7-block-inset-border-radius) var(--f7-block-inset-border-radius) 0 0;
}

blockquote.border-horizontal, .quote.border-horizontal {
    border-width: var(--f7-quote-border-width) 0 var(--f7-quote-border-width) 0;
}

blockquote.inset.border-horizontal, .quote.inset.border-horizontal {
    border-radius: 0;
}

blockquote.border-outline, .quote.border-outline {
    border-radius: 0;
    border-width: var(--f7-quote-border-width);
}

blockquote.inset.border-outline, .quote.inset.border-outline {
    border-radius: var(--f7-block-inset-border-radius);
}

blockquote[class*='color-'], .quote[class*='color-'] {
    border-color: var(--f7-theme-color);
}

blockquote:before, .quote:before {
    content: '\\201C';
    font-family: 'Georgia', 'Times New Roman', serif;
    font-size: 8em;
    font-style: normal;
    font-weight: normal;
    line-height: 0;
    position: absolute;
}

[dir=rtl] blockquote:before, [dir=rtl] .quote:before {
    content: '\\201D';
}

blockquote[class*='color-']:before, .quote[class*='color-']:before {
    color: var(--f7-theme-color);
}

blockquote .quote-text, .quote .quote-text {
    font-style: italic;
}

blockquote .quote-cite, .quote .quote-cite {
    font-size: 0.85em;
    font-style: normal;
}

blockquote .quote-text + .quote-cite, .quote .quote-text + .quote-cite {
    margin-top: 12px;
}

blockquote .quote-cite .cite-title, .quote .quote-cite .cite-title {
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

blockquote .quote-cite .cite-subtitle, .quote .quote-cite .cite-subtitle {
    color: var(--f7-block-footer-text-color);
    font-size: 0.95em;
}

blockquote[class*='color-'] .quote-cite .cite-title, .quote[class*='color-'] .quote-cite .cite-title {
    color: var(--f7-theme-color);
}

blockquote.quote-fade[class*='color-'], .quote.quote-fade[class*='color-'] {
    background-color: rgba(var(--f7-theme-color-rgb), 0.15);
}

blockquote.quote-fill[class*='color-'], .quote.quote-fill[class*='color-'] {
    background-color: var(--f7-theme-color);
    border-color: rgba(0, 0, 0, 0.25);
    color: #FFFFFF;
}

blockquote.quote-fill[class*='color-']:before, .quote.quote-fill[class*='color-']:before {
    color: #FFFFFF;
}

blockquote.quote-fill[class*='color-'] .quote-cite, .quote.quote-fill[class*='color-'] .quote-cite,
blockquote.quote-fill[class*='color-'] .quote-cite .cite-title, .quote.quote-fill[class*='color-'] .quote-cite .cite-title,
blockquote.quote-fill[class*='color-'] .quote-cite .cite-subtitle, .quote.quote-fill[class*='color-'] .quote-cite .cite-subtitle {
    color: #FFFFFF;
}

/*
|------------------------------------------------------------------------------
| Range Slider
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-range-label-bg-color: var(--f7-theme-color);
    --f7-range-label-text-color: #FFFFFF;
}

.range-slider[class*='color-'] {
    --f7-range-label-bg-color: var(--f7-theme-color);
}

[dir=rtl] .range-slider-vertical .range-scale-step {
    justify-content: flex-start;
}

/*
|------------------------------------------------------------------------------
| Rating
|------------------------------------------------------------------------------
*/

.jq-ry-container {
    padding: 0;
}

/*
|------------------------------------------------------------------------------
| Responsive Container
|------------------------------------------------------------------------------
*/

.responsive-wrapper {
    border-radius: inherit;
    max-width: 100%;
    overflow: hidden;
}

.responsive-container {
    clear: both;
    float: none;
    height: 0;
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    width: 100%;
}

.responsive-container .responsive-content {
    border: none;
    height: 100%;
    left: 0;
    position: absolute;
    right: auto;
    top: 0;
    width: 100%;
}

[dir=rtl] .responsive-container .responsive-content {
    left: auto;
    right: 0;
}

.responsive-container.aspect-ratio-1-1 {
    padding-bottom: 100%;
}

.responsive-container.aspect-ratio-6-5 {
    padding-bottom: 83.33%;
}

.responsive-container.aspect-ratio-5-4 {
    padding-bottom: 80%;
}

.responsive-container.aspect-ratio-4-3 {
    padding-bottom: 75%;
}

.responsive-container.aspect-ratio-11-8 {
    padding-bottom: 72.73%;
}

.responsive-container.aspect-ratio-3-2 {
    padding-bottom: 66.67%;
}

.responsive-container.aspect-ratio-8-5 {
    padding-bottom: 62.5%;
}

.responsive-container.aspect-ratio-5-3 {
    padding-bottom: 60%;
}

.responsive-container.aspect-ratio-16-9 {
    padding-bottom: 56.25%;
}

.responsive-container.aspect-ratio-2-1 {
    padding-bottom: 50%;
}

.responsive-container.aspect-ratio-21-9 {
    padding-bottom: 42.86%;
}

.responsive-container.aspect-ratio-3-1 {
    padding-bottom: 33.33%;
}

/*
|------------------------------------------------------------------------------
| Ribbon
|------------------------------------------------------------------------------
*/

:root {
    --f7-ribbon-border-radius: 0.475rem;
    --f7-ribbon-clip-color: rgba(0, 0, 0, 0.75);
    --f7-ribbon-spacing: 8px;
}

:root .dark, :root.dark {
    --f7-ribbon-clip-color: rgba(255, 255, 255, 0.25);
}

.ribbon {
    align-items: center;
    background-color: var(--f7-theme-color);
    color: #FFFFFF;
    display: flex;
    font-size: 12px;
    font-weight: normal;
    justify-content: center;
    max-width: 100%;
    overflow: hidden;
    padding: 4px 8px;
    position: absolute;
    text-overflow: ellipsis;
    white-space: nowrap;
    z-index: 100;
}

.ribbon.ribbon-left-top {
    left: 0;
    top: 0;
    right: auto;
    bottom: auto;
    transform: translateX(calc(var(--f7-ribbon-spacing) * -1)) translateY(calc(var(--f7-ribbon-spacing) * 1));
}

.ribbon.ribbon-right-top {
    right: 0;
    top: 0;
    left: auto;
    bottom: auto;
    transform: translateX(calc(var(--f7-ribbon-spacing) * 1)) translateY(calc(var(--f7-ribbon-spacing) * 1));
}

.ribbon.ribbon-right-bottom {
    right: 0;
    bottom: 0;
    left: auto;
    top: auto;
    transform: translateX(calc(var(--f7-ribbon-spacing) * 1)) translateY(calc(var(--f7-ribbon-spacing) * -1));
}

.ribbon.ribbon-left-bottom {
    left: 0;
    bottom: 0;
    right: auto;
    top: auto;
    transform: translateX(calc(var(--f7-ribbon-spacing) * -1)) translateY(calc(var(--f7-ribbon-spacing) * -1));
}

.ribbon.ribbon-left-center {
    left: 0;
    top: 50%;
    right: auto;
    bottom: auto;
    transform: translateX(calc(var(--f7-ribbon-spacing) * -1)) translateY(-50%);
}

.ribbon.ribbon-top-center {
    top: 0;
    left: 50%;
    bottom: auto;
    right: auto;
    transform: translateY(calc(var(--f7-ribbon-spacing) * -1)) translateX(-50%);
}

.ribbon.ribbon-right-center {
    right: 0;
    top: 50%;
    left: auto;
    bottom: auto;
    transform: translateX(calc(var(--f7-ribbon-spacing) * 1)) translateY(-50%)
}

.ribbon.ribbon-bottom-center {
    bottom: 0;
    left: 50%;
    top: auto;
    right: auto;
    transform: translateY(calc(var(--f7-ribbon-spacing) * 1)) translateX(-50%);
}

.ribbon.ribbon-top-left {
    top: 0;
    left: 0;
    bottom: auto;
    right: auto;
    transform: translateY(calc(var(--f7-ribbon-spacing) * -1)) translateX(calc(var(--f7-ribbon-spacing) * 1));
}

.ribbon.ribbon-top-right {
    top: 0;
    right: 0;
    bottom: auto;
    left: auto;
    transform: translateY(calc(var(--f7-ribbon-spacing) * -1)) translateX(calc(var(--f7-ribbon-spacing) * -1));
}

.ribbon.ribbon-bottom-right {
    bottom: 0;
    right: 0;
    top: auto;
    left: auto;
    transform: translateY(calc(var(--f7-ribbon-spacing) * 1)) translateX(calc(var(--f7-ribbon-spacing) * -1));
}

.ribbon.ribbon-bottom-left {
    bottom: 0;
    left: 0;
    top: auto;
    right: auto;
    transform: translateY(calc(var(--f7-ribbon-spacing) * 1)) translateX(calc(var(--f7-ribbon-spacing) * 1));
}

.ribbon-round.ribbon-left-top, .ribbon-round.ribbon-left-center, .ribbon-round.ribbon-left-bottom {
    border-radius: 0 var(--f7-ribbon-border-radius) var(--f7-ribbon-border-radius) 0;
}

.ribbon-round.ribbon-right-top, .ribbon-round.ribbon-right-center, .ribbon-round.ribbon-right-bottom {
    border-radius: var(--f7-ribbon-border-radius) 0 0 var(--f7-ribbon-border-radius);
}

.ribbon-round.ribbon-top-left, .ribbon-round.ribbon-top-center, .ribbon-round.ribbon-top-right {
    border-radius: 0 0 var(--f7-ribbon-border-radius) var(--f7-ribbon-border-radius);
}

.ribbon-round.ribbon-bottom-left, .ribbon-round.ribbon-bottom-center, .ribbon-round.ribbon-bottom-right {
    border-radius: var(--f7-ribbon-border-radius) var(--f7-ribbon-border-radius) 0 0;
}

.ribbon.ribbon-clip {
    overflow: visible;
}

.ribbon.ribbon-clip:before {
    border-style: solid;
    content: '';
    position: absolute;
}

.ribbon.ribbon-clip:after {
    border-style: solid;
    content: '';
    position: absolute;
}

.ribbon.ribbon-clip.ribbon-left-top:before {
    content: none;
}

.ribbon.ribbon-clip.ribbon-left-top:after {
    left: 0;
    right: auto;
    bottom: calc(var(--f7-ribbon-spacing) * -1);
    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;
    border-width: 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0;
}

.ribbon.ribbon-clip.ribbon-right-top:before {
    content: none;
}

.ribbon.ribbon-clip.ribbon-right-top:after {
    left: auto;
    right: 0;
    bottom: calc(var(--f7-ribbon-spacing) * -1);
    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);
    border-width: 0 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing);
}

.ribbon.ribbon-clip.ribbon-right-bottom:before {
    left: auto;
    right: 0;
    top: calc(var(--f7-ribbon-spacing) * -1);
    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);
    border-width: var(--f7-ribbon-spacing) 0 0 var(--f7-ribbon-spacing);
}

.ribbon.ribbon-clip.ribbon-right-bottom:after {
    content: none;
}

.ribbon.ribbon-clip.ribbon-left-bottom:before {
    left: 0;
    right: auto;
    top: calc(var(--f7-ribbon-spacing) * -1);
    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;
    border-width: var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0 0;
}

.ribbon.ribbon-clip.ribbon-left-bottom:after {
    content: none;
}

.ribbon.ribbon-clip.ribbon-left-center:before {
    left: 0;
    right: auto;
    top: calc(var(--f7-ribbon-spacing) * -1);
    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;
    border-width: var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0 0;
}

.ribbon.ribbon-clip.ribbon-left-center:after {
    left: 0;
    right: auto;
    bottom: calc(var(--f7-ribbon-spacing) * -1);
    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;
    border-width: 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0;
}

.ribbon.ribbon-clip.ribbon-top-center:before {
    left: calc(var(--f7-ribbon-spacing) * -1);
    right: auto;
    top: 0;
    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;
    border-width: var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0 0;
}

.ribbon.ribbon-clip.ribbon-top-center:after {
    left: auto;
    right: calc(var(--f7-ribbon-spacing) * -1);
    top: 0;
    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);
    border-width: var(--f7-ribbon-spacing) 0 0 var(--f7-ribbon-spacing);
}

.ribbon.ribbon-clip.ribbon-right-center:before {
    left: auto;
    right: 0;
    top: calc(var(--f7-ribbon-spacing) * -1);
    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);
    border-width: var(--f7-ribbon-spacing) 0 0 var(--f7-ribbon-spacing);
}

.ribbon.ribbon-clip.ribbon-right-center:after {
    left: auto;
    right: 0;
    bottom: calc(var(--f7-ribbon-spacing) * -1);
    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);
    border-width: 0 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing);
}

.ribbon.ribbon-clip.ribbon-bottom-center:before {
    left: calc(var(--f7-ribbon-spacing) * -1);
    right: auto;
    bottom: 0;
    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;
    border-width: 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0;
}

.ribbon.ribbon-clip.ribbon-bottom-center:after {
    left: auto;
    right: calc(var(--f7-ribbon-spacing) * -1);
    bottom: 0;
    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);
    border-width: 0 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing);
}

.ribbon.ribbon-clip.ribbon-top-left:before {
    content: none;
}

.ribbon.ribbon-clip.ribbon-top-left:after {
    left: auto;
    right: calc(var(--f7-ribbon-spacing) * -1);
    top: 0;
    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);
    border-width: var(--f7-ribbon-spacing) 0 0 var(--f7-ribbon-spacing);
}

.ribbon.ribbon-clip.ribbon-top-right:before {
    left: calc(var(--f7-ribbon-spacing) * -1);
    right: auto;
    top: 0;
    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;
    border-width: var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0 0;
}

.ribbon.ribbon-clip.ribbon-top-right:after {
    content: none;
}

.ribbon.ribbon-clip.ribbon-bottom-right:before {
    left: calc(var(--f7-ribbon-spacing) * -1);
    right: auto;
    bottom: 0;
    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;
    border-width: 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0;
}

.ribbon.ribbon-clip.ribbon-bottom-right:after {
    content: none;
}

.ribbon.ribbon-clip.ribbon-bottom-left:before {
    content: none;
}

.ribbon.ribbon-clip.ribbon-bottom-left:after {
    left: auto;
    right: calc(var(--f7-ribbon-spacing) * -1);
    bottom: 0;
    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);
    border-width: 0 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing);
}

.ribbon-corner {
    align-items: flex-end;
    background: none;
    border-style: solid;
    border-width: 2rem;
    box-shadow: none;
    height: 0;
    justify-content: flex-start;
    overflow: visible;
    padding: 0;
    transform: none !important;
    width: 0;
}

.ribbon-corner {
    bottom: auto;
    left: auto;
    right: 0;
    top: 0;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: var(--f7-theme-color);
    border-top-color: var(--f7-theme-color);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 0;
    border-top-right-radius: inherit;
}

[dir=rtl] .ribbon-corner {
    bottom: auto;
    left: 0;
    right: auto;
    top: 0;
    border-bottom-color: transparent;
    border-left-color: var(--f7-theme-color);
    border-right-color: transparent;
    border-top-color: var(--f7-theme-color);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: inherit;
    border-top-right-radius: 0;
}

.ribbon-corner.ribbon-corner-top-left {
    bottom: auto;
    left: 0;
    right: auto;
    top: 0;
    border-bottom-color: transparent;
    border-left-color: var(--f7-theme-color);
    border-right-color: transparent;
    border-top-color: var(--f7-theme-color);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: inherit;
    border-top-right-radius: 0;
    align-items: flex-end;
    justify-content: flex-end;
}

[dir=rtl] .ribbon-corner.ribbon-corner-top-left {
    justify-content: flex-start;
}

.ribbon-corner.ribbon-corner-top-right {
    bottom: auto;
    left: auto;
    right: 0;
    top: 0;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: var(--f7-theme-color);
    border-top-color: var(--f7-theme-color);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 0;
    border-top-right-radius: inherit;
    align-items: flex-end;
    justify-content: flex-start;
}

[dir=rtl] .ribbon-corner.ribbon-corner-top-right {
    justify-content: flex-end;
}

.ribbon-corner.ribbon-corner-bottom-right {
    bottom: 0;
    left: auto;
    right: 0;
    top: auto;
    border-bottom-color: var(--f7-theme-color);
    border-left-color: transparent;
    border-right-color: var(--f7-theme-color);
    border-top-color: transparent;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: inherit;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    align-items: flex-start;
    justify-content: flex-start;
}

[dir=rtl] .ribbon-corner.ribbon-corner-bottom-right {
    justify-content: flex-end;
}

.ribbon-corner.ribbon-corner-bottom-left {
    bottom: 0;
    left: 0;
    right: auto;
    top: auto;
    border-bottom-color: var(--f7-theme-color);
    border-left-color: var(--f7-theme-color);
    border-right-color: transparent;
    border-top-color: transparent;
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    align-items: flex-start;
    justify-content: flex-end;
}

[dir=rtl] .ribbon-corner.ribbon-corner-bottom-left {
    justify-content: flex-start;
}

.ribbon-vertical {
    min-height: 48px;
    min-width: 24px;
    text-align: center;
}

/*
|------------------------------------------------------------------------------
| Scroll Bar
|------------------------------------------------------------------------------
*/

.device-desktop * {
    scrollbar-color: var(--color-gray-500) var(--color-gray-300);
    scrollbar-width: auto;
}

.device-desktop .dark *, .device-desktop.dark * {
    scrollbar-color: var(--color-gray-800) var(--color-gray-700);
}

.device-desktop *::-webkit-scrollbar {
    height: 4px;
    width: 8px;
}

.device-desktop *::-webkit-scrollbar-track {
    background-color: var(--color-gray-300);
}

.device-desktop .dark *::-webkit-scrollbar-track, .device-desktop.dark *::-webkit-scrollbar-track {
    background-color: var(--color-gray-700);
}

.device-desktop *::-webkit-scrollbar-thumb {
    background-color: var(--color-gray-500);
    border-color: var(--color-gray-500);
    border-radius: 0;
    border-style: none;
    border-width: 0;
}

.device-desktop .dark *::-webkit-scrollbar-thumb, .device-desktop.dark *::-webkit-scrollbar-thumb {
    background-color: var(--color-gray-800);
    border-color: var(--color-gray-800);
}

.no-scrollbar::-webkit-scrollbar {
    display: none;
}

/*
|------------------------------------------------------------------------------
| Searchbar
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-searchbar-input-font-size: 16px;
    --f7-searchbar-in-page-content-input-border-radius: var(--f7-searchbar-input-border-radius);
}

.md {
    --f7-searchbar-input-border-radius: 4px;
}

.md .searchbar-icon {
    --f7-safe-area-left: 0px;
    --f7-safe-area-right: 0px;
}

[dir=rtl].md .searchbar-icon {
    right: calc(8px + var(--f7-safe-area-right));
}

/*
|------------------------------------------------------------------------------
| Shape & Size
|------------------------------------------------------------------------------
*/

.shape-container {
    align-items: center;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    padding: 12px;
    text-align: center;
}

.shape-circle {
    border-radius: 50%;
}

.shape-rounded-square {
    border-radius: var(--f7-block-inset-border-radius);
}

.aurora .shape-auto {
    border-radius: var(--f7-block-inset-border-radius);
}

.ios .shape-auto {
    border-radius: var(--f7-block-inset-border-radius);
}

.md .shape-auto {
    border-radius: 50%;
}

.shape-inherit {
    border-radius: inherit !important;
}

.shape-none {
    border-radius: 0 !important;
}

.size-8 {
    height: 8px;
    width: 8px;
}

.size-12 {
    height: 12px;
    width: 12px;
}

.size-16 {
    height: 16px;
    width: 16px;
}

.size-20 {
    height: 20px;
    width: 20px;
}

.size-24 {
    height: 24px;
    width: 24px;
}

.size-32 {
    height: 32px;
    width: 32px;
}

.size-40 {
    height: 40px;
    width: 40px;
}

.size-48 {
    height: 48px;
    width: 48px;
}

.size-56 {
    height: 56px;
    width: 56px;
}

.size-64 {
    height: 64px;
    width: 64px;
}

.size-72 {
    height: 72px;
    width: 72px;
}

.size-80 {
    height: 80px;
    width: 80px;
}

.size-96 {
    height: 96px;
    width: 96px;
}

.size-112 {
    height: 112px;
    width: 112px;
}

.size-128 {
    height: 128px;
    width: 128px;
}

/*
|------------------------------------------------------------------------------
| Sheet Modal
|------------------------------------------------------------------------------
*/

:root {
    --f7-sheet-height: auto;
}

.aurora, .ios, .md {
    --f7-sheet-border-color: transparent;
}

.sheet-modal {
    border-radius: 16px 16px 0 0px;
    overflow: hidden;
}

.sheet-modal-top {
    border-radius: 0 0 16px 16px;
}

.sheet-modal-top .toolbar-bottom + .sheet-modal-inner {
    padding-bottom: var(--f7-toolbar-height);
}

.sheet-modal-bottom:before, .sheet-modal:not(.sheet-modal-top):before {
    background-color: transparent;
}

.sheet-modal .sheet-modal-inner {
    max-height: 75vh;
    overflow-y: auto;
}

.swipe-handler {
    background-color: inherit;
    cursor: pointer;
    height: 16px;
    left: 0;
    position: absolute;
    top: 0;
    transform: translate3d(0, 0, 1px);
    width: 100%;
    z-index: 999;
}

.swipe-handler:after {
    background-color: var(--f7-color-gray);
    border-radius: 3px;
    content: '';
    height: 6px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translateX(-18px) translateY(-3px);
    width: 36px;
}

.sheet-modal .list ul {
    --f7-list-bg-color: transparent;
}

/*
|------------------------------------------------------------------------------
| Show More/Less
|------------------------------------------------------------------------------
*/

.show-more-less .hidden {
    display: none;
}

.show-more-less > p:first-child {
    margin-top: 0;
}

.show-more-less > p:last-child {
    margin-bottom: 0;
}

.block ul.show-more-less {
    margin: 0;
}

div.show-more-wrapper {
    margin-top: calc(var(--f7-typography-margin) / 2);
}

span.show-more-wrapper {
    margin-left: calc(var(--f7-typography-margin) / 2);
}

[dir=rtl] span.show-more-wrapper {
    margin-right: calc(var(--f7-typography-margin) / 2);
}

.show-more-btn {
    background: transparent;
    border: 0;
    color: var(--f7-theme-color);
    cursor: pointer;
    display: inline-flex;
    font-size: inherit;
    margin: auto;
    outline: 0;
    padding: 0;
    white-space: nowrap;
    width: auto;
}

.data-table .show-more-less + .show-more-btn {
    margin: var(--f7-table-label-cell-padding-horizontal);
}

/*
|------------------------------------------------------------------------------
| Side Panel
|------------------------------------------------------------------------------
*/

:root {
    --f7-panel-bg-color: var(--color-gray-50);
}

:root .dark, :root.dark {
    --f7-panel-bg-color: var(--color-gray-900);
}

.aurora, .ios, .md {
    --f7-panel-collapsed-width: 56px;
}

.panel {
    box-shadow: var(--f7-elevation-1);
}

.panel-in-collapsed {
    transform: translate3d(0, 0, 0) !important;
    transition-duration: 0s;
}

.panel-left.panel-in-collapsed {
    --f7-panel-width: calc(var(--f7-safe-area-left) + var(--f7-panel-collapsed-width));
}

.panel-right.panel-in-collapsed {
    --f7-panel-width: calc(var(--f7-safe-area-right) + var(--f7-panel-collapsed-width));
}

.panel-in .panel-in-hide {
    display: none;
}

.panel-in-collapsed .panel-collapsed-hide {
    display: none;
}

.panel-in-breakpoint .panel-breakpoint-hide,
.panel-in-swipe .panel-breakpoint-hide {
    display: none;
}

/*
|------------------------------------------------------------------------------
| Signature Pad
|------------------------------------------------------------------------------
*/

.signature-pad {
    border: 2px dashed var(--f7-text-color);
    border-radius: var(--f7-block-inset-border-radius);
    clear: both;
    float: none;
    height: 0;
    padding-bottom: 56.25%;
    position: relative;
    width: 100%;
}

.signature-pad[class*='color-'] {
    border-color: var(--f7-theme-color);
}

.signature-pad .signature-pad-canvas {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}

/*
|------------------------------------------------------------------------------
| Skeleton
|------------------------------------------------------------------------------
*/

[dir=rtl] .skeleton-effect-blink, [dir=rtl] .skeleton-effect-wave {
    animation-direction: reverse;
}

.skeleton-block[class*='color-'] {
    --skeleton-color: rgba(var(--f7-theme-color-rgb), 0.125);
}

.skeleton-text[class*='color-'], .skeleton-text[class*='color-'] * {
    --skeleton-color: rgba(var(--f7-theme-color-rgb), 0.125);
}

/*
|------------------------------------------------------------------------------
| Smart Select
|------------------------------------------------------------------------------
*/

.smart-select-page .list {
    border-radius: var(--f7-list-inset-border-radius);
    margin-bottom: var(--f7-typography-margin);
    margin-left: calc(var(--f7-list-inset-side-margin) + var(--f7-safe-area-outer-left));
    margin-right: calc(var(--f7-list-inset-side-margin) + var(--f7-safe-area-outer-right));
    margin-top: var(--f7-typography-margin);
    --f7-safe-area-left: 0px;
    --f7-safe-area-right: 0px;
}

.smart-select-page .list ul {
    border-radius: var(--f7-list-inset-border-radius);
}

.smart-select-page .list ul:before, .smart-select-page .list ul:after {
    display: none !important;
}

.smart-select-page .list .item-media img {
    height: auto;
    width: 32px;
}

.smart-select-page .searchbar-not-found {
    margin: 0;
    padding: 0;
}

.smart-select-sheet {
    --f7-sheet-height: 256px;
}

/*
|------------------------------------------------------------------------------
| Sortable List
|------------------------------------------------------------------------------
*/

.aurora .sortable-handler:after, .ios .sortable-handler:after, .md .sortable-handler:after {
    content: 'sort_md';
}

/*
|------------------------------------------------------------------------------
| State Toggle
|------------------------------------------------------------------------------
*/

.state-toggle .state-active, .state-toggle .state-inactive {
    margin: 0 !important;
}

.state-toggle:not(.state-toggle-active) .state-active {
    display: none;
}

.state-toggle.state-toggle-active .state-inactive {
    display: none;
}

/*
|------------------------------------------------------------------------------
| Stepper
|------------------------------------------------------------------------------
*/

.ios {
    --f7-stepper-border-radius: 8px;
    --f7-stepper-height: 36px;
    --f7-stepper-large-height: 48px;
    --f7-stepper-small-height: 28px;
    --f7-stepper-value-font-size: 14px;
}

.stepper {
    --f7-stepper-vertical-width: var(--f7-stepper-height);
}

.stepper-small {
    --f7-stepper-vertical-width: var(--f7-stepper-small-height);
}

.stepper-large {
    --f7-stepper-vertical-width: var(--f7-stepper-large-height);
}

[dir=rtl] .stepper .stepper-button-minus {
    order: 2;
}

[dir=rtl] .stepper .stepper-input-wrap, [dir=rtl] .stepper .stepper-value {
    order: 1;
}

[dir=rtl] .stepper .stepper-button-plus {
    order: 0;
}

[dir=rtl] .stepper-button-minus:first-child, [dir=rtl] .stepper-button-plus:first-child, [dir=rtl] .stepper-button:first-child {
    border-radius: 0 var(--f7-stepper-border-radius) var(--f7-stepper-border-radius) 0;
}

[dir=rtl] .stepper-button-minus:last-child, [dir=rtl] .stepper-button-plus:last-child, [dir=rtl] .stepper-button:last-child {
    border-radius: var(--f7-stepper-border-radius) 0 0 var(--f7-stepper-border-radius);
}

.stepper .stepper-input-wrap input::-webkit-inner-spin-button, .stepper .stepper-input-wrap input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
}

.stepper .stepper-input-wrap input,
.stepper-value {
    box-sizing: border-box;
    padding-left: 4px;
    padding-right: 4px;
}

.stepper .stepper-input-wrap input[type=number] {
    -moz-appearance: textfield;
}

.stepper-vertical {
    flex-direction: column;
    height: auto;
    width: var(--f7-stepper-vertical-width);
}

[dir=rtl] .stepper-vertical .stepper-input-wrap, [dir=rtl] .stepper-vertical .stepper-value,
[dir=rtl] .stepper-vertical .stepper-button-minus, [dir=rtl] .stepper-vertical .stepper-button-plus {
    order: unset;
}

.stepper-vertical .stepper-input-wrap, .stepper-vertical .stepper-value {
    border-bottom: none;
    border-left: var(--f7-stepper-border-width) solid var(--f7-theme-color);
    border-right: var(--f7-stepper-border-width) solid var(--f7-theme-color);
    border-top: none;
    box-sizing: border-box;
}

.stepper-vertical .stepper-input-wrap, .stepper-vertical .stepper-value,
.stepper-vertical .stepper-button-minus, .stepper-vertical .stepper-button-plus, .stepper-vertical .stepper-button {
    height: 28px;
    width: var(--f7-stepper-vertical-width);
}

.stepper-vertical .stepper-button-minus:first-child, .stepper-vertical .stepper-button-plus:first-child, .stepper-vertical .stepper-button:first-child {
    border-radius: var(--f7-stepper-border-radius) var(--f7-stepper-border-radius) 0 0;
}

.stepper-vertical .stepper-button-minus:last-child, .stepper-vertical .stepper-button-plus:last-child, .stepper-vertical .stepper-button:last-child {
    border-radius: 0 0 var(--f7-stepper-border-radius) var(--f7-stepper-border-radius);
}

.stepper-vertical .stepper-input-wrap input {
    width: calc(var(--f7-stepper-vertical-width) - (var(--f7-stepper-border-width) * 2));
}

[dir=rtl] .stepper-button + .stepper-button,
[dir=rtl] .stepper-button + .stepper-button-minus,
[dir=rtl] .stepper-button + .stepper-button-plus,
[dir=rtl] .stepper-button-minus + .stepper-button,
[dir=rtl] .stepper-button-minus + .stepper-button-minus,
[dir=rtl] .stepper-button-minus + .stepper-button-plus,
[dir=rtl] .stepper-button-plus + .stepper-button,
[dir=rtl] .stepper-button-plus + .stepper-button-minus,
[dir=rtl] .stepper-button-plus + .stepper-button-plus {
    border-left: var(--f7-stepper-border-width) solid var(--f7-theme-color);
    border-right: 0;
}

.stepper-button.custom-icon:before, .stepper-button.custom-icon:after,
.stepper-button-minus.custom-icon:before, .stepper-button-minus.custom-icon:after,
.stepper-button-plus.custom-icon:before, .stepper-button-plus.custom-icon:after {
    content: none;
}

.stepper.custom-style .stepper-value,
.stepper.custom-style .stepper-input-wrap  {
    border: none;
    min-width: var(--f7-stepper-height);
    width: auto;
}

.stepper.custom-style .stepper-input-wrap input {
    min-width: var(--f7-stepper-height);
}

.stepper.custom-style .stepper-button, .stepper.custom-style .stepper-button-minus, .stepper.custom-style .stepper-button-plus {
    border: none;
    border-radius: 50%;
    width: var(--f7-stepper-height);
}

/*
|------------------------------------------------------------------------------
| Subnavbar
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-subnavbar-height: 48px;
    --f7-subnavbar-title-font-size: 24px;
    --f7-subnavbar-title-font-weight: bold;
    --f7-subnavbar-title-letter-spacing: 0em;
}

/*
|------------------------------------------------------------------------------
| Swipeout
|------------------------------------------------------------------------------
*/

:root {
    --f7-swipeout-delete-button-bg-color: var(--f7-color-red);
}

.aurora, .ios, .md {
    --f7-swipeout-button-font-size: 14px;
    --f7-swipeout-button-font-weight: 500;
}

.swipeout-actions-left {
    transform: translateX(-101%);
}

.swipeout-actions-right {
    transform: translateX(101%);
}

.swipeout-actions-left > a, .swipeout-actions-right > a {
    align-items: center;
    justify-content: center;
    text-align: center;
}

.swipeout-actions-left > a > *, .swipeout-actions-right > a > * {
    margin-left: 3px;
    margin-right: 3px;
}

/*
|------------------------------------------------------------------------------
| Swiper Slider
|------------------------------------------------------------------------------
*/

.swiper-button-disabled {
    cursor: auto;
    opacity: 0.35;
    pointer-events: none;
}

.swiper-navigation-button-next,
.swiper-navigation-button-previous {
    align-items: center;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    justify-content: center;
    position: absolute;
    top: calc(50% - var(--f7-button-height) / 2);
    z-index: 10;
}

.swiper-navigation-button-next,
.swiper-rtl .swiper-navigation-button-previous {
    right: 8px;
    left: auto;
}

.swiper-navigation-button-previous,
.swiper-rtl .swiper-navigation-button-next {
    right: auto;
    left: 8px;
}

.swiper-vertical .swiper-navigation-button-next {
    bottom: 4px;
    left: calc(50% - var(--f7-button-height) / 2);
    right: calc(50% - var(--f7-button-height) / 2);
    top: auto;
}

.swiper-vertical .swiper-navigation-button-previous {
    bottom: auto;
    left: calc(50% - var(--f7-button-height) / 2);
    right: calc(50% - var(--f7-button-height) / 2);
    top: 4px;
}

.swiper-thumbs .swiper-slide {
    filter: grayscale(1);
}

.swiper-thumbs .swiper-slide-thumb-active {
    filter: grayscale(0);
}

.swiper-pagination {
    --swiper-pagination-bullet-inactive-color: var(--f7-color-gray);
    --swiper-pagination-bullet-size: 8px;
    --swiper-pagination-bullet-height: 8px;
    --swiper-pagination-bullet-width: 8px;
}

.swiper-pagination-bullets .swiper-pagination-bullet {
    border-radius: var(--swiper-pagination-bullet-size);
}

.swiper-pagination-bullets.swiper-pagination-pills {
    --swiper-pagination-bullet-width: 24px;
}

.swiper-pagination-bullets.swiper-pagination-active-pill .swiper-pagination-bullet-active {
    --swiper-pagination-bullet-width: 24px;
}

/*
|------------------------------------------------------------------------------
| Syntax Hightlighter
|------------------------------------------------------------------------------
*/

pre, code {
    direction: ltr;
    font-size: 0.87em;
}

pre.inline {
    display: inline;
}

pre.inline code, pre.inline code.hljs {
    display: inline;
    padding: 3px 6px;
}

pre .hljs {
    background-color:#F3F3F3;
    color: #545454;
}

.dark pre .hljs {
    background-color: #2B2B2B;
    color: #F8F8F2;
}

pre .hljs-comment, pre .hljs-quote {
    color: #696969;
}

.dark pre .hljs-comment, .dark pre .hljs-quote {
    color: #D4D0AB;
}

pre .hljs-deletion, pre .hljs-name, pre .hljs-regexp, pre .hljs-selector-class, pre .hljs-selector-id, pre .hljs-tag, pre .hljs-template-variable, pre .hljs-variable {
    color: #D91E18;
}

.dark pre .hljs-deletion, .dark pre .hljs-name, .dark pre .hljs-regexp, .dark pre .hljs-selector-class, .dark pre .hljs-selector-id, .dark pre .hljs-tag, .dark pre .hljs-template-variable, .dark pre .hljs-variable {
    color: #FFA07A;
}

pre .hljs-tag .hljs-attr, pre .hljs-tag .hljs-name {
    color: #D91E18;
}

.dark pre .hljs-tag .hljs-attr, .dark pre .hljs-tag .hljs-name {
    color: #FFA07A;
}

pre .hljs-attribute, pre .hljs-built_in, pre .hljs-link, pre .hljs-literal, pre .hljs-meta, pre .hljs-number, pre .hljs-params, pre .hljs-type {
    color: #AA5D00;
}

.dark pre .hljs-attribute {
    color: #FFD700;
}

.dark pre .hljs-built_in, .dark pre .hljs-link, .dark pre .hljs-literal, .dark pre .hljs-meta, .dark pre .hljs-number, .dark pre .hljs-params, .dark pre .hljs-type {
    color: #F5AB35;
}

pre .hljs-addition, pre .hljs-bullet, pre .hljs-string, pre .hljs-symbol {
    color: #008000;
}

.dark pre .hljs-addition, .dark pre .hljs-bullet, .dark pre .hljs-string, .dark pre .hljs-symbol {
    color: #ABE338;
}

pre .hljs-section, pre .hljs-title {
    color: #007FAA;
}

.dark pre .hljs-section, .dark pre .hljs-title {
    color: #00E0E0;
}

pre .hljs-keyword, pre .hljs-selector-tag {
    color: #7928A1;
}

.dark pre .hljs-keyword, .dark pre .hljs-selector-tag {
    color: #DCC6E0;
}

[dir=rtl] pre .menu-overlay {
    left: auto;
    right: var(--f7-typography-margin);
}

/*
|------------------------------------------------------------------------------
| Tab
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-tabbar-icon-size: 20px;
    --f7-tabbar-label-font-size: 12px;
    --f7-tabbar-label-tablet-font-size: 12px;
}

.tabbar-labels .link, .tabbar-labels .tab-link {
    justify-content: center;
}

@media (min-width: 768px) and (min-height: 600px) {
    .ios .tabbar .link, .ios .tabbar .tab-link, .ios .tabbar-labels .link, .ios .tabbar-labels .tab-link {
        flex-direction: column;
    }
}

.tabbar-labels .tabbar-label {
    margin-top: 4px;
}

.no-tab-link-highlight .tab-link-highlight {
    display: none;
}

.tab-link .icons .icon + .icon-active, .tab-link .icons .icon-active + .icon {
    margin: 0;
}

.tab-link:not(.tab-link-active) .icons .icon-active {
    display: none;
}

.tab-link-active .icons .icon:not(.icon-active) {
    display: none;
}

/*
|------------------------------------------------------------------------------
| Text Editor
|------------------------------------------------------------------------------
*/

:root {
    --f7-text-editor-bg-color: var(--f7-block-strong-bg-color);
    --f7-text-editor-height: 256px;
    --f7-text-editor-padding: 12px 16px;
}

:root .dark, :root.dark {
    --f7-text-editor-bg-color: var(--f7-block-strong-bg-color);
}

.ios .dark, .ios.dark {
    --f7-text-editor-toolbar-bg-color: var(--f7-bars-bg-color);
}

.text-editor.inset {
    border: none;
    border-radius: var(--f7-block-inset-border-radius);
    margin-left: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-left));
    margin-right: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-right));
    overflow: hidden;
    --f7-safe-area-left: 0px;
    --f7-safe-area-right: 0px;
}

/*
|------------------------------------------------------------------------------
| Theme
|------------------------------------------------------------------------------
*/

html.dark .if-not-dark {
    display: none !important;
}

html:not(.dark) .if-dark {
    display: none !important;
}

/*
|------------------------------------------------------------------------------
| Timeline
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-timeline-item-inner-border-radius: var(--f7-card-border-radius);
    --f7-timeline-item-inner-box-shadow: var(--f7-card-box-shadow);
    --f7-timeline-item-title-font-size: var(--f7-font-size);
    --f7-timeline-item-title-font-weight: 600;
    --f7-timeline-item-subtitle-font-size: 14px;
    --f7-timeline-item-text-color: var(--f7-list-item-text-text-color);
    --f7-timeline-item-text-font-size: 14px;
    --f7-timeline-year-font-size: 18px;
    --f7-timeline-year-font-weight: bold;
    --f7-timeline-month-font-size: 12px;
    --f7-timeline-month-font-weight: 600;
}

.timeline {
    --f7-timeline-divider-size: 12px;
}

.timeline-item-date {
    line-height: 1;
}

.timeline-item-media, .timeline-item-title, .timeline-item-subtitle, .timeline-item-text {
    margin: 4px 0;
}

.timeline-year-title {
    color: var(--f7-theme-color);
}

.timeline-month-title {
    color: rgba(var(--f7-theme-color-rgb), 0.75);
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.timeline-horizontal .timeline-item-date {
    color: var(--f7-theme-color);
    font-weight: 600;
}

[dir=rtl] .timeline-horizontal > .timeline-item:last-child:after,
[dir=rtl] .timeline-horizontal .timeline-month:last-child .timeline-item:last-child:after {
    display: block !important;
}

.timeline-item-day {
    color: rgba(var(--f7-theme-color-rgb), 0.75);
    font-size: 10px;
    font-weight: 500;
    text-transform: uppercase;
}

.timeline-item-divider {
    align-items: center;
    background-color: #CCCCCC;
    color: #FFFFFF;
    display: flex;
    height: var(--f7-timeline-divider-size);
    justify-content: center;
    text-align: center;
    width: var(--f7-timeline-divider-size);
}

.timeline-item-divider:after, .timeline-item-divider:before {
    background-color: #CCCCCC;
}

.timeline-item-divider[class*='color-'] {
    background-color: var(--f7-theme-color);
}

.timeline-item-divider[class*='color-']:after, .timeline-item-divider[class*='color-']:before {
    background-color: var(--f7-theme-color);
}

.timeline.timeline-divider-icons {
    --f7-timeline-divider-size: 24px;
}

.timeline.timeline-divider-icons .timeline-item-divider:after, .timeline.timeline-divider-icons .timeline-item-divider:before {
    width: 2px;
}

.timeline-divider-icons .timeline-item-divider i, .timeline-divider-icons .timeline-item-divider .icon {
    font-size: 16px;
}

.timeline-sides .timeline-item-right,
.timeline-sides .timeline-item {
    margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
    margin-right: 0;
}

.timeline-sides .timeline-item-left,
.timeline-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {
    margin-left: 0;
    margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
}

@media (min-width: 480px) {
    .xsmall-sides .timeline-item-right,
    .xsmall-sides .timeline-item {
        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-right: 0;
    }
    .xsmall-sides .timeline-item-left,
    .xsmall-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {
        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-left: 0;
    }
}

@media (min-width: 568px) {
    .small-sides .timeline-item-right,
    .small-sides .timeline-item {
        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-right: 0;
    }
    .small-sides .timeline-item-left,
    .small-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {
        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-left: 0;
    }
}

@media (min-width: 768px) {
    .medium-sides .timeline-item-right,
    .medium-sides .timeline-item {
        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-right: 0;
    }
    .medium-sides .timeline-item-left,
    .medium-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {
        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-left: 0;
    }
}

@media (min-width: 1024px) {
    .large-sides .timeline-item-right,
    .large-sides .timeline-item {
        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-right: 0;
    }
    .large-sides .timeline-item-left,
    .large-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {
        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-left: 0;
    }
}

@media (min-width: 1200px) {
    .xlarge-sides .timeline-item-right,
    .xlarge-sides .timeline-item {
        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-right: 0;
    }
    .xlarge-sides .timeline-item-left,
    .xlarge-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {
        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-left: 0;
    }
}

[dir=rtl] .timeline-sides .timeline-item-right,
[dir=rtl] .timeline-sides .timeline-item {
    margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
    margin-left: 0;
}

[dir=rtl] .timeline-sides .timeline-item-left,
[dir=rtl] .timeline-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {
    margin-right: 0;
    margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
}

@media (min-width: 480px) {
    [dir=rtl] .xsmall-sides .timeline-item-right,
    [dir=rtl] .xsmall-sides .timeline-item {
        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-left: 0;
    }
    [dir=rtl] .xsmall-sides .timeline-item-left,
    [dir=rtl] .xsmall-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {
        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-right: 0;
    }
}

@media (min-width: 568px) {
    [dir=rtl] .small-sides .timeline-item-right,
    [dir=rtl] .small-sides .timeline-item {
        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-left: 0;
    }
    [dir=rtl] .small-sides .timeline-item-left,
    [dir=rtl] .small-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {
        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-right: 0;
    }
}

@media (min-width: 768px) {
    [dir=rtl] .medium-sides .timeline-item-right,
    [dir=rtl] .medium-sides .timeline-item {
        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-left: 0;
    }
    [dir=rtl] .medium-sides .timeline-item-left,
    [dir=rtl] .medium-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {
        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-right: 0;
    }
}

@media (min-width: 1024px) {
    [dir=rtl] .large-sides .timeline-item-right,
    [dir=rtl] .large-sides .timeline-item {
        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-left: 0;
    }
    [dir=rtl] .large-sides .timeline-item-left,
    [dir=rtl] .large-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {
        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-right: 0;
    }
}

@media (min-width: 1200px) {
    [dir=rtl] .xlarge-sides .timeline-item-right,
    [dir=rtl] .xlarge-sides .timeline-item {
        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-left: 0;
    }
    [dir=rtl] .xlarge-sides .timeline-item-left,
    [dir=rtl] .xlarge-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {
        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);
        margin-right: 0;
    }
}

/*
|------------------------------------------------------------------------------
| Timer
|------------------------------------------------------------------------------
*/

.timer-countdown .countdown-result {
    display: none;
}

/*
|------------------------------------------------------------------------------
| Toast
|------------------------------------------------------------------------------
*/

:root {
    --f7-toast-icon-size: 1.75em;
}

:root .dark, :root.dark {
    --f7-toast-text-color: #000000;
}

.aurora, .ios, .md {
    --f7-toast-bg-color: #323232;
    --f7-toast-button-min-width: auto;
}

.aurora .dark, .aurora.dark, .ios .dark, .ios.dark, .md .dark, .md.dark {
    --f7-toast-bg-color: #FAFAFA;
}

.ios .dark, .ios.dark {
    --f7-toast-bg-color-rgb: 250, 250, 250;
}

.md {
    --f7-toast-padding-horizontal: 16px;
}

.aurora .toast.toast-round, .ios .toast.toast-round, .md .toast.toast-round {
    border-radius: calc(var(--f7-toast-border-radius) * 8);
}

.toast[class*='color-'] {
    background-color: var(--f7-theme-color);
    color: #FFFFFF;
}

.ios .toast {
    border-radius: var(--f7-toast-border-radius);
}

@media (max-width: 568px) {
    .ios .toast {
        left: 8px;
        width: calc(100% - 16px);
    }

    .ios .toast.toast-top {
        margin-top: var(--f7-safe-area-top);
        top: 8px;
    }

    .ios .toast.toast-bottom {
        bottom: calc(8px + var(--f7-safe-area-bottom));
    }

    .ios .toast.toast-top .toast-content {
        padding-top: var(--f7-toast-padding-vertical);
    }

    .ios .toast.toast-bottom .toast-content {
        padding-bottom: var(--f7-toast-padding-vertical);
    }
}

.toast-button {
    text-transform: uppercase;
}

.ios .toast-button, .md .toast-button {
    margin-left: 16px;
    margin-right: 0;
}

[dir=rtl].ios .toast-button, [dir=rtl].md .toast-button {
    margin-left: 0;
    margin-right: 16px;
}

.toast[class*='color-'] .toast-button {
    color: #FFFFFF;
}

.toast .toast-button[class*='color-'] {
    color: var(--f7-theme-color);
}

.toast-with-icon.icon-position-start .toast-content {
    display: flex;
    justify-content: flex-start;
}

.toast-with-icon.icon-position-start .toast-icon + .toast-text {
    margin-left: 6px;
    margin-right: 0;
}

[dir=rtl] .toast-with-icon.icon-position-start .toast-icon + .toast-text {
    margin-left: 0;
    margin-right: 6px;
}

.toast-center .toast-text {
    text-align: center;
}

/*
|------------------------------------------------------------------------------
| Toggle
|------------------------------------------------------------------------------
*/

.ios {
    --f7-toggle-height: 28px;
    --f7-toggle-width: 52px;
}

.toggle .toggle-label {
    align-items: center;
    box-sizing: border-box;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    font-size: 8px;
    height: var(--f7-toggle-height);
    line-height: 1;
    overflow: hidden;
    padding: 0 4px;
    position: absolute;
    text-overflow: ellipsis;
    text-transform: uppercase;
    top: 0;
    white-space: nowrap;
    width: var(--f7-toggle-width);
}

.ios .toggle .toggle-label {
    font-size: 10px;
}

.md .toggle .toggle-label {
    padding: 0 3px;
}

.toggle .toggle-label i {
    font-size: 16px;
}

.toggle input:not(:checked) ~ .toggle-label {
    justify-content: flex-end;
}

.toggle input:checked ~ .toggle-label {
    justify-content: flex-start;
}

.md .toggle input:not(:checked) ~ .toggle-label {
    justify-content: flex-start;
}

.md .toggle input:checked ~ .toggle-label {
    justify-content: flex-end;
}

.ios .toggle input:not(:checked) ~ .toggle-label, .md .toggle input:not(:checked) ~ .toggle-label {
    color: var(--f7-color-gray);
}

.toggle input:not(:checked) ~ .toggle-label .toggle-label-on {
    display: none;
}

.toggle input:checked ~ .toggle-label .toggle-label-off {
    display: none;
}

/*
|------------------------------------------------------------------------------
| Toolbar
|------------------------------------------------------------------------------
*/

:root {
    --f7-toolbar-hide-show-transition-duration: 0ms;
}

.toolbar {
    position: relative;
}

/*
|------------------------------------------------------------------------------
| Tooltip
|------------------------------------------------------------------------------
*/

:root {
    --f7-tooltip-bg-color: rgba(0, 0, 0, 0.95);
}

:root .dark, :root.dark {
    --f7-tooltip-bg-color: rgba(255, 255, 255, 0.95);
    --f7-tooltip-text-color: #000000;
}

.tooltip {
    max-width: 256px;
}

.tooltip[class*='color-'] {
    --f7-tooltip-bg-color: rgba(var(--f7-theme-color-rgb), 0.95);
    --f7-tooltip-text-color: #FFFFFF;
}

.tooltip[class*='text-color-'] {
    --f7-tooltip-text-color: var(--f7-theme-color);
}

/*
|------------------------------------------------------------------------------
| Tour Guide
|------------------------------------------------------------------------------
*/

.shepherd-element {
    background-color: var(--f7-popover-bg-color) !important;
    border-radius: var(--f7-popover-border-radius) !important;
    box-shadow: var(--f7-popover-box-shadow) !important;
    max-width: 384px !important;
}

.shepherd-element .shepherd-arrow:before {
    background-color: var(--f7-popover-bg-color) !important;
}

.shepherd-element.shepherd-has-title[data-popper-placement^=bottom] > .shepherd-arrow:before {
    background-color: var(--f7-popover-bg-color) !important;
}

.shepherd-enabled.shepherd-target {
    background-color: var(--f7-popover-bg-color);
}

.shepherd-element .shepherd-content {
    background-color: var(--f7-popover-bg-color);
    border-radius: var(--f7-popover-border-radius);
}

.shepherd-element .shepherd-header {
    align-items: center;
    border-top-left-radius: var(--f7-popover-border-radius);
    border-top-right-radius: var(--f7-popover-border-radius);
    justify-content: space-between;
    line-height: var(--f7-line-height);
    padding: 8px 16px;
    position: relative;
}

.shepherd-element.shepherd-has-title .shepherd-content .shepherd-header {
    background: var(--f7-popover-bg-color);
    padding: 8px 16px;
}

.shepherd-element .shepherd-header:after {
    background-color: var(--f7-card-header-border-color);
    bottom: 0;
    content: '';
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    right: auto;
    top: auto;
    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
    transform-origin: 50% 100%;
    width: 100%;
    z-index: 15;
}

.shepherd-element .shepherd-title {
    color: var(--f7-card-header-text-color);
    flex: auto;
    font-size: var(--f7-card-header-font-size);
    font-weight: var(--f7-card-header-font-weight);
}

.shepherd-element .shepherd-cancel-icon {
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 50%;
    color: rgba(255, 255, 255, 0.90);
    font-size: 11px;
    font-weight: bold;
    height: 24px;
    width: 24px;
}

.shepherd-element .shepherd-cancel-icon:after {
    font-family: 'framework7-core-icons';
    content: 'delete_md';
}

.dark .shepherd-element .shepherd-cancel-icon {
    background-color: rgba(255, 255, 255, 0.25);
    color: rgba(255, 255, 255, 0.50);
}

.shepherd-element .shepherd-cancel-icon:hover {
    background-color: rgba(0, 0, 0, 0.30);
    color: rgba(255, 255, 255, 0.95);
}

.dark .shepherd-element .shepherd-cancel-icon:hover {
    background-color: rgba(255, 255, 255, 0.30);
    color: rgba(255, 255, 255, 0.55);
}

.shepherd-element.shepherd-has-title .shepherd-content .shepherd-cancel-icon {
    color: rgba(255, 255, 255, 0.90);
}

.dark .shepherd-element.shepherd-has-title .shepherd-content .shepherd-cancel-icon {
    color: rgba(255, 255, 255, 0.50);
}

.shepherd-element.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {
    color: rgba(255, 255, 255, 0.95);
}

.dark .shepherd-element.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {
    color: rgba(255, 255, 255, 0.55);
}

.shepherd-element .shepherd-cancel-icon span {
    display: none;
}

.shepherd-element .shepherd-text {
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    padding: var(--f7-card-content-padding-vertical) var(--f7-card-content-padding-horizontal);
}

.shepherd-element .shepherd-footer {
    border-bottom-left-radius: var(--f7-popover-border-radius);
    border-bottom-right-radius: var(--f7-popover-border-radius);
    justify-content: space-between;
    padding: calc(var(--f7-card-footer-padding-horizontal) / 1.5) var(--f7-card-footer-padding-horizontal);
    position: relative;
}

.shepherd-element .shepherd-footer:before {
    background-color: var(--f7-card-footer-border-color);
    bottom: auto;
    content: '';
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    right: auto;
    top: 0;
    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
    transform-origin: 50% 0%;
    width: 100%;
    z-index: 15;
}

.shepherd-element .shepherd-button {
    align-items: center;
    -webkit-appearance: none;
    appearance: none;
    background-color: var(--f7-theme-color);
    border-radius: var(--f7-button-border-radius);
    box-shadow: var(--f7-button-box-shadow);
    box-sizing: border-box;
    color: #FFFFFF;
    display: flex;
    font-family: inherit;
    font-size: var(--f7-button-font-size);
    font-weight: var(--f7-button-font-weight);
    height: var(--f7-button-height);
    justify-content: center;
    letter-spacing: var(--f7-button-letter-spacing);
    line-height: calc(var(--f7-button-height) - var(--f7-button-border-width, 0) * 2);
    margin: 0;
    min-width: var(--f7-button-min-width);
    outline: 0;
    overflow: hidden;
    padding: var(--f7-button-padding-vertical) var(--f7-button-padding-horizontal);
    position: relative;
    text-align: center;
    text-decoration: none;
    text-overflow: ellipsis;
    text-transform: var(--f7-button-text-transform);
    transition: none;
    vertical-align: middle;
    white-space: nowrap;
}

.shepherd-element .shepherd-button + .shepherd-button {
    margin-left: 16px;
    margin-right: 0;
}

[dir=rtl] .shepherd-element .shepherd-button + .shepherd-button {
    margin-left: 0;
    margin-right: 16px;
}

.shepherd-element .shepherd-button:not(:disabled):hover {
    background-color: var(--f7-theme-color-tint);
    color: #FFFFFF;
}

.shepherd-element .shepherd-button.shepherd-button-secondary {
    background-color: var(--f7-color-gray);
    color: #FFFFFF;
}

.shepherd-element .shepherd-button.shepherd-button-secondary:not(:disabled):hover {
    background-color: var(--f7-color-gray-tint);
    color: #FFFFFF;
}

.shepherd-element .shepherd-button.shepherd-button-secondary[class*='color-'] {
    background-color: var(--f7-theme-color);
}

.shepherd-element .shepherd-button.shepherd-button-secondary[class*='color-']:not(:disabled):hover {
    background-color: var(--f7-theme-color-tint);
}

/*
|------------------------------------------------------------------------------
| Tree View
|------------------------------------------------------------------------------
*/

.aurora, .ios, .md {
    --f7-treeview-label-font-size: 16px;
}

.treeview-item-content .icon[class*='color-'] {
    color: var(--f7-theme-color);
}

.treeview-preloader {
    --f7-preloader-size: 20px;
}

/*
|------------------------------------------------------------------------------
| Video
|------------------------------------------------------------------------------
*/

video {
    background-color: #000000;
    max-width: 100%;
    vertical-align: bottom;
}

.dark video {
    background-color: #111111;
}

/*
|------------------------------------------------------------------------------
| Virtual List
|------------------------------------------------------------------------------
*/

.virtual-list {
    position: relative;
}

/*
|------------------------------------------------------------------------------
| Utilities
|------------------------------------------------------------------------------
*/

[class*='text-gradient-'] { -webkit-background-clip: text; -webkit-text-fill-color: transparent; }

.bg-transparent { background: transparent !important; }
.bg-translucent { background-color: rgba(255, 255, 255, 0.75); -webkit-backdrop-filter: blur(24px); backdrop-filter: blur(24px); }
.dark .bg-translucent, .dark.bg-translucent { background-color: rgba(45, 45, 45, 0.75); }

.bg-color-chrome { --f7-theme-color-bg-color: rgba(var(--f7-color-gray-rgb), 0.25); }
.border-color-chrome { --f7-theme-color-border-color: rgba(var(--f7-color-gray-rgb), 0.25); }

.opacity-0 { opacity: 0; }
.opacity-25 { opacity: 0.25; }
.opacity-50 { opacity: 0.5; }
.opacity-75 { opacity: 0.75; }
.opacity-100 { opacity: 1; }

.font-size-8 { font-size: 8px !important; }
.font-size-10 { font-size: 10px !important; }
.font-size-12 { font-size: 12px !important; }
.font-size-14 { font-size: 14px !important; }
.font-size-16 { font-size: 16px !important; }
.font-size-18 { font-size: 18px !important; }
.font-size-20 { font-size: 20px !important; }
.font-size-22 { font-size: 22px !important; }
.font-size-24 { font-size: 24px !important; }
.font-size-26 { font-size: 26px !important; }
.font-size-28 { font-size: 28px !important; }
.font-size-30 { font-size: 30px !important; }
.font-size-32 { font-size: 32px !important; }
.font-size-40 { font-size: 40px !important; }
.font-size-48 { font-size: 48px !important; }
.font-size-56 { font-size: 56px !important; }
.font-size-64 { font-size: 64px !important; }
.font-size-72 { font-size: 72px !important; }
.font-size-80 { font-size: 80px !important; }
.font-size-88 { font-size: 88px !important; }
.font-size-96 { font-size: 96px !important; }

.font-weight-bold { font-weight: bold !important; }
.font-weight-normal { font-weight: normal !important; }
.font-weight-600 { font-weight: 600 !important; }
.font-weight-800 { font-weight: 800 !important; }
.font-weight-900 { font-weight: 900 !important; }

.text-capitalize { text-transform: capitalize !important; }
.text-uppercase { text-transform: uppercase !important; }
.text-italic { font-style: italic; }
.text-underline-dotted { cursor: pointer; text-decoration-line: underline; text-decoration-style: dotted; }

.single-line-text { display: block !important; overflow: hidden !important; text-overflow: ellipsis !important; white-space: nowrap !important; }
.multi-line-text { display: -webkit-box !important; -webkit-box-orient: vertical !important; -webkit-line-clamp: 2 !important; overflow: hidden !important; word-break: break-word !important; }
.lines-1 { -webkit-line-clamp: 1 !important; }
.lines-2 { -webkit-line-clamp: 2 !important; }
.lines-3 { -webkit-line-clamp: 3 !important; }
.lines-4 { -webkit-line-clamp: 4 !important; }
.lines-5 { -webkit-line-clamp: 5 !important; }

.overflow-hidden { overflow: hidden !important; }
.overflow-visible { overflow: visible !important; }

.height-100 { height: 100% !important; }
.height-auto { height: auto !important; }
.height-full { height: 100% !important; overflow-y: auto !important; }
.width-100 { width: 100%; }

.flexbox-centered {
    align-items: center;
    border-radius: inherit;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    text-align: center;
    width: 100%;
}

.flex-grow-1 { flex-grow: 1 !important; }
.flex-wrap-wrap { flex-wrap: wrap !important; }

.letter-spacing-1 { letter-spacing: 1px; }
.line-height-1 { line-height: 1 !important; }

.text-align-start { text-align: start !important; }
.text-align-end { text-align: end !important; }

.vertical-align-middle { vertical-align: middle !important; }

.white-space-normal { white-space: normal !important; }
.white-space-nowrap { white-space: nowrap !important; }

.z-index-0 { z-index: 0 !important; }
.z-index-1 { z-index: 1 !important; }
.z-index-10 { z-index: 10 !important; }
.z-index-100 { z-index: 100 !important; }
.z-index-1000 { z-index: 1000 !important; }

.user-select-none {
    user-select: none;
}

.mask {
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: contain;
    mask-size: contain;
}

.mask-squircle {
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}`, "",{"version":3,"sources":["webpack://./client/styles/app.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAkGC;;AAED;;;;CAIC;;AAED;;;;;IAKI,0BAA0B;AAC9B;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,QAAQ;AACZ;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,QAAQ;IACR,eAAe;IACf,gDAAgD;AACpD;;AAEA;;IAEI,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;CAIC;;AAED;IACI,wCAAwC;IACxC,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;IAClD,mCAAmC;IACnC,iDAAiD;AACrD;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;;;CAIC;;AAED;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;;CAIC;;AAED;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;CAIC;;AAED;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,gCAAgC;IAChC,gBAAgB;IAChB,6DAA6D;AACjE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;IAC1C,+BAA+B;AACnC;;AAEA;IACI,sDAAsD;IACtD,4BAA4B;AAChC;;AAEA;IACI,sDAAsD;IACtD,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,gDAAgD;IAChD,oDAAoD;IACpD,4CAA4C;IAC5C,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,oCAAoC;IACpC,sDAAsD;IACtD,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,qDAAqD;AACzD;;AAEA;IACI,uCAAuC;IACvC,SAAS;AACb;;AAEA;;;;CAIC;;AAED;IACI,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,qNAAqN;IACrN,+MAA+M;AACnN;;AAEA;IACI,mLAAmL;IACnL,6KAA6K;AACjL;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,iDAAiD;AACrD;;AAEA;;;;CAIC;;AAED;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;;;CAIC;;AAED;IACI,kEAAkE;IAClE,yDAAyD;IACzD,uEAAuE;IACvE,uEAAuE;IACvE,0EAA0E;AAC9E;;AAEA;IACI,6CAA6C;IAC7C,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,wEAAwE;AAC5E;;AAEA;IACI,yEAAyE;AAC7E;;AAEA;;;IAGI,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;;CAIC;;AAED;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;IACjC,kCAAkC;IAClC,iCAAiC;IACjC,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;IACxB,kCAAkC;IAClC,sDAAsD;AAC1D;;AAEA;IACI,wDAAwD;IACxD,2DAA2D;AAC/D;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mFAAmF;AACvF;;AAEA;IACI,oFAAoF;AACxF;;AAEA;IACI,oFAAoF;AACxF;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;;IAII,UAAU;IACV,wJAAwJ;AAC5J;;AAEA;;IAEI,uCAAuC;AAC3C;;AAEA;;IAEI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;IACI,iGAAiG;AACrG;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;;;CAIC;;AAED;IACI,4DAA4D;IAC5D,mDAAmD;IACnD,gCAAgC;IAChC,kCAAkC;IAClC,iCAAiC;IACjC,sCAAsC;IACtC,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,oDAAoD;IACpD,qDAAqD;AACzD;;AAEA;IACI,uDAAuD;IACvD,wDAAwD;AAC5D;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,0FAA0F;IAC1F,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;;;;CAIC;;AAED;IACI,kEAAkE;AACtE;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;;IAGI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;;;CAIC;;AAED;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,SAAS;IACT,0JAA0J;AAC9J;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,kDAAkD;IAClD,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,+CAA+C;AACnD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,sDAAsD;AAC1D;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;;IAEI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,4DAA4D;IAC5D,0DAA0D;IAC1D,0DAA0D;AAC9D;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;IACnB,yDAAyD;IACzD,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,gDAAgD;IAChD,aAAa;IACb,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,2DAA2D;IAC3D,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,kCAAkC;IAClC,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;AACf;;AAEA;;IAEI,SAAS;IACT,WAAW;AACf;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;;IAEI,6DAA6D;IAC7D,2DAA2D;IAC3D,oBAAoB;AACxB;;AAEA;;IAEI,2DAA2D;IAC3D,UAAU;AACd;;AAEA;;IAEI,2DAA2D;AAC/D;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;;;CAIC;;AAED;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,6DAA6D;AACjE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,uDAAuD;IACvD,4BAA4B;AAChC;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,qDAAqD;AACzD;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,6CAA6C;IAC7C,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,oDAAoD;AACxD;;AAEA;IACI,2BAA2B;IAC3B,0DAA0D;AAC9D;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yCAAyC;IACzC,6BAA6B;IAC7B,qDAAqD;AACzD;;AAEA;IACI,yDAAyD;IACzD,2CAA2C;IAC3C,qDAAqD;AACzD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,6BAA6B;IAC7B,qDAAqD;AACzD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;CAIC;;AAED;;;IAGI,sCAAsC;IACtC,wCAAwC;AAC5C;;AAEA;;;;CAIC;;AAED;IACI,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,uCAAuC;IACvC,yCAAyC;IACzC,wCAAwC;IACxC,sCAAsC;IACtC,wCAAwC;IACxC,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;;;;CAIC;;AAED;IACI,+DAA+D;AACnE;;AAEA;IACI,iCAAiC;IACjC,+BAA+B;IAC/B,wCAAwC;IACxC,gCAAgC;IAChC,kCAAkC;IAClC,wCAAwC;IACxC,6CAA6C;IAC7C,8CAA8C;AAClD;;AAEA;;;IAGI,+CAA+C;IAC/C,sDAAsD;AAC1D;;AAEA;IACI,+CAA+C;IAC/C,yCAAyC;IACzC,6CAA6C;IAC7C,wCAAwC;IACxC,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wCAAwC;IACxC,OAAO;IACP,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;;;;CAIC;;AAED;IACI,0EAA0E;IAC1E,OAAO;IACP,WAAW;AACf;;AAEA;IACI,0EAA0E;IAC1E,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;CAIC;;AAED;IACI,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,kCAAkC;IAClC,sCAAsC;IACtC,sDAAsD;AAC1D;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,uDAAuD;IACvD,YAAY;IACZ,WAAW;IACX,cAAc;IACd,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,yDAAyD;IACzD,0BAA0B;IAC1B,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;;;CAIC;;AAED;IACI,2BAA2B;IAC3B,WAAW;IACX,gDAAgD;IAChD,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,kCAAkC;IAClC,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;;CAIC;;AAED;IACI,oEAAoE;IACpE,qLAAqL;IACrL,qLAAqL;IACrL,qLAAqL;IACrL,sLAAsL;IACtL,sLAAsL;IACtL,uLAAuL;IACvL,uLAAuL;IACvL,uLAAuL;IACvL,uLAAuL;IACvL,yLAAyL;IACzL,yLAAyL;IACzL,yLAAyL;IACzL,yLAAyL;IACzL,yLAAyL;IACzL,yLAAyL;IACzL,0LAA0L;IAC1L,0LAA0L;IAC1L,0LAA0L;IAC1L,0LAA0L;IAC1L,2LAA2L;IAC3L,2LAA2L;IAC3L,2LAA2L;IAC3L,2LAA2L;IAC3L,2LAA2L;AAC/L;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;;CAIC;;AAED;IACI,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,qCAAqC;IACrC,iBAAiB;IACjB,iFAAiF;IACjF,mFAAmF;IACnF,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;IACxC,gDAAgD;IAChD,6CAA6C;AACjD;;AAEA;IACI,kDAAkD;IAClD,qFAAqF;IACrF,uFAAuF;IACvF,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,gDAAgD;IAChD,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,wCAAwC;IACxC,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,iDAAiD;AACrD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;;;;CAIC;;AAED;IACI,gEAAgE;IAChE,qCAAqC;IACrC,wEAAwE;IACxE,oEAAoE;IACpE,uEAAuE;IACvE,yCAAyC;IACzC,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;CAIC;;AAED;IACI,uBAAuB;IACvB,2CAA2C;IAC3C,gBAAgB;IAChB,sBAAsB;IACtB,mCAAmC;IACnC,6CAA6C;IAC7C,8EAA8E;IAC9E,gFAAgF;IAChF,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,mCAAmC;IACnC,2BAA2B;IAC3B,yCAAyC;IACzC,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,0FAA0F;IAC1F,kBAAkB;IAClB,WAAW;AACf;;AAEA;;;;CAIC;;AAED;IACI,8BAA8B;AAClC;;AAEA;IACI,uCAAuC;IACvC,6CAA6C;AACjD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;;IAGI,UAAU;IACV,WAAW;AACf;;AAEA;;;IAGI,SAAS;AACb;;AAEA;;;IAGI,SAAS;AACb;;AAEA;IACI,UAAU;IACV,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;;;;CAIC;;AAED;IACI,8DAA8D;AAClE;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,wCAAwC;IACxC,mCAAmC;AACvC;;AAEA;IACI,oDAAoD;IACpD,gEAAgE;IAChE,sDAAsD;IACtD,iEAAiE;AACrE;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;;;IAGI,wDAAwD;IACxD,yDAAyD;AAC7D;;AAEA;IACI,+CAA+C;IAC/C,YAAY;AAChB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;;IAGI,0CAA0C;AAC9C;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,SAAS;AACb;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;;;IAII,8FAA8F;AAClG;;AAEA;;;;IAII,gGAAgG;AACpG;;AAEA;;;;;;;;IAQI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;IAGI,8DAA8D;IAC9D,4DAA4D;AAChE;;AAEA;;;;CAIC;;AAED;IACI,gDAAgD;AACpD;;AAEA;;;;CAIC;;AAED;IACI,kBAAkB;AACtB;;AAEA;;;;CAIC;;AAED;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;;;;CAIC;;AAED;;IAEI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;;;;CAIC;;AAED;IACI,mCAAmC;IACnC,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kIAAkI;IAClI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,0CAA0C;IAC1C,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;IACvC,iDAAiD;IACjD,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,6CAA6C;IAC7C,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+FAA+F;IAC/F,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gGAAgG;AACpG;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;CAIC;;AAED;IACI,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;;;;CAIC;;AAED;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,0DAA0D;IAC1D,kDAAkD;IAClD,kBAAkB;IAClB,kEAAkE;IAClE,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,sDAAsD;IACtD,uCAAuC;IACvC,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI;QACI,mEAAmE;IACvE;IACA;QACI,kEAAkE;IACtE;AACJ;;AAEA;IACI;QACI,mEAAmE;IACvE;IACA;QACI,kEAAkE;IACtE;AACJ;;AAEA;;;;CAIC;;AAED;IACI,cAAc;AAClB;;AAEA;;;;CAIC;;AAED;IACI,yBAAyB;IACzB,kDAAkD;IAClD,4EAA4E;AAChF;;AAEA;IACI,yBAAyB;IACzB,kDAAkD;IAClD,4EAA4E;AAChF;;AAEA;IACI,yBAAyB;IACzB,kDAAkD;IAClD,sBAAsB;IACtB,+CAA+C;AACnD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,yCAAyC;IACzC,iDAAiD;IACjD,gBAAgB;IAChB,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;IAC1C,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;;;;CAIC;;AAED;IACI,gCAAgC;IAChC,mCAAmC;IACnC,6BAA6B;IAC7B,oCAAoC;IACpC,4CAA4C;IAC5C,6CAA6C;IAC7C,kFAAkF;IAClF,yCAAyC;IACzC,0CAA0C;IAC1C,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;IACpC,4CAA4C;IAC5C,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,6DAA6D;IAC7D,uCAAuC;IACvC,uEAAuE;AAC3E;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yDAA0a;AAC9a;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kFAAkF;AACtF;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,8CAA8C;IAC9C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,4EAA4E;IAChF;AACJ;;AAEA;IACI,yFAAyF;AAC7F;;AAEA;IACI,8EAA8E;IAC9E,gFAAgF;AACpF;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uDAAuD;IACvD,+DAA+D;AACnE;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,uEAAuE;AAC3E;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,4CAA4C;AAChD;;AAEA;;;;CAIC;;AAED;IACI,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6CAA6C;IAC7C,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;;;CAIC;;AAED;IACI,6CAA6C;IAC7C,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;CAIC;;AAED;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mDAAmD;IACnD,eAAe;AACnB;;AAEA;IACI,mDAAmD;IACnD,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;;;CAIC;;AAED;IACI,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,uCAAuC;IACvC,mCAAmC;IACnC,2CAA2C;IAC3C,2CAA2C;IAC3C,wCAAwC;IACxC,yCAAyC;IACzC,4DAA4D;IAC5D,gDAAgD;IAChD,yCAAyC;IACzC,0CAA0C;IAC1C,6DAA6D;IAC7D,mEAAmE;IACnE,mEAAmE;AACvE;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,sDAAsD;IACtD,gDAAgD;IAChD,mEAAmE;IACnE,mEAAmE;AACvE;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;IACtB,+CAA+C;AACnD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;;CAIC;;AAED;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI;QACI,kDAAkD;QAClD,qDAAqD;IACzD;IACA;QACI,kDAAkD;IACtD;IACA;QACI,qDAAqD;IACzD;IACA;QACI,wBAAwB;QACxB,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,oDAAoD;QACpD,uDAAuD;IAC3D;IACA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;AACJ;;AAEA;;;;CAIC;;AAED;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;;;;CAIC;;AAED;IACI,4CAA4C;IAC5C,6BAA6B;IAC7B,oDAAoD;IACpD,sDAAsD;AAC1D;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,wDAAwD;IACxD,6BAA6B;IAC7B,0DAA0D;IAC1D,4DAA4D;AAChE;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,8GAA8G;IAC9G,OAAO;IACP,WAAW;AACf;;AAEA;IACI,mHAAmH;IACnH,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,yDAAyD;IACzD,0BAA0B;IAC1B,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,0DAA0D;IAC1D,OAAO;IACP,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;;;;CAIC;;AAED;;;;IAII,yDAAyD;IACzD,uEAAuE;AAC3E;;AAEA;;;;IAII,yDAAyD;IACzD,uEAAuE;AAC3E;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;CAIC;;AAED;IACI,mCAAmC;IACnC,iCAAiC;IACjC,wCAAwC;IACxC,0CAA0C;AAC9C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;CAIC;;AAED;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,oCAAoC;IACpC,qCAAqC;IACrC,uCAAuC;IACvC,yCAAyC;IACzC,2CAA2C;AAC/C;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,oCAAoC;IACpC,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;;;CAIC;;AAED;IACI,uBAAuB;IACvB,iDAAiD;IACjD,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,mDAAmD;IACnD,4DAA4D;IAC5D,uFAAuF;IACvF,yFAAyF;IACzF,yDAAyD;AAC7D;;AAEA;IACI,sCAAsC;IACtC,kDAAkD;AACtD;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kDAAkD;IAClD,qFAAqF;IACrF,uFAAuF;IACvF,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,OAAO;IACP,eAAe;IACf,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,cAAc;IACd,8DAA8D;AAClE;;AAEA;IACI,4BAA4B;IAC5B,8DAA8D;AAClE;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iCAAiC;IACjC,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;;;;CAIC;;AAED;IACI,2CAA2C;AAC/C;;AAEA;IACI,iCAAiC;IACjC,4EAA4E;IAC5E,2CAA2C;IAC3C,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;IACxC,6CAA6C;AACjD;;AAEA;IACI,sCAAsC;IACtC,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iDAAiD;AACrD;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,wDAAwD;IACxD,4BAA4B;AAChC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;;CAIC;;AAED;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,4EAA4E;IAC5E,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kKAAkK;IAClK,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;CAIC;;AAED;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;;CAIC;;AAED;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,eAAe;IACf,yCAAyC;IACzC,iBAAiB;IACjB,iFAAiF;IACjF,mFAAmF;IACnF,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,sCAAsC;IACtC,uBAAuB;IACvB,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;;;CAIC;;AAED;IACI,kBAAkB;AACtB;;AAEA;;;;CAIC;;AAED;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;CAIC;;AAED;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;;;CAIC;;AAED;;;;;;IAMI,+BAA+B;AACnC;;AAEA;;;;CAIC;;AAED;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;;IAGI,OAAO;AACX;;AAEA;;;IAGI,QAAQ;AACZ;;AAEA;;;IAGI,MAAM;AACV;;AAEA;;;IAGI,SAAS;AACb;;AAEA;;;IAGI,SAAS;IACT,2BAA2B;AAC/B;;AAEA;;;IAGI,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,4CAA4C;AAChD;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,wBAAwB;QACxB,gBAAgB;QAChB,QAAQ;QACR,aAAa;IACjB;AACJ;;AAEA;;;;CAIC;;AAED;IACI,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;;;CAIC;;AAED;IACI,8CAA8C;IAC9C,mCAAmC;IACnC,4BAA4B;AAChC;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;;;;IAOI,4BAA4B;AAChC;;AAEA;IACI,qEAAqE;AACzE;;AAEA;IACI;QACI,gCAAgC;IACpC;IACA;QACI,iCAAiC;IACrC;AACJ;;AAEA;;;;CAIC;;AAED;IACI,6BAA6B;AACjC;;AAEA;;;;CAIC;;AAED;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iDAAiD;IACjD,kCAAkC;IAClC,mBAAmB;IACnB,gDAAgD;IAChD,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,mDAAmD;IACnD,gDAAgD;IAChD,iFAAiF;IACjF,mFAAmF;IACnF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,0FAA0F;IAC1F,qFAAqF;IACrF,uFAAuF;IACvF,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,2EAA2E;AAC/E;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,2EAA2E;AAC/E;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,gDAAgD;IAChD,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,uCAAuC;IACvC,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;;CAIC;;AAED;IACI,gDAAgD;IAChD,oCAAoC;AACxC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;;CAIC;;AAED;IACI,UAAU;AACd;;AAEA;;;;CAIC;;AAED;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,WAAW;AACf;;AAEA;IACI,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;;CAIC;;AAED;IACI,mCAAmC;IACnC,2CAA2C;IAC3C,wBAAwB;AAC5B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,cAAc;IACd,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,yGAAyG;AAC7G;;AAEA;IACI,QAAQ;IACR,MAAM;IACN,UAAU;IACV,YAAY;IACZ,wGAAwG;AAC5G;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,UAAU;IACV,SAAS;IACT,yGAAyG;AAC7G;;AAEA;IACI,OAAO;IACP,SAAS;IACT,WAAW;IACX,SAAS;IACT,0GAA0G;AAC9G;;AAEA;IACI,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,2EAA2E;AAC/E;;AAEA;IACI,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,2EAA2E;AAC/E;;AAEA;IACI,QAAQ;IACR,QAAQ;IACR,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI,SAAS;IACT,SAAS;IACT,SAAS;IACT,WAAW;IACX,0EAA0E;AAC9E;;AAEA;IACI,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,yGAAyG;AAC7G;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,0GAA0G;AAC9G;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,SAAS;IACT,UAAU;IACV,yGAAyG;AAC7G;;AAEA;IACI,SAAS;IACT,OAAO;IACP,SAAS;IACT,WAAW;IACX,wGAAwG;AAC5G;;AAEA;IACI,gFAAgF;AACpF;;AAEA;IACI,gFAAgF;AACpF;;AAEA;IACI,gFAAgF;AACpF;;AAEA;IACI,gFAAgF;AACpF;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,2CAA2C;IAC3C,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,2CAA2C;IAC3C,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,wCAAwC;IACxC,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,wCAAwC;IACxC,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,wCAAwC;IACxC,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,OAAO;IACP,WAAW;IACX,2CAA2C;IAC3C,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,yCAAyC;IACzC,WAAW;IACX,MAAM;IACN,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,UAAU;IACV,0CAA0C;IAC1C,MAAM;IACN,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,wCAAwC;IACxC,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,2CAA2C;IAC3C,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,yCAAyC;IACzC,WAAW;IACX,SAAS;IACT,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,UAAU;IACV,0CAA0C;IAC1C,SAAS;IACT,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,0CAA0C;IAC1C,MAAM;IACN,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,yCAAyC;IACzC,WAAW;IACX,MAAM;IACN,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yCAAyC;IACzC,WAAW;IACX,SAAS;IACT,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,0CAA0C;IAC1C,SAAS;IACT,6EAA6E;IAC7E,mEAAmE;AACvE;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,UAAU;IACV,0BAA0B;IAC1B,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,QAAQ;IACR,MAAM;IACN,gCAAgC;IAChC,8BAA8B;IAC9B,yCAAyC;IACzC,uCAAuC;IACvC,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,WAAW;IACX,MAAM;IACN,gCAAgC;IAChC,wCAAwC;IACxC,+BAA+B;IAC/B,uCAAuC;IACvC,4BAA4B;IAC5B,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,WAAW;IACX,MAAM;IACN,gCAAgC;IAChC,wCAAwC;IACxC,+BAA+B;IAC/B,uCAAuC;IACvC,4BAA4B;IAC5B,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,QAAQ;IACR,MAAM;IACN,gCAAgC;IAChC,8BAA8B;IAC9B,yCAAyC;IACzC,uCAAuC;IACvC,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;IACzB,gCAAgC;IAChC,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,0CAA0C;IAC1C,8BAA8B;IAC9B,yCAAyC;IACzC,6BAA6B;IAC7B,4BAA4B;IAC5B,mCAAmC;IACnC,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,OAAO;IACP,WAAW;IACX,SAAS;IACT,0CAA0C;IAC1C,wCAAwC;IACxC,+BAA+B;IAC/B,6BAA6B;IAC7B,kCAAkC;IAClC,6BAA6B;IAC7B,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;;CAIC;;AAED;IACI,4DAA4D;IAC5D,qBAAqB;AACzB;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;IACvC,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;CAIC;;AAED;IACI,oCAAoC;IACpC,2FAA2F;AAC/F;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;;;;CAIC;;AAED;IACI,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;;;;CAIC;;AAED;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,iCAAiC;IACjC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,6CAA6C;IAC7C,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;;;CAIC;;AAED;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,4BAA4B;IAC5B,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,qDAAqD;AACzD;;AAEA;;;;CAIC;;AAED;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;IAC1C,uBAAuB;AAC3B;;AAEA;IACI,kFAAkF;AACtF;;AAEA;IACI,mFAAmF;AACvF;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;;;CAIC;;AAED;IACI,uCAAuC;IACvC,kDAAkD;IAClD,WAAW;IACX,WAAW;IACX,SAAS;IACT,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;;AAEA;;;;CAIC;;AAED;IACI,4BAA4B;AAChC;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;;;;CAIC;;AAED;IACI,iDAAiD;IACjD,0CAA0C;IAC1C,oFAAoF;IACpF,sFAAsF;IACtF,uCAAuC;IACvC,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;;CAIC;;AAED;IACI,kBAAkB;AACtB;;AAEA;;;;CAIC;;AAED;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;CAIC;;AAED;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,+BAA+B;IAC/B,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,kFAAkF;AACtF;;AAEA;IACI,kFAAkF;AACtF;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,SAAS;AACb;;AAEA;;IAEI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,uEAAuE;IACvE,wEAAwE;IACxE,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,kFAAkF;AACtF;;AAEA;IACI,kFAAkF;AACtF;;AAEA;IACI,oFAAoF;AACxF;;AAEA;;;;;;;;;IASI,uEAAuE;IACvE,eAAe;AACnB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;;;;CAIC;;AAED;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,sCAAsC;IACtC,wCAAwC;AAC5C;;AAEA;;;;CAIC;;AAED;IACI,yDAAyD;AAC7D;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;;;CAIC;;AAED;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;AACxB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,4CAA4C;IAC5C,WAAW;AACf;;AAEA;;IAEI,UAAU;IACV,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,6CAA6C;IAC7C,8CAA8C;IAC9C,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,6CAA6C;IAC7C,8CAA8C;IAC9C,QAAQ;AACZ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+DAA+D;IAC/D,oCAAoC;IACpC,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;;;CAIC;;AAED;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,kCAAkC;AACtC;;AAEA;;;;CAIC;;AAED;IACI,2BAA2B;IAC3B,iCAAiC;IACjC,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;CAIC;;AAED;IACI,0DAA0D;IAC1D,8BAA8B;IAC9B,mCAAmC;AACvC;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,YAAY;IACZ,kDAAkD;IAClD,qFAAqF;IACrF,uFAAuF;IACvF,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;;;;CAIC;;AAED;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;;CAIC;;AAED;IACI,oEAAoE;IACpE,8DAA8D;IAC9D,uDAAuD;IACvD,yCAAyC;IACzC,2CAA2C;IAC3C,kEAAkE;IAClE,uCAAuC;IACvC,kCAAkC;IAClC,oCAAoC;IACpC,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4CAA4C;IAC5C,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,uCAAuC;IACvC,uBAAuB;IACvB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,wHAAwH;IACxH,eAAe;AACnB;;AAEA;;IAEI,cAAc;IACd,yHAAyH;AAC7H;;AAEA;IACI;;QAEI,wHAAwH;QACxH,eAAe;IACnB;IACA;;QAEI,yHAAyH;QACzH,cAAc;IAClB;AACJ;;AAEA;IACI;;QAEI,wHAAwH;QACxH,eAAe;IACnB;IACA;;QAEI,yHAAyH;QACzH,cAAc;IAClB;AACJ;;AAEA;IACI;;QAEI,wHAAwH;QACxH,eAAe;IACnB;IACA;;QAEI,yHAAyH;QACzH,cAAc;IAClB;AACJ;;AAEA;IACI;;QAEI,wHAAwH;QACxH,eAAe;IACnB;IACA;;QAEI,yHAAyH;QACzH,cAAc;IAClB;AACJ;;AAEA;IACI;;QAEI,wHAAwH;QACxH,eAAe;IACnB;IACA;;QAEI,yHAAyH;QACzH,cAAc;IAClB;AACJ;;AAEA;;IAEI,yHAAyH;IACzH,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,wHAAwH;AAC5H;;AAEA;IACI;;QAEI,yHAAyH;QACzH,cAAc;IAClB;IACA;;QAEI,wHAAwH;QACxH,eAAe;IACnB;AACJ;;AAEA;IACI;;QAEI,yHAAyH;QACzH,cAAc;IAClB;IACA;;QAEI,wHAAwH;QACxH,eAAe;IACnB;AACJ;;AAEA;IACI;;QAEI,yHAAyH;QACzH,cAAc;IAClB;IACA;;QAEI,wHAAwH;QACxH,eAAe;IACnB;AACJ;;AAEA;IACI;;QAEI,yHAAyH;QACzH,cAAc;IAClB;IACA;;QAEI,wHAAwH;QACxH,eAAe;IACnB;AACJ;;AAEA;IACI;;QAEI,yHAAyH;QACzH,cAAc;IAClB;IACA;;QAEI,wHAAwH;QACxH,eAAe;IACnB;AACJ;;AAEA;;;;CAIC;;AAED;IACI,aAAa;AACjB;;AAEA;;;;CAIC;;AAED;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI;QACI,SAAS;QACT,wBAAwB;IAC5B;;IAEA;QACI,mCAAmC;QACnC,QAAQ;IACZ;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,6CAA6C;IACjD;;IAEA;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;CAIC;;AAED;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,aAAa;IACb,cAAc;IACd,+BAA+B;IAC/B,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,MAAM;IACN,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;CAIC;;AAED;IACI,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;CAIC;;AAED;IACI,0CAA0C;AAC9C;;AAEA;IACI,gDAAgD;IAChD,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4DAA4D;IAC5D,gCAAgC;AACpC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;;;;CAIC;;AAED;IACI,uDAAuD;IACvD,yDAAyD;IACzD,mDAAmD;IACnD,2BAA2B;AAC/B;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,4CAA4C;IAC5C,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,uDAAuD;IACvD,wDAAwD;IACxD,8BAA8B;IAC9B,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA;IACI,oDAAoD;IACpD,SAAS;IACT,WAAW;IACX,cAAc;IACd,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,yDAAyD;IACzD,0BAA0B;IAC1B,WAAW;IACX,WAAW;AACf;;AAEA;IACI,uCAAuC;IACvC,UAAU;IACV,0CAA0C;IAC1C,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,2CAA2C;IAC3C,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;IAC3C,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,0FAA0F;AAC9F;;AAEA;IACI,0DAA0D;IAC1D,2DAA2D;IAC3D,8BAA8B;IAC9B,sGAAsG;IACtG,kBAAkB;AACtB;;AAEA;IACI,oDAAoD;IACpD,YAAY;IACZ,WAAW;IACX,cAAc;IACd,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,yDAAyD;IACzD,wBAAwB;IACxB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;IAChB,uCAAuC;IACvC,6CAA6C;IAC7C,uCAAuC;IACvC,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,oBAAoB;IACpB,qCAAqC;IACrC,yCAAyC;IACzC,+BAA+B;IAC/B,uBAAuB;IACvB,+CAA+C;IAC/C,iFAAiF;IACjF,SAAS;IACT,qCAAqC;IACrC,UAAU;IACV,gBAAgB;IAChB,8EAA8E;IAC9E,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;IACvB,+CAA+C;IAC/C,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,4CAA4C;IAC5C,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;;;;CAIC;;AAED;IACI,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;CAIC;;AAED;IACI,yBAAyB;IACzB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;CAIC;;AAED;IACI,kBAAkB;AACtB;;AAEA;;;;CAIC;;AAED,4BAA4B,6BAA6B,EAAE,oCAAoC,EAAE;;AAEjG,kBAAkB,kCAAkC,EAAE;AACtD,kBAAkB,2CAA2C,EAAE,mCAAmC,EAAE,2BAA2B,EAAE;AACjI,8CAA8C,wCAAwC,EAAE;;AAExF,mBAAmB,+DAA+D,EAAE;AACpF,uBAAuB,mEAAmE,EAAE;;AAE5F,aAAa,UAAU,EAAE;AACzB,cAAc,aAAa,EAAE;AAC7B,cAAc,YAAY,EAAE;AAC5B,cAAc,aAAa,EAAE;AAC7B,eAAe,UAAU,EAAE;;AAE3B,eAAe,yBAAyB,EAAE;AAC1C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;;AAE5C,oBAAoB,4BAA4B,EAAE;AAClD,sBAAsB,8BAA8B,EAAE;AACtD,mBAAmB,2BAA2B,EAAE;AAChD,mBAAmB,2BAA2B,EAAE;AAChD,mBAAmB,2BAA2B,EAAE;;AAEhD,mBAAmB,qCAAqC,EAAE;AAC1D,kBAAkB,oCAAoC,EAAE;AACxD,eAAe,kBAAkB,EAAE;AACnC,yBAAyB,eAAe,EAAE,+BAA+B,EAAE,6BAA6B,EAAE;;AAE1G,oBAAoB,yBAAyB,EAAE,2BAA2B,EAAE,kCAAkC,EAAE,8BAA8B,EAAE;AAChJ,mBAAmB,+BAA+B,EAAE,uCAAuC,EAAE,gCAAgC,EAAE,2BAA2B,EAAE,iCAAiC,EAAE;AAC/L,WAAW,gCAAgC,EAAE;AAC7C,WAAW,gCAAgC,EAAE;AAC7C,WAAW,gCAAgC,EAAE;AAC7C,WAAW,gCAAgC,EAAE;AAC7C,WAAW,gCAAgC,EAAE;;AAE7C,mBAAmB,2BAA2B,EAAE;AAChD,oBAAoB,4BAA4B,EAAE;;AAElD,cAAc,uBAAuB,EAAE;AACvC,eAAe,uBAAuB,EAAE;AACxC,eAAe,uBAAuB,EAAE,2BAA2B,EAAE;AACrE,aAAa,WAAW,EAAE;;AAE1B;IACI,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA,eAAe,uBAAuB,EAAE;AACxC,kBAAkB,0BAA0B,EAAE;;AAE9C,oBAAoB,mBAAmB,EAAE;AACzC,iBAAiB,yBAAyB,EAAE;;AAE5C,oBAAoB,4BAA4B,EAAE;AAClD,kBAAkB,0BAA0B,EAAE;;AAE9C,yBAAyB,iCAAiC,EAAE;;AAE5D,sBAAsB,8BAA8B,EAAE;AACtD,sBAAsB,8BAA8B,EAAE;;AAEtD,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,cAAc,sBAAsB,EAAE;AACtC,eAAe,uBAAuB,EAAE;AACxC,gBAAgB,wBAAwB,EAAE;;AAE1C;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,8BAA8B;IAC9B,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,2DAA2P;IAC3P,mDAAmP;AACvP","sourcesContent":["/*\n|------------------------------------------------------------------------------\n| TABLE OF CONTENTS\n|------------------------------------------------------------------------------\n| Accordion\n| Action Sheet\n| Audio\n| Autocomplete\n| Badge\n| Bars\n| Body\n| Breadcrumb\n| Button\n| Card\n| Chart\n| Checkbox & Radio\n| Chip\n| Color Picker\n| Content Block\n| Data Table\n| Date-Time Picker\n| Dialog\n| Dropcap\n| Elevation\n| Empty State\n| Expandable Card\n| Flip Card\n| Floating Action Button\n| Form Input\n| Form Validator\n| Gauge\n| Grid\n| Icon\n| Image\n| Image Compare\n| Image Hotspot\n| Infinite Scroll\n| Integrations\n| Keypad\n| Line Divider\n| Link\n| List Index\n| List View\n| Margin & Padding\n| Marquee\n| Menu\n| Menu List\n| Message\n| Navbar\n| Note\n| Notification\n| Overlay Container\n| Page\n| Pagination\n| Photo Browser\n| Picker\n| Popover\n| Popup\n| Position\n| Preloader\n| Progress Bar\n| Pull-to-Refresh\n| Quote\n| Range Slider\n| Rating\n| Responsive Container\n| Ribbon\n| Scroll Bar\n| Searchbar\n| Shape & Size\n| Sheet Modal\n| Show More/Less\n| Side Panel\n| Signature Pad\n| Skeleton\n| Smart Select\n| Sortable List\n| State Toggle\n| Stepper\n| Subnavbar\n| Swipeout\n| Swiper Slider\n| Syntax Highlighter\n| Tab\n| Text Editor\n| Theme\n| Timeline\n| Timer\n| Toast\n| Toggle\n| Toolbar\n| Tooltip\n| Tour Guide\n| Tree View\n| Video\n| Virtual List\n| Utilities\n|------------------------------------------------------------------------------\n*/\n\n/*\n|------------------------------------------------------------------------------\n| Accordion\n|------------------------------------------------------------------------------\n*/\n\n[dir=rtl] .accordion-opposite .accordion-item-toggle.item-content:before,\n[dir=rtl] .accordion-opposite .accordion-item-toggle > .item-content:before,\n[dir=rtl] .accordion-opposite .accordion-item > .item-content:before,\n[dir=rtl] .accordion-opposite .accordion-item > .item-link > .item-content:before,\n[dir=rtl] .accordion-opposite.links-list .accordion-item > a:before {\n    transform: translateX(50%);\n}\n\n.accordion-item.custom-toggle-icon > .item-content > .item-inner,\n.accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner {\n    --f7-list-chevron-icon-area: 0px;\n}\n\n.accordion-item.custom-toggle-icon > .item-content > .item-inner:before,\n.accordion-item.custom-toggle-icon > .item-content > .item-inner > .item-title-row:before ,\n.accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner:before,\n.accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner > .item-title-row:before {\n    display: none;\n}\n\n.accordion-opposite .accordion-item.custom-toggle-icon > .item-content,\n.accordion-opposite .accordion-item.custom-toggle-icon > .item-link > .item-content {\n    --f7-list-chevron-icon-area: 0px;\n}\n\n.accordion-opposite .accordion-item.custom-toggle-icon > .item-content:before,\n.accordion-opposite .accordion-item.custom-toggle-icon > .item-link > .item-content:before {\n    display: none;\n}\n\n.accordion-item.accordion-item-opened.custom-toggle-icon .toggle-icon-open {\n    display: none;\n}\n\n.accordion-item.accordion-item-opened.custom-toggle-icon .toggle-icon-close {\n    display: inline-block;\n}\n\n.accordion-item:not(.accordion-item-opened).custom-toggle-icon .toggle-icon-open {\n    display: inline-block;\n}\n\n.accordion-item:not(.accordion-item-opened).custom-toggle-icon .toggle-icon-close {\n    display: none;\n}\n\n.accordion-opposite .accordion-item.custom-toggle-icon > .item-content > .item-inner,\n.accordion-opposite .accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner {\n    justify-content: flex-start;\n}\n\n.accordion-opposite .accordion-item.custom-toggle-icon > .item-content > .item-inner .item-title,\n.accordion-opposite .accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner .item-title {\n    order: 2;\n}\n\n.accordion-opposite .accordion-item.custom-toggle-icon > .item-content > .item-inner .item-after,\n.accordion-opposite .accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner .item-after {\n    margin-left: 0;\n    margin-right: 0;\n    order: 1;\n    padding-left: 0;\n    padding-right: var(--f7-list-item-after-padding);\n}\n\n[dir=rtl] .accordion-opposite .accordion-item.custom-toggle-icon > .item-content > .item-inner .item-after,\n[dir=rtl] .accordion-opposite .accordion-item.custom-toggle-icon > .item-link > .item-content > .item-inner .item-after {\n    padding-left: var(--f7-list-item-after-padding);\n    padding-right: 0;\n}\n\n.cards-list li.accordion-item {\n    margin: calc(var(--f7-list-margin-vertical) / 4) 0;\n}\n\n.accordion-item-opened .item-title[class*='color-'] {\n    color: var(--f7-theme-color);\n}\n\n.accordion-item-content {\n    font-size: 15px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Action Sheet\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-actions-grid-button-font-size: 14px;\n    --f7-actions-grid-button-icon-size: 24px;\n}\n\n.aurora, .ios, .md {\n    --f7-actions-button-font-size: var(--f7-font-size);\n    --f7-actions-button-icon-size: 24px;\n    --f7-actions-label-font-size: var(--f7-font-size);\n}\n\n.md {\n    --f7-actions-border-radius: 4px;\n    --f7-actions-group-margin: 8px;\n}\n\n[dir=rtl].md {\n    --f7-actions-button-text-align: right;\n}\n\n.actions-group:after {\n    display: none;\n}\n\n.actions-button {\n    align-items: center;\n    height: auto;\n    min-height: var(--f7-actions-button-height);\n}\n\n.aurora .actions-button-media {\n    margin-left: 0;\n}\n\n[dir=rtl].ios .actions-button-media {\n    margin-left: 0;\n    margin-right: 16px;\n}\n\n.md .actions-button-media {\n    min-width: var(--f7-actions-button-icon-size);\n}\n\n[dir=rtl].aurora .actions-button-media + .actions-button-text,\n[dir=rtl].md .actions-button-media + .actions-button-text {\n    margin-left: 0;\n    margin-right: 16px;\n    text-align: right;\n}\n\n[dir=rtl].ios .actions-button-media + .actions-button-text {\n    margin-right: 16px;\n    text-align: right;\n}\n\n.md .actions-button-media + .actions-button-text {\n    text-align: left;\n}\n\n.actions-grid .actions-button {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n}\n\n.actions-grid .actions-button[class*=color-] {\n    color: var(--f7-theme-color);\n}\n\n.actions-grid .actions-button-media {\n    height: auto;\n    width: auto;\n}\n\n.actions-grid .actions-button-text {\n    margin-right: 0 !important;\n}\n\n.actions-grid .actions-label {\n    --f7-actions-label-justify-content: center;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Audio\n|------------------------------------------------------------------------------\n*/\n\naudio {\n    display: block;\n    width: 100%;\n}\n\n.dark audio::-webkit-media-controls-panel {\n    background-color: var(--color-gray-800);\n}\n\n.dark audio::-webkit-media-controls-play-button,\n.dark audio::-webkit-media-controls-mute-button {\n    background-color: var(--color-gray-400);\n    border-radius: 50%;\n}\n\n.dark audio::-webkit-media-controls-current-time-display,\n.dark audio::-webkit-media-controls-time-remaining-display {\n    color: #FFFFFF;\n}\n\n.dark audio::-webkit-media-controls-timeline {\n    background-color: var(--color-gray-600);\n    border-radius: 24px;\n    margin-left: 16px;\n    margin-right: 16px;\n}\n\n.dark audio::-webkit-media-controls-volume-slider {\n    background-color: var(--color-gray-400);\n    border-radius: 24px;\n    margin-right: 8px;\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Autocomplete\n|------------------------------------------------------------------------------\n*/\n\n.autocomplete-dropdown {\n    border-radius: 4px;\n}\n\n.autocomplete-popup .searchbar-backdrop {\n    display: none;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Badge\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-badge-bg-color: var(--color-gray-500);\n}\n\n:root .dark, :root.dark {\n    --f7-badge-bg-color: var(--color-gray-700);\n}\n\n.aurora, .ios, .md {\n    --f7-badge-font-weight: normal;\n    --f7-badge-size: 20px;\n}\n\n.badge {\n    border-radius: 4px;\n    height: auto;\n    line-height: 1;\n    margin: 3px;\n    min-height: var(--f7-badge-size);\n    overflow: hidden;\n    --f7-touch-ripple-color: rgba(var(--f7-color-gray-rgb), 0.25);\n}\n\n.badge[class*=color-] {\n    --f7-touch-ripple-color: rgba(var(--f7-theme-color-rgb), 0.25);\n}\n\n.badge > :not(.ripple-wave) + * {\n    margin-left: 3px;\n    margin-right: 0;\n}\n\n[dir=rtl] .badge > :not(.ripple-wave) + * {\n    margin-left: 0;\n    margin-right: 3px;\n}\n\n.badge-round {\n    border-radius: var(--f7-badge-size);\n    --f7-badge-padding: 0px 8px;\n}\n\n.badge-outline {\n    background: none;\n    border: 1px solid var(--f7-badge-bg-color);\n    color: var(--f7-badge-bg-color);\n}\n\n.badge-fade {\n    background-color: rgba(var(--color-gray-rgb-500), 0.2);\n    color: var(--color-gray-600);\n}\n\n.badge-fade[class*='color-'] {\n    background-color: rgba(var(--f7-theme-color-rgb), 0.2);\n    color: var(--f7-theme-color);\n}\n\n.badge.badge-dot {\n    border-radius: 50%;\n    height: var(--f7-badge-size);\n    overflow: hidden;\n    width: var(--f7-badge-size);\n    --f7-badge-padding: 0px;\n    --f7-badge-size: 10px;\n    --f7-badge-text-color: transparent;\n}\n\n.badge .icon {\n    font-size: var(--f7-badge-font-size) !important;\n}\n\n.icon .badge {\n    margin-top: 0;\n}\n\n[dir=rtl] .icon .badge {\n    left: auto;\n    margin-left: 0;\n    margin-right: -10px;\n    right: 100%;\n}\n\n.button .badge {\n    --f7-badge-bg-color: #FFFFFF;\n    --f7-badge-font-size: var(--f7-button-font-size);\n    --f7-badge-font-weight: var(--f7-button-font-weight);\n    --f7-badge-text-color: var(--f7-theme-color);\n    margin: 0 8px !important;\n}\n\n.badge-wrapper {\n    overflow: visible;\n    position: relative;\n}\n\n.badge-wrapper .badge {\n    left: 100%;\n    margin: 0;\n    position: absolute;\n    top: calc(var(--f7-badge-size) / -2);\n    transform: translateX(calc(var(--f7-badge-size) / -2));\n    --f7-badge-font-size: 0.625rem;\n    --f7-badge-size: 0.625rem;\n}\n\n[dir=rtl] .badge-wrapper .badge {\n    left: auto;\n    right: 100%;\n    transform: translateX(calc(var(--f7-badge-size) / 2));\n}\n\n.badge-wrapper .badge-bottom {\n    bottom: calc(var(--f7-badge-size) / -2);\n    top: auto;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Bars\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-bars-bg-color: #FFFFFF;\n    --f7-bars-bg-color-rgb: 255, 255, 255;\n}\n\n:root {\n    --f7-bars-shadow-bottom-image: linear-gradient(to bottom, rgba(158, 158, 158, 0.1) 0%, rgba(158, 158, 158, 0.05) 40%, rgba(158, 158, 158, 0.025) 50%, rgba(158, 158, 158, 0.0125) 90%, rgba(158, 158, 158, 0.0) 100%);\n    --f7-bars-shadow-top-image: linear-gradient(to top, rgba(158, 158, 158, 0.1) 0%, rgba(158, 158, 158, 0.05) 40%, rgba(158, 158, 158, 0.025) 50%, rgba(158, 158, 158, 0.0125) 90%, rgba(158, 158, 158, 0.0) 100%);\n}\n\n:root .dark, :root.dark {\n    --f7-bars-shadow-bottom-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.16) 0%, rgba(0, 0, 0, 0.08) 40%, rgba(0, 0, 0, 0.04) 50%, rgba(0, 0, 0, 0.02) 90%, rgba(0, 0, 0, 0) 100%);\n    --f7-bars-shadow-top-image: linear-gradient(to top, rgba(0, 0, 0, 0.16) 0%, rgba(0, 0, 0, 0.08) 40%, rgba(0, 0, 0, 0.04) 50%, rgba(0, 0, 0, 0.02) 90%, rgba(0, 0, 0, 0) 100%);\n}\n\n.aurora .dark, .aurora.dark, .ios .dark, .ios.dark, .md .dark, .md.dark {\n    --f7-bars-bg-color: #1C1C1C;\n    --f7-bars-bg-color-rgb: 28, 28, 28;\n}\n\n.aurora, .ios {\n    --f7-bars-border-color: rgba(0, 0, 0, 0.12);\n}\n\n.aurora .dark, .aurora.dark, .ios .dark, .ios.dark {\n    --f7-bars-border-color: rgba(255, 255, 255, 0.12);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Body\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-font-size: 16px;\n    --f7-body-bg-color: #ECEFF1;\n}\n\n:root .dark, :root.dark {\n    --f7-body-bg-color: #000000;\n}\n\nhtml {\n    overscroll-behavior-y: contain;\n}\n\nbody {\n    background: var(--f7-body-bg-color);\n}\n\n.bg-color-body {\n    background-color: var(--f7-body-bg-color) !important;\n}\n\n.text-color-body {\n    color: var(--f7-text-color) !important;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Breadcrumb\n|------------------------------------------------------------------------------\n*/\n\n.breadcrumbs[class*='color-'] {\n    --f7-breadcrumbs-item-color: rgba(var(--f7-theme-color-rgb), 0.55);\n    --f7-breadcrumbs-item-active-color: var(--f7-theme-color);\n    --f7-breadcrumbs-separator-color: rgba(var(--f7-theme-color-rgb), 0.35);\n    --f7-breadcrumbs-collapsed-color: rgba(var(--f7-theme-color-rgb), 0.75);\n    --f7-breadcrumbs-collapsed-bg-color: rgba(var(--f7-theme-color-rgb), 0.15);\n}\n\n.breadcrumbs-item a {\n    border-radius: var(--f7-button-border-radius);\n    overflow: hidden;\n    padding: 0 4px;\n}\n\n.breadcrumbs-item a {\n    --f7-touch-ripple-color: rgba(var(--f7-color-gray-rgb), 0.25) !important;\n}\n\n.breadcrumbs[class*='color-'] .breadcrumbs-item a {\n    --f7-touch-ripple-color: rgba(var(--f7-theme-color-rgb), 0.25) !important;\n}\n\n[dir=rtl] .breadcrumbs-collapsed + .breadcrumbs-collapsed, [dir=rtl] .breadcrumbs-collapsed + .breadcrumbs-item, [dir=rtl] .breadcrumbs-collapsed + .breadcrumbs-separator,\n[dir=rtl] .breadcrumbs-item + .breadcrumbs-collapsed, [dir=rtl] .breadcrumbs-item + .breadcrumbs-item, [dir=rtl] .breadcrumbs-item + .breadcrumbs-separator,\n[dir=rtl] .breadcrumbs-separator + .breadcrumbs-collapsed, [dir=rtl] .breadcrumbs-separator + .breadcrumbs-item, [dir=rtl] .breadcrumbs-separator + .breadcrumbs-separator {\n    margin-left: 0;\n    margin-right: var(--f7-breadcrumbs-spacing);\n}\n\n.breadcrumbs-separator.separator-dot:after {\n    content: '\\2022';\n    font-family: var(--f7-font-family);\n    font-weight: bold;\n}\n\n.breadcrumbs-separator.separator-slash:after {\n    content: '\\002F';\n    font-family: var(--f7-font-family);\n    font-weight: bold;\n}\n\n[dir=rtl] .breadcrumbs-separator:after {\n    transform: scaleX(-1);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Button\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-button-min-width: auto;\n    --f7-button-small-outline-border-width: 1px;\n}\n\n:root .dark, :root.dark {\n    --f7-button-raised-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24), 0 1px 2px rgba(0, 0, 0, 0.48);\n}\n\n.aurora, .ios, .md {\n    --f7-button-font-size: 14px;\n    --f7-button-font-weight: 500;\n    --f7-button-large-font-size: 14px;\n    --f7-button-large-font-weight: 600;\n    --f7-button-small-font-size: 12px;\n    --f7-button-small-font-weight: normal;\n    --f7-button-padding-horizontal: 16px;\n}\n\n.aurora {\n    --f7-button-letter-spacing: 0.025em;\n}\n\n.ios {\n    --f7-button-height: 36px;\n    --f7-button-letter-spacing: 0.01em;\n    --f7-segmented-strong-button-text-transform: uppercase;\n}\n\n.ios .button-small-ios.button-fill, .ios .button-small.button-fill, .ios .button-small.button-fill-ios {\n    --f7-button-pressed-bg-color: var(--f7-theme-color-tint);\n    --f7-button-pressed-text-color: var(--f7-button-text-color);\n}\n\n.button-fade {\n    --f7-button-bg-color: rgba(var(--f7-theme-color-rgb), 0.125);\n}\n\n.button-preloader.button-loading {\n    pointer-events: none;\n}\n\n.button-icon {\n    height: var(--f7-button-height);\n    width: var(--f7-button-height);\n}\n\n.button > :not(.ripple-wave) + * {\n    margin-left: 4px;\n    margin-right: 0;\n}\n\n[dir=rtl] .button > :not(.ripple-wave) + * {\n    margin-left: 0;\n    margin-right: 4px;\n}\n\n.button-social {\n    justify-content: space-between;\n}\n\n.button-social > span:not(.icon) {\n    flex-grow: 1;\n}\n\n.button > img, .button > svg {\n    height: calc((var(--f7-button-height) - var(--f7-button-padding-horizontal)) / 1.5);\n}\n\n.button-large > img, .button-large > svg {\n    height: calc((var(--f7-button-height) - var(--f7-button-padding-horizontal)) / 1.75);\n}\n\n.button-small > img, .button-small > svg {\n    height: calc((var(--f7-button-height) - var(--f7-button-padding-horizontal)) / 1.25);\n}\n\n.segmented-strong .button {\n    --f7-touch-ripple-color: rgba(var(--f7-color-gray-rgb), 0.25);\n}\n\n.aurora .segmented-round, .ios .segmented-round, .md .segmented-round {\n    border-radius: var(--f7-button-large-height);\n}\n\n.segmented-round .segmented-highlight {\n    border-radius: inherit;\n}\n\n[dir=rtl] .aurora .segmented-strong-aurora .segmented-highlight,\n[dir=rtl] .ios .segmented-strong-ios .segmented-highlight,\n[dir=rtl] .md .segmented-strong-md .segmented-highlight,\n[dir=rtl] .segmented-strong .segmented-highlight {\n    left: auto;\n    transform: translateX(calc(var(--f7-segmented-highlight-active) * -100% - var(--f7-segmented-highlight-active) * var(--f7-segmented-highlight-between)));\n}\n\n.segmented-strong .button.button-active,\n.segmented-strong .button.tab-link-active {\n    --f7-button-hover-bg-color: transparent;\n}\n\n.segmented-strong[class*='color-'] .button.button-active,\n.segmented-strong[class*='color-'] .button.tab-link-active {\n    --f7-button-bg-color: var(--f7-theme-color);\n    color: #FFFFFF;\n}\n\n.segmented-strong[class*='color-'] .segmented-highlight {\n    --f7-segmented-strong-button-active-box-shadow: 0px 2px 2px rgba(var(--f7-theme-color-rgb), 0.25);\n}\n\n.aurora.device-desktop .segmented-strong[class*='color-'] .button:not(.active-state):not(.no-hover):hover {\n    background-color: var(--f7-theme-color);\n}\n\n.aurora.device-desktop .segmented-strong[class*='color-'] .button:not(.button-active):not(.tab-link-active):not(.active-state):not(.no-hover):hover {\n    background-color: rgba(0, 0, 0, 0.04);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Card\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-card-border-radius: var(--f7-block-inset-border-radius);\n    --f7-card-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n    --f7-card-header-font-size: 18px;\n    --f7-card-header-font-weight: bold;\n    --f7-card-header-min-height: 48px;\n    --f7-card-header-padding-vertical: 8px;\n    --f7-card-footer-font-size: 14px;\n    --f7-card-footer-min-height: 48px;\n    --f7-card-footer-padding-vertical: 12px;\n}\n\n.card-media {\n    align-items: flex-start;\n    color: #FFFFFF;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: flex-end;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n}\n\n.card > .card-media:first-child {\n    border-top-left-radius: var(--f7-card-border-radius);\n    border-top-right-radius: var(--f7-card-border-radius);\n}\n\n.card > .card-media:last-child {\n    border-bottom-left-radius: var(--f7-card-border-radius);\n    border-bottom-right-radius: var(--f7-card-border-radius);\n}\n\n.card-media-content {\n    box-sizing: border-box;\n    color: #FFFFFF;\n    padding: var(--f7-card-content-padding-vertical) var(--f7-card-content-padding-horizontal);\n    position: relative;\n    width: 100%;\n    z-index: 1000;\n}\n\n.card-media > * ~ .card-media-content {\n    position: absolute;\n}\n\n.card-title {\n    font-size: 22px;\n    font-weight: bold;\n}\n\n.card-subtitle {\n    font-size: 16px;\n}\n\n.card-text {\n    color: var(--f7-card-footer-text-color);\n    font-size: 14px;\n}\n\n.card-title + .card-subtitle, .card-title + .card-text, .card-subtitle + .card-text {\n    margin-top: 4px;\n}\n\n.card-footer > * + * {\n    margin-left: 4px;\n    margin-right: 0;\n}\n\n[dir=rtl] .card-footer > * + * {\n    margin-left: 0;\n    margin-right: 4px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Chart\n|------------------------------------------------------------------------------\n*/\n\n:root .dark, :root.dark {\n    --f7-area-chart-tooltip-total-label-text-color: rgba(0, 0, 0, 0.5);\n}\n\n[dir=rtl] .area-chart svg {\n    transform: scaleX(-1);\n}\n\n[dir=rtl] .area-chart-tooltip,\n[dir=rtl] .pie-chart-tooltip {\n    text-align: right;\n}\n\n[dir=rtl] .area-chart-tooltip-list span,\n[dir=rtl] .area-chart-legend-item span,\n[dir=rtl] .pie-chart-tooltip-color {\n    margin-left: 4px;\n    margin-right: 0;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Checkbox & Radio\n|------------------------------------------------------------------------------\n*/\n\n.checkbox,\n.radio {\n    --f7-touch-ripple-color: transparent;\n}\n\n.checkbox-inline,\n.radio-inline {\n    display: inline-flex;\n}\n\n.aurora .checkbox-inline, .md .checkbox-inline,\n.aurora .radio-inline, .md .radio-inline {\n    line-height: 1;\n}\n\n.checkbox-inline > .icon-checkbox,\n.radio-inline > .icon-radio {\n    margin-left: 0;\n    margin-right: 4px;\n}\n\n[dir=rtl] .checkbox-inline > .icon-checkbox,\n[dir=rtl] .radio-inline > .icon-radio {\n    margin-left: 4px;\n    margin-right: 0;\n}\n\n.checkbox-list .item-checkbox,\n.radio-list .item-radio {\n    padding: 0;\n}\n\n.checkbox-list .item-inner,\n.radio-list .item-inner {\n    margin: 0;\n    padding: var(--f7-list-item-padding-vertical) calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left) - var(--menu-list-offset)) !important;\n}\n\n.checkbox-list .item-checkbox, .checkbox-list .item-checkbox .item-inner,\n.radio-list .item-radio, .radio-list .item-radio .item-inner {\n    border-radius: inherit;\n}\n\n.checkbox-list.checkbox-fill .item-checkbox input:checked ~ .item-inner,\n.radio-list.radio-fill .item-radio input:checked ~ .item-inner {\n    background-color: var(--f7-theme-color) !important;\n    color: #FFFFFF !important;\n}\n\n.checkbox-list.checkbox-fill .item-checkbox input:checked ~ .item-inner .icon-checkbox {\n    --f7-checkbox-active-color: #FFFFFF;\n    --f7-checkbox-icon-color: var(--f7-theme-color);\n}\n\n.radio-list.radio-fill .item-radio input:checked ~ .item-inner .icon-radio {\n    --f7-radio-active-color: #FFFFFF;\n}\n\n.aurora .radio-list.radio-fill .item-radio input:checked ~ .item-inner .icon-radio:after {\n    background-color: var(--f7-theme-color);\n}\n\n.checkbox-list.checkbox-outline .item-checkbox input ~ .item-inner,\n.radio-list.radio-outline .item-radio input ~ .item-inner {\n    border: 2px solid rgba(var(--f7-color-gray-rgb), 0.25);\n}\n\n.checkbox-list.checkbox-outline .item-checkbox input:checked ~ .item-inner,\n.radio-list.radio-outline .item-radio input:checked ~ .item-inner {\n    border-color: var(--f7-theme-color) !important;\n}\n\n.checkbox-media,\n.radio-media {\n    display: inline-block;\n    font-size: 14px;\n    position: relative;\n    text-align: center;\n    --f7-checkbox-radio-media-border-color: var(--f7-color-gray);\n    --f7-checkbox-radio-media-icon-color: var(--f7-color-gray);\n    --f7-checkbox-radio-media-text-color: var(--f7-color-gray);\n}\n\n.checkbox-media input,\n.radio-media input {\n    display: none;\n}\n\n.checkbox-media .checkbox-inner,\n.radio-media .radio-inner {\n    align-items: center;\n    border-color: var(--f7-checkbox-radio-media-border-color);\n    border-style: solid;\n    border-width: 4px;\n    box-sizing: border-box;\n    color: var(--f7-checkbox-radio-media-text-color);\n    display: flex;\n    filter: grayscale(1);\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n    text-align: center;\n}\n\n.checkbox-media .checkbox-inner:after,\n.radio-media .radio-inner:after {\n    align-items: center;\n    background-color: var(--f7-checkbox-radio-media-icon-color);\n    border-radius: 50%;\n    color: #FFFFFF;\n    content: 'checkbox_md';\n    display: flex;\n    font-family: framework7-core-icons;\n    font-size: 10px;\n    height: 16px;\n    justify-content: center;\n    left: auto;\n    opacity: 0;\n    position: absolute;\n    right: 6px;\n    top: 6px;\n    width: 16px;\n}\n\n[dir=rtl] .checkbox-media .checkbox-inner:after,\n[dir=rtl] .radio-media .radio-inner:after {\n    left: 6px;\n    right: auto;\n}\n\n.checkbox-media .checkbox-inner img,\n.radio-media .radio-inner img {\n    border-radius: inherit;\n}\n\n.checkbox-media .checkbox-label,\n.radio-media .radio-label {\n    color: var(--f7-checkbox-radio-media-text-color);\n    margin-top: 2px;\n}\n\n.checkbox-media input:checked ~ .checkbox-inner,\n.radio-media input:checked ~ .radio-inner {\n    --f7-checkbox-radio-media-border-color: var(--f7-theme-color);\n    --f7-checkbox-radio-media-text-color: var(--f7-theme-color);\n    filter: grayscale(0);\n}\n\n.checkbox-media input:checked ~ .checkbox-inner:after,\n.radio-media input:checked ~ .radio-inner:after {\n    --f7-checkbox-radio-media-icon-color: var(--f7-theme-color);\n    opacity: 1;\n}\n\n.checkbox-media input:checked ~ .checkbox-label,\n.radio-media input:checked ~ .radio-label {\n    --f7-checkbox-radio-media-text-color: var(--f7-theme-color);\n}\n\n.checkbox-media.no-outline .checkbox-inner,\n.radio-media.no-outline .radio-inner {\n    border-width: 0;\n}\n\n.checkbox-media.no-tick .checkbox-inner:after,\n.radio-media.no-tick .radio-inner:after {\n    display: none;\n}\n\n.checkbox-media.no-grayscale input ~ .checkbox-inner,\n.radio-media.no-grayscale input ~ .radio-inner {\n    filter: grayscale(0);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Chip\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-chip-delete-button-color: inherit;\n}\n\n:root .dark, :root.dark {\n    --f7-chip-delete-button-color: inherit;\n}\n\n.aurora, .ios, .md {\n    --f7-chip-height: 28px;\n    --f7-chip-padding-horizontal: 12px;\n}\n\n.chip {\n    margin: 3px;\n    max-width: 100%;\n    overflow: hidden;\n    --f7-touch-ripple-color: rgba(var(--f7-color-gray-rgb), 0.25);\n}\n\n.chip[class*='color-'] {\n    --f7-touch-ripple-color: rgba(var(--f7-theme-color-rgb), 0.25);\n}\n\n.chip-fade[class*='color-'] {\n    background-color: rgba(var(--f7-theme-color-rgb), 0.15);\n    color: var(--f7-theme-color);\n}\n\n.chip-media {\n    background-color: rgba(0, 0, 0, 0.125);\n    color: var(--color-gray-700);\n    font-weight: 600;\n}\n\n.chip[class*='color-'] .chip-media {\n    color: #FFFFFF;\n}\n\n.chip-outline .chip-media {\n    background-color: transparent;\n    border: 1px solid var(--f7-chip-outline-border-color);\n}\n\n.chip-outline[class*='color-'] .chip-media {\n    color: var(--f7-theme-color);\n}\n\n.chip-fade[class*='color-'] .chip-media {\n    background-color: inherit;\n    color: var(--f7-theme-color);\n}\n\n.chip-media i.icon {\n    font-size: calc(var(--f7-chip-height) - 12px);\n    height: calc(var(--f7-chip-height) - 12px);\n}\n\n.chip-selectable {\n    align-items: center;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: inline-flex;\n    max-width: 100%;\n}\n\n.chip-selectable .chip {\n    --f7-chip-bg-color: rgba(0, 0, 0, 0.12);\n    --f7-chip-outline-border-color: rgba(0, 0, 0, 0.125);\n}\n\n.dark .chip-selectable .chip {\n    --f7-chip-bg-color: #333333;\n    --f7-chip-outline-border-color: rgba(255, 255, 255, 0.125);\n}\n\n.aurora .chip-selectable .chip, .ios .chip-selectable .chip {\n    --f7-chip-text-color: #000000;\n}\n\n.aurora .dark .chip-selectable .chip, .aurora.dark .chip-selectable .chip,\n.ios .dark .chip-selectable .chip, .ios.dark .chip-selectable .chip {\n    --f7-chip-text-color: #FFFFFF;\n}\n\n.md .chip-selectable .chip {\n    --f7-chip-text-color: rgba(0, 0, 0, 0.87);\n}\n\n.md .dark .chip-selectable .chip, .md.dark .chip-selectable .chip {\n    --f7-chip-text-color: rgba(255, 255, 255, 0.87);\n}\n\n.chip-selectable .chip .chip-media {\n    color: var(--f7-chip-text-color);\n}\n\n.chip-selectable input {\n    display: none;\n}\n\n.chip-selectable input:checked ~ .chip {\n    --f7-chip-bg-color: var(--f7-theme-color);\n    --f7-chip-text-color: #FFFFFF;\n    --f7-chip-outline-border-color: var(--f7-theme-color);\n}\n\n.chip-selectable.selectable-fade input:checked ~ .chip {\n    --f7-chip-bg-color: rgba(var(--f7-theme-color-rgb), 0.15);\n    --f7-chip-text-color: var(--f7-theme-color);\n    --f7-chip-outline-border-color: var(--f7-theme-color);\n}\n\n.chip-selectable.selectable-fade input:checked ~ .chip .chip-media {\n    background-color: inherit;\n}\n\n.chip-selectable.selectable-fill input:checked ~ .chip {\n    background-color: var(--f7-theme-color);\n    --f7-chip-text-color: #FFFFFF;\n    --f7-chip-outline-border-color: var(--f7-theme-color);\n}\n\n.chip-selectable.selectable-fill input:checked ~ .chip .chip-media {\n    background-color: rgba(0, 0, 0, 0.25);\n}\n\n.chip-selectable input:checked ~ .chip-outline {\n    --f7-chip-text-color: var(--f7-theme-color);\n}\n\n.chip-selectable.selectable-fade input:checked ~ .chip-outline {\n    background-color: rgba(var(--f7-theme-color-rgb), 0.15);\n}\n\n.chip-selectable .chip-media img {\n    filter: grayscale(1);\n}\n\n.chip-selectable input:checked ~ .chip .chip-media img {\n    filter: grayscale(0);\n}\n\n.chip-delete {\n    margin-top: 2px;\n    opacity: 0.75;\n}\n\n.md .chip-delete {\n    margin-right: calc(-1 * var(--f7-chip-padding-horizontal));\n}\n\n[dir=rtl].md .chip-delete {\n    margin-left: calc(-1 * var(--f7-chip-padding-horizontal));\n}\n\n.aurora .chip-delete:after, .ios .chip-delete:after, .md .chip-delete:after {\n    font-size: 10px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Color Picker\n|------------------------------------------------------------------------------\n*/\n\n.color-picker-page .color-picker-module,\n.color-picker-popup .color-picker-module,\n.color-picker-sheet-modal .color-picker-module {\n    padding-left: var(--f7-safe-area-left);\n    padding-right: var(--f7-safe-area-right);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Content Block\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-block-header-font-size: 15px;\n    --f7-block-footer-font-size: 15px;\n}\n\n.aurora, .ios, .md {\n    --f7-block-title-font-size: 18px;\n    --f7-block-title-font-weight: bold;\n    --f7-block-title-line-height: 1.5;\n    --f7-block-margin-vertical: 32px;\n    --f7-block-title-margin-bottom: 10px;\n    --f7-block-title-text-color: #000000;\n    --f7-block-title-white-space: normal;\n    --f7-block-title-medium-font-size: 22px;\n    --f7-block-title-medium-font-weight: bold;\n    --f7-block-title-medium-line-height: 1.4;\n    --f7-block-title-large-font-size: 30px;\n    --f7-block-title-large-font-weight: bold;\n    --f7-block-title-large-line-height: 1.4;\n}\n\n.block-title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    overflow: unset;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Data Table\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-table-card-header-height: var(--f7-table-body-cell-height);\n}\n\n.aurora, .ios, .md {\n    --f7-table-head-bg-color: #F6F6F7;\n    --f7-table-head-font-size: 13px;\n    --f7-table-card-header-bg-color: #F6F6F7;\n    --f7-table-title-font-size: 18px;\n    --f7-table-title-font-weight: bold;\n    --f7-table-cell-padding-horizontal: 16px;\n    --f7-table-edge-cell-padding-horizontal: 16px;\n    --f7-table-label-cell-padding-horizontal: 16px;\n}\n\n.aurora .dark, .aurora.dark,\n.ios .dark, .ios.dark,\n.md .dark, .md.dark {\n    --f7-table-head-bg-color: var(--color-gray-900);\n    --f7-table-card-header-bg-color: var(--color-gray-900);\n}\n\n.data-table tbody th {\n    background-color: var(--f7-table-head-bg-color);\n    font-size: var(--f7-table-head-font-size);\n    font-weight: var(--f7-table-head-font-weight);\n    height: var(--f7-table-head-cell-height);\n    line-height: 16px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n[dir=rtl] .data-table .data-table-footer {\n    justify-content: flex-end;\n}\n\n@media (max-width: 480px) and (orientation: portrait) {\n    .data-table.data-table-collapsible tr:first-child:before {\n        display: none;\n    }\n}\n\n.data-table-fixed-header thead th, .data-table-fixed-first-column thead th {\n    position: sticky;\n    top: 0;\n    z-index: 100;\n}\n\n.data-table-fixed-first-column thead th:first-child {\n    z-index: 110;\n}\n\n.data-table-fixed-first-column tbody th {\n    z-index: 100;\n}\n\n.data-table-fixed-first-column tbody th {\n    color: var(--f7-table-head-text-color);\n}\n\n.data-table-fixed-first-column tbody th, .data-table-fixed-first-column thead th:first-child {\n    height: var(--f7-table-body-cell-height);\n    left: 0;\n    position: sticky;\n    right: auto;\n}\n\n[dir=rtl]:not(.ios) .data-table-fixed-first-column tbody th, [dir=rtl]:not(.ios) .data-table-fixed-first-column thead th:first-child {\n    left: auto;\n    position: sticky;\n    right: 0;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Date-Time Picker\n|------------------------------------------------------------------------------\n*/\n\n[dir=rtl] .calendar-day-selected-left:before, [dir=rtl] .calendar-day-selected-range:first-child:before {\n    border-radius: 0 var(--f7-calendar-day-size) var(--f7-calendar-day-size) 0;\n    left: 0;\n    right: auto;\n}\n\n[dir=rtl] .calendar-day-selected-right:before, [dir=rtl] .calendar-day-selected-range:last-child:before {\n    border-radius: var(--f7-calendar-day-size) 0 0 var(--f7-calendar-day-size);\n    left: auto;\n    right: 0;\n}\n\n.calendar {\n    --f7-bars-bg-color: transparent;\n}\n\n.aurora .calendar, .ios .calendar, .md .calendar {\n    --f7-toolbar-font-size: 16px;\n}\n\n.calendar-inline .toolbar-top {\n    top: 0;\n}\n\n.calendar .toolbar-top:after {\n    display: none;\n}\n\n.calendar-footer:before {\n    display: none;\n}\n\n.calendar-year-picker {\n    overflow: unset;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Dialog\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-dialog-font-size: 14px;\n    --f7-dialog-inner-padding: 16px;\n    --f7-dialog-title-font-size: 18px;\n    --f7-dialog-title-font-weight: 600;\n    --f7-dialog-title-line-height: inherit;\n    --f7-dialog-input-font-size: var(--f7-input-font-size);\n}\n\n.md {\n    --f7-dialog-text-color: rgba(0, 0, 0, 0.87);\n}\n\n.dialog-inner {\n    max-height: 75vh;\n    overflow-y: auto;\n}\n\n.ios .dialog-inner:after {\n    content: none;\n}\n\n.aurora .dialog-title + .dialog-text, .ios .dialog-title + .dialog-text, .md .dialog-title + .dialog-text {\n    margin-top: 12px;\n}\n\n.aurora .dialog-buttons {\n    padding: 12px var(--f7-dialog-inner-padding);\n}\n\n.ios .dialog-buttons:before {\n    background-color: var(--f7-dialog-border-divider-color);\n    bottom: auto;\n    content: '';\n    display: block;\n    height: 1px;\n    left: 0;\n    position: absolute;\n    right: auto;\n    top: 0;\n    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));\n    transform-origin: 50% 100%;\n    width: 100%;\n    z-index: 15;\n}\n\n.md .dialog-buttons-vertical .dialog-button + .dialog-button {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.md .dialog-button {\n    min-width: auto;\n}\n\n.dialog .list ul {\n    --f7-list-bg-color: transparent;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Dropcap\n|------------------------------------------------------------------------------\n*/\n\n.dropcap:first-letter {\n    color: var(--f7-text-color);\n    float: left;\n    font-family: 'Georgia', 'Times New Roman', serif;\n    font-size: 5em;\n    font-weight: bold;\n    line-height: 0.83;\n    margin-right: 0.125em;\n    text-transform: uppercase;\n}\n\n.dropcap[class*='color-']:first-letter {\n    color: var(--f7-theme-color);\n}\n\n.aurora .dropcap:first-letter, .md .dropcap:first-letter {\n    margin-top: 0.05em;\n}\n\n.dropcap.dropcap-fill:first-letter {\n    background-color: var(--f7-color-mono);\n    color: var(--f7-color-mono-invert);\n    font-size: 4.25em;\n    padding: 0.22em;\n}\n\n.dropcap.dropcap-fill[class*='color-']:first-letter {\n    background-color: var(--f7-theme-color);\n    color: #FFFFFF;\n}\n\n.dropcap.dropcap-outline:first-letter {\n    border: 2px solid var(--f7-text-color);\n    border-radius: 4px;\n    font-size: 4.25em;\n    padding: 0.2em;\n}\n\n.dropcap.dropcap-outline[class*='color-']:first-letter {\n    border-color: var(--f7-theme-color);\n}\n\n.dropcap.dropcap-fill:first-letter, .dropcap.dropcap-outline:first-letter {\n    margin-top: 0.1em;\n}\n\n.ios .dropcap.dropcap-fill:first-letter, .ios .dropcap.dropcap-outline:first-letter {\n    line-height: 0.75;\n}\n\n[dir=rtl] .dropcap:first-letter, [dir=rtl] .dropcap[class*='color-']:first-letter {\n    background-color: unset;\n    border: unset;\n    border-radius: unset;\n    color: unset;\n    float: unset;\n    font-family: unset;\n    font-size: unset;\n    font-weight: unset;\n    line-height: unset;\n    margin: unset;\n    padding: unset;\n    text-transform: unset;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Elevation\n|------------------------------------------------------------------------------\n*/\n\n[class*='elevation-'][class*='color-'] {\n    --f7-elevation-0: 0px 0px 0px 0px rgba(var(--f7-theme-color-rgb), 0);\n    --f7-elevation-1: 0px 2px 1px -1px rgba(var(--f7-theme-color-rgb), 0.2), 0px 1px 1px 0px rgba(var(--f7-theme-color-rgb), 0.14), 0px 1px 3px 0px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-2: 0px 3px 1px -2px rgba(var(--f7-theme-color-rgb), 0.2), 0px 2px 2px 0px rgba(var(--f7-theme-color-rgb), 0.14), 0px 1px 5px 0px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-3: 0px 3px 3px -2px rgba(var(--f7-theme-color-rgb), 0.2), 0px 3px 4px 0px rgba(var(--f7-theme-color-rgb), 0.14), 0px 1px 8px 0px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-4: 0px 2px 4px -1px rgba(var(--f7-theme-color-rgb), 0.2), 0px 4px 5px 0px rgba(var(--f7-theme-color-rgb), 0.14), 0px 1px 10px 0px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-5: 0px 3px 5px -1px rgba(var(--f7-theme-color-rgb), 0.2), 0px 5px 8px 0px rgba(var(--f7-theme-color-rgb), 0.14), 0px 1px 14px 0px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-6: 0px 3px 5px -1px rgba(var(--f7-theme-color-rgb), 0.2), 0px 6px 10px 0px rgba(var(--f7-theme-color-rgb), 0.14), 0px 1px 18px 0px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-7: 0px 4px 5px -2px rgba(var(--f7-theme-color-rgb), 0.2), 0px 7px 10px 1px rgba(var(--f7-theme-color-rgb), 0.14), 0px 2px 16px 1px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-8: 0px 5px 5px -3px rgba(var(--f7-theme-color-rgb), 0.2), 0px 8px 10px 1px rgba(var(--f7-theme-color-rgb), 0.14), 0px 3px 14px 2px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-9: 0px 5px 6px -3px rgba(var(--f7-theme-color-rgb), 0.2), 0px 9px 12px 1px rgba(var(--f7-theme-color-rgb), 0.14), 0px 3px 16px 2px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-10: 0px 6px 6px -3px rgba(var(--f7-theme-color-rgb), 0.2), 0px 10px 14px 1px rgba(var(--f7-theme-color-rgb), 0.14), 0px 4px 18px 3px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-11: 0px 6px 7px -4px rgba(var(--f7-theme-color-rgb), 0.2), 0px 11px 15px 1px rgba(var(--f7-theme-color-rgb), 0.14), 0px 4px 20px 3px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-12: 0px 7px 8px -4px rgba(var(--f7-theme-color-rgb), 0.2), 0px 12px 17px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 5px 22px 4px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-13: 0px 7px 8px -4px rgba(var(--f7-theme-color-rgb), 0.2), 0px 13px 19px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 5px 24px 4px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-14: 0px 7px 9px -4px rgba(var(--f7-theme-color-rgb), 0.2), 0px 14px 21px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 5px 26px 4px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-15: 0px 8px 9px -5px rgba(var(--f7-theme-color-rgb), 0.2), 0px 15px 22px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 6px 28px 5px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-16: 0px 8px 10px -5px rgba(var(--f7-theme-color-rgb), 0.2), 0px 16px 24px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 6px 30px 5px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-17: 0px 8px 11px -5px rgba(var(--f7-theme-color-rgb), 0.2), 0px 17px 26px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 6px 32px 5px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-18: 0px 9px 11px -5px rgba(var(--f7-theme-color-rgb), 0.2), 0px 18px 28px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 7px 34px 6px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-19: 0px 9px 12px -6px rgba(var(--f7-theme-color-rgb), 0.2), 0px 19px 29px 2px rgba(var(--f7-theme-color-rgb), 0.14), 0px 7px 36px 6px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-20: 0px 10px 13px -6px rgba(var(--f7-theme-color-rgb), 0.2), 0px 20px 31px 3px rgba(var(--f7-theme-color-rgb), 0.14), 0px 8px 38px 7px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-21: 0px 10px 13px -6px rgba(var(--f7-theme-color-rgb), 0.2), 0px 21px 33px 3px rgba(var(--f7-theme-color-rgb), 0.14), 0px 8px 40px 7px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-22: 0px 10px 14px -6px rgba(var(--f7-theme-color-rgb), 0.2), 0px 22px 35px 3px rgba(var(--f7-theme-color-rgb), 0.14), 0px 8px 42px 7px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-23: 0px 11px 14px -7px rgba(var(--f7-theme-color-rgb), 0.2), 0px 23px 36px 3px rgba(var(--f7-theme-color-rgb), 0.14), 0px 9px 44px 8px rgba(var(--f7-theme-color-rgb), 0.12);\n    --f7-elevation-24: 0px 11px 15px -7px rgba(var(--f7-theme-color-rgb), 0.2), 0px 24px 38px 3px rgba(var(--f7-theme-color-rgb), 0.14), 0px 9px 46px 8px rgba(var(--f7-theme-color-rgb), 0.12);\n}\n\n.no-shadow {\n    box-shadow: none !important;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Empty State\n|------------------------------------------------------------------------------\n*/\n\n.empty-state {\n    align-items: center;\n    box-sizing: border-box;\n    color: inherit;\n    display: flex;\n    flex-direction: column;\n    font-size: inherit;\n    justify-content: center;\n    margin: var(--f7-typography-margin) 0;\n    padding-bottom: 0;\n    padding-left: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-left));\n    padding-right: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-right));\n    padding-top: 0;\n    position: relative;\n    text-align: center;\n    z-index: 1;\n}\n\n.empty-state-strong {\n    background-color: var(--f7-block-strong-bg-color);\n    color: var(--f7-block-strong-text-color);\n    padding-bottom: var(--f7-block-padding-vertical);\n    padding-top: var(--f7-block-padding-vertical);\n}\n\n.empty-state.inset {\n    border-radius: var(--f7-block-inset-border-radius);\n    margin-left: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-left));\n    margin-right: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-right));\n    --f7-safe-area-left: 0px;\n    --f7-safe-area-right: 0px;\n}\n\n.page-content > .empty-state {\n    padding-bottom: var(--f7-block-padding-vertical);\n    padding-top: var(--f7-block-padding-vertical);\n}\n\n.page-content > .empty-state:not(.inset) {\n    height: 100%;\n    margin-bottom: 0;\n    margin-top: 0;\n}\n\n.page-content > .empty-state.inset {\n    min-height: calc(100% - var(--f7-typography-margin) * 2);\n}\n\n.empty-state > :first-child {\n    margin-top: 0;\n}\n\n.empty-state > :last-child {\n    margin-bottom: 0;\n}\n\n.empty-state-media {\n    margin-top: calc(var(--f7-typography-margin) / 2);\n}\n\n.empty-state-title {\n    font-size: 22px;\n    font-weight: bold;\n    line-height: 1.3;\n    margin-top: calc(var(--f7-typography-margin) / 1);\n}\n\n.empty-state-subtitle {\n    margin-top: calc(var(--f7-typography-margin) / 2);\n}\n\n.empty-state-text {\n    color: var(--f7-block-header-text-color);\n    margin-top: calc(var(--f7-typography-margin) / 2);\n}\n\n.empty-state-actions {\n    display: flex;\n    margin-top: calc(var(--f7-typography-margin) / 1);\n}\n\n.empty-state-actions.actions-vertical {\n    flex-direction: column;\n}\n\n.empty-state-action {\n    min-width: 144px;\n    width: auto;\n}\n\n.empty-state-actions.actions-vertical .empty-state-action + .empty-state-action {\n    margin-top: 8px;\n}\n\n.empty-state-actions:not(.actions-vertical) .empty-state-action + .empty-state-action {\n    margin-left: 8px;\n    margin-right: 0;\n}\n\n[dir=rtl] .empty-state-actions:not(.actions-vertical) .empty-state-action + .empty-state-action {\n    margin-left: 0;\n    margin-right: 8px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Expandable Card\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-card-expandable-border-radius: var(--f7-card-border-radius);\n    --f7-card-expandable-box-shadow: none;\n    --f7-card-expandable-margin-horizontal: var(--f7-card-margin-horizontal);\n    --f7-card-expandable-margin-vertical: var(--f7-card-margin-vertical);\n    --f7-card-expandable-tablet-border-radius: var(--f7-card-border-radius);\n    --f7-card-expandable-tablet-height: 568px;\n    --f7-card-expandable-tablet-width: 568px;\n}\n\n.card-expandable {\n    height: 304px;\n}\n\n.card-expandable:not(.card-opened) {\n    cursor: pointer;\n}\n\n.card-expandable .card-expandable-inner {\n    align-items: stretch;\n    display: flex;\n    flex-direction: column;\n    height: 304px;\n    justify-content: flex-start;\n    min-height: 304px;\n    position: relative;\n}\n\n.card-expandable.card-opened .card-expandable-inner {\n    height: auto;\n}\n\n.card-expandable .card-close-link .icon {\n    font-size: 32px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Flip Card\n|------------------------------------------------------------------------------\n*/\n\n.flip-card {\n    background: transparent;\n    border-radius: var(--f7-card-border-radius);\n    box-shadow: none;\n    box-sizing: border-box;\n    font-size: var(--f7-card-font-size);\n    margin-bottom: var(--f7-card-margin-vertical);\n    margin-left: calc(var(--f7-card-margin-horizontal) + var(--f7-safe-area-left));\n    margin-right: calc(var(--f7-card-margin-horizontal) + var(--f7-safe-area-right));\n    margin-top: var(--f7-card-margin-vertical);\n    min-height: 256px;\n    overflow: hidden;\n    perspective: 1000px;\n    position: relative;\n}\n\n.flip-card-inner {\n    border-radius: inherit;\n    height: 100%;\n    position: absolute;\n    transform-style: preserve-3d;\n    transition: transform 0.75s;\n    width: 100%;\n}\n\n.flip-card-flipped .flip-card-inner {\n    transform: rotateY(-180deg);\n}\n\n[dir=rtl] .flip-card-flipped .flip-card-inner {\n    transform: rotateY(180deg);\n}\n\n.flip-card-inner .flip-card-front, .flip-card-inner .flip-card-back {\n    align-items: flex-start;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    background-color: var(--f7-card-bg-color);\n    border-radius: inherit;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: flex-start;\n    overflow-y: auto;\n    position: absolute;\n    width: 100%;\n}\n\n.flip-card-inner .flip-card-back {\n    transform: rotateY(180deg) translateZ(1px);\n}\n\n.flip-card-content {\n    box-sizing: border-box;\n    padding: var(--f7-card-content-padding-vertical) var(--f7-card-content-padding-horizontal);\n    position: relative;\n    z-index: 10;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Floating Action Button\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-fab-label-font-size: 14px;\n}\n\n.aurora, .ios, .md {\n    --f7-fab-extended-text-font-weight: 600;\n    --f7-fab-extended-text-letter-spacing: 0.05em;\n}\n\n.fab:not(.fa-brands) {\n    font-family: var(--f7-font-family);\n}\n\n.fab-label-button > span:not(.fab-label) {\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.fab-label {\n    max-width: 192px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.fab-center-top .fab-buttons-bottom .fab-label, .fab-center-top .fab-buttons-top .fab-label,\n.fab-center-center .fab-buttons-bottom .fab-label, .fab-center-center .fab-buttons-top .fab-label,\n.fab-center-bottom .fab-buttons-bottom .fab-label, .fab-center-bottom .fab-buttons-top .fab-label {\n    left: 125%;\n}\n\n[dir=rtl] .fab-center-top .fab-buttons-bottom .fab-label, [dir=rtl] .fab-center-top .fab-buttons-top .fab-label,\n[dir=rtl] .fab-center-center .fab-buttons-bottom .fab-label, [dir=rtl] .fab-center-center .fab-buttons-top .fab-label,\n[dir=rtl] .fab-center-bottom .fab-buttons-bottom .fab-label, [dir=rtl] .fab-center-bottom .fab-buttons-top .fab-label {\n    left: auto;\n    right: 125%;\n}\n\n.fab-buttons-left a:nth-child(even) .fab-label, .fab-buttons-right a:nth-child(even) .fab-label,\n.fab-buttons-left a:nth-child(even) .fab-label, .fab-buttons-right a:nth-child(even) .fab-label,\n.fab-buttons-left a:nth-child(even) .fab-label, .fab-buttons-right a:nth-child(even) .fab-label {\n    top: 150%;\n}\n\n.fab-buttons-left a:nth-child(odd) .fab-label, .fab-buttons-right a:nth-child(odd) .fab-label,\n.fab-buttons-left a:nth-child(odd) .fab-label, .fab-buttons-right a:nth-child(odd) .fab-label,\n.fab-buttons-left a:nth-child(odd) .fab-label, .fab-buttons-right a:nth-child(odd) .fab-label {\n    top: -50%;\n}\n\n.fab-buttons-left .fab-label, .fab-buttons-right .fab-label {\n    left: auto;\n    margin-left: 0;\n    margin-right: 0;\n    right: auto;\n}\n\n.fab-center-center .fab-buttons-center a:nth-child(1) .fab-label {\n    top: -50%;\n}\n\n.fab-center-center .fab-buttons-center a:nth-child(2) .fab-label {\n    left: 125%;\n}\n\n.fab-center-center .fab-buttons-center a:nth-child(3) .fab-label {\n    top: 150%;\n}\n\n.fab-center-center .fab-buttons-center a:nth-child(4) .fab-label {\n    right: 125%;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Form Input\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-input-fill-bg-color: rgba(var(--f7-color-gray-rgb), 0.25);\n}\n\n.aurora, .ios, .md {\n    --f7-input-font-size: 14px;\n    --f7-inline-label-font-size: 14px;\n    --f7-floating-label-scale: calc(14 / 12);\n    --f7-textarea-padding-vertical: 8px;\n}\n\n.ios {\n    --f7-label-focused-text-color: var(--f7-theme-color);\n    --f7-label-invalid-text-color: var(--f7-input-error-text-color );\n    --f7-input-focused-border-color: var(--f7-theme-color);\n    --f7-input-invalid-border-color: var(--f7-input-error-text-color);\n}\n\n.aurora .item-input .item-media, .ios .item-input .item-media, .md .item-input .item-media {\n    color: var(--f7-color-gray);\n}\n\n.ios .input-focused:not(.input-outline):after, .ios .input-invalid:not(.input-outline):after,\n.ios .item-input-focused:not(.item-input-outline) .item-inner:after, .ios .item-input-invalid:not(.item-input-outline) .item-inner:after {\n    transform: scaleY(2) !important;\n}\n\n.list .item-floating-label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.item-input-wrap {\n    align-items: center;\n    box-sizing: border-box;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.item-input-wrap > * + * {\n    margin-left: 8px !important;\n    margin-right: 0 !important;\n}\n\n[dir=rtl] .item-input-wrap > * + * {\n    margin-left: 0 !important;\n    margin-right: 8px !important;\n}\n\n.item-input-wrap input, .item-input-wrap select, .item-input-wrap textarea {\n    flex-basis: 0;\n    flex-grow: 1;\n    flex-shrink: 1;\n}\n\n.item-input-wrap > textarea ~ * {\n    align-self: flex-start;\n    margin-top: 8px;\n}\n\n.item-input-wrap .input-clear-button {\n    bottom: unset;\n    left: unset;\n    margin-top: unset;\n    position: relative;\n    right: unset;\n    top: unset;\n}\n\n.item-input-wrap .input-clear-button .ripple-wave {\n    position: absolute;\n}\n\n.item-input-wrap > textarea ~ .input-clear-button {\n    margin-top: calc(var(--f7-textarea-padding-vertical) * 1.375);\n}\n\n.input-outline .item-input-wrap, .input-outline .item-input-wrap, .input-outline .item-input-wrap,\n.item-input-outline .item-input-wrap, .item-input-outline .item-input-wrap, .item-input-outline .item-input-wrap,\n.list .item-input-outline .item-input-wrap, .list .item-input-outline .item-input-wrap, .list .item-input-outline .item-input-wrap {\n    padding-left: var(--f7-input-outline-padding-horizontal);\n    padding-right: var(--f7-input-outline-padding-horizontal);\n}\n\n.item-input-outline.item-input-fill .item-input-wrap:after {\n    background-color: var(--f7-input-fill-bg-color);\n    border: none;\n}\n\n.item-input-outline.item-input-round .item-input-wrap:after {\n    border-radius: var(--f7-input-height);\n}\n\n.input-outline input, .input-outline select, .input-outline textarea,\n.item-input-outline input, .item-input-outline select, .item-input-outline textarea,\n.list .item-input-outline input, .list .item-input-outline select, .list .item-input-outline textarea {\n    --f7-input-outline-padding-horizontal: 0px;\n}\n\n.item-input-wrap .input-info, .item-input-wrap .item-input-info,\n.item-input-wrap .input-error-message, .item-input-wrap .item-input-error-message {\n    display: flex;\n    flex-basis: 100%;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    order: 99;\n}\n\n.item-input-outline .item-input-info,\n.item-input-outline .item-input-error-message {\n    left: unset;\n    padding-left: 0;\n    padding-right: 0;\n    right: unset;\n}\n\n.aurora .input-outline .input-info, .aurora .input-outline .item-input-info,\n.aurora .item-input-outline .input-info, .aurora .item-input-outline .item-input-info,\n.ios .input-outline .input-info, .ios .input-outline .item-input-info,\n.ios .item-input-outline .input-info, .ios .item-input-outline .item-input-info {\n    margin-bottom: calc(-1.25 * var(--f7-input-info-font-size) * var(--f7-input-info-line-height));\n}\n\n.aurora .input-outline .input-error-message, .aurora .input-outline .item-input-error-message,\n.aurora .item-input-outline .input-error-message, .aurora .item-input-outline .item-input-error-message,\n.ios .input-outline .input-error-message, .ios .input-outline .item-input-error-message,\n.ios .item-input-outline .input-error-message, .ios .item-input-outline .item-input-error-message {\n    margin-bottom: calc(-1.25 * var(--f7-input-error-font-size) * var(--f7-input-error-line-height));\n}\n\n.aurora .input-outline .input-info, .aurora .input-outline .input-error-message,\n.aurora .input-outline .item-input-info, .aurora .input-outline .item-input-error-message,\n.aurora .item-input-outline .input-info, .aurora .item-input-outline .input-error-message,\n.aurora .item-input-outline .item-input-info, .aurora .item-input-outline .item-input-error-message,\n.ios .input-outline .input-info, .ios .input-outline .input-error-message,\n.ios .input-outline .item-input-info, .ios .input-outline .item-input-error-message,\n.ios .item-input-outline .input-info, .ios .item-input-outline .input-error-message,\n.ios .item-input-outline .item-input-info, .ios .item-input-outline .item-input-error-message {\n    white-space: nowrap;\n}\n\n.item-input-wrap :not(.input-invalid) ~ .input-error-message,\n.item-input-wrap :not(.input-invalid) ~ .item-input-error-message {\n    display: none;\n}\n\n.button-file {\n    cursor: pointer;\n    overflow: hidden;\n    position: relative;\n}\n\n.button-file [type=file] {\n    cursor: pointer;\n    opacity: 0;\n    position: absolute;\n}\n\n.button-file [type=file]:valid ~ .file-status-icon .status-invalid {\n    display: none;\n}\n\n.button-file [type=file]:invalid ~ .file-status-icon .status-valid {\n    display: none;\n}\n\ninput:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus,\ntextarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus,\nselect:-webkit-autofill, select:-webkit-autofill:hover, select:-webkit-autofill:focus {\n    -webkit-text-fill-color: var(--f7-input-text-color) !important;\n    transition: background-color 5000s ease-in-out 0s !important;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Form Validator\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-input-error-text-color: var(--f7-color-red);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Gauge\n|------------------------------------------------------------------------------\n*/\n\n.gauge {\n    position: relative;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Grid\n|------------------------------------------------------------------------------\n*/\n\n[dir=rtl] .col > .resize-handler, [dir=rtl] [class*=col-] > .resize-handler {\n    left: auto;\n    right: 100%;\n}\n\n@media (max-width: 479.98px) {\n    .xsmall-show {\n        display: none !important;\n    }\n}\n\n@media (min-width: 480px) {\n    .xsmall-hide {\n        display: none !important;\n    }\n}\n\n@media (max-width: 567.98px) {\n    .small-show {\n        display: none !important;\n    }\n}\n\n@media (min-width: 568px) {\n    .small-hide {\n        display: none !important;\n    }\n}\n\n@media (max-width: 767.98px) {\n    .medium-show {\n        display: none !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .medium-hide {\n        display: none !important;\n    }\n}\n\n@media (max-width: 1023.98px) {\n    .large-show {\n        display: none !important;\n    }\n}\n\n@media (min-width: 1024px) {\n    .large-hide {\n        display: none !important;\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .xlarge-show {\n        display: none !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .xlarge-hide {\n        display: none !important;\n    }\n}\n\n/*\n|------------------------------------------------------------------------------\n| Icon\n|------------------------------------------------------------------------------\n*/\n\n.aurora .f7-icons, .ios .f7-icons, .md .f7-icons,\n.aurora .material-icons, .ios .material-icons, .md .material-icons {\n    font-size: 24px;\n}\n\n.fa-stack {\n    width: 2em;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Image\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-avatar-group-avatar-size: 48px;\n    --f7-avatar-group-space-multiplier: -2.5;\n}\n\nimg {\n    max-width: 100%;\n    object-fit: cover;\n    object-position: center;\n    vertical-align: bottom;\n}\n\n.avatar {\n    background-image: linear-gradient(to bottom right, var(--f7-theme-color-shade), var(--f7-theme-color), var(--f7-theme-color-tint));\n    box-sizing: border-box;\n    padding: 3.5px;\n}\n\n.avatar-group {\n    align-items: center;\n    display: flex;\n    justify-content: flex-start;\n}\n\n.avatar-group .avatar, .avatar-group .avatar-count {\n    align-items: center;\n    border-radius: 50%;\n    box-sizing: border-box;\n    display: flex;\n    height: var(--f7-avatar-group-avatar-size);\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n    text-align: center;\n    width: var(--f7-avatar-group-avatar-size);\n}\n\n.avatar-group-hover .avatar:hover {\n    z-index: 10;\n}\n\n.avatar-group .avatar img {\n    border-radius: 50%;\n}\n\n.avatar-group .avatar-count {\n    background-color: var(--color-gray-800);\n    border-radius: var(--f7-avatar-group-avatar-size);\n    color: #FFFFFF;\n    font-size: 12px;\n    font-weight: bold;\n    min-width: var(--f7-avatar-group-avatar-size);\n    padding: 0 8px;\n    width: auto;\n}\n\n.avatar-group .avatar-count * {\n    color: #FFFFFF;\n}\n\n.avatar-group .avatar:not(:first-child), .avatar-group .avatar-count:not(:first-child) {\n    margin-left: calc(var(--f7-avatar-group-avatar-size) / var(--f7-avatar-group-space-multiplier));\n    margin-right: 0;\n}\n\n[dir=rtl] .avatar-group .avatar:not(:first-child), [dir=rtl] .avatar-group .avatar-count:not(:first-child) {\n    margin-left: 0;\n    margin-right: calc(var(--f7-avatar-group-avatar-size) / var(--f7-avatar-group-space-multiplier));\n}\n\n.bg-cover {\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    position: relative;\n}\n\n.no-object-fit {\n    object-fit: unset;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Image Compare\n|------------------------------------------------------------------------------\n*/\n\ndiv.juxtapose {\n    font-family: var(--f7-font-family);\n    width: 100% !important;\n}\n\ndiv.juxtapose a.jx-knightlab {\n    display: none;\n}\n\ndiv.juxtapose div.jx-credit {\n    color: var(--f7-color-gray-shade);\n    font-size: 10px;\n    letter-spacing: 0.375px;\n    line-height: inherit;\n}\n\n.dark div.juxtapose div.jx-credit {\n    color: var(--f7-color-gray-tint);\n}\n\ndiv.juxtapose div.jx-credit em {\n    color: var(--f7-text-color);\n    font-weight: 600;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Image Hotspot\n|------------------------------------------------------------------------------\n*/\n\n.hotspots {\n    display: inline-block;\n    position: relative;\n    vertical-align: bottom;\n}\n\n.hotspot-image {\n    display: block;\n    height: 100%;\n    object-fit: scale-down;\n    width: 100%;\n}\n\n.hotspot-point {\n    -webkit-animation: hotspot 600ms linear infinite alternate;\n    animation: hotspot 600ms linear infinite alternate;\n    border-radius: 50%;\n    box-shadow: inset 0 0 6px 4px rgba(var(--f7-theme-color-rgb), 0.6);\n    height: 32px;\n    position: absolute;\n    width: 32px;\n}\n\n.hotspot-point:before {\n    background-color: rgba(var(--f7-theme-color-rgb), 0.8);\n    border: 2px solid var(--f7-theme-color);\n    border-radius: 50%;\n    content: '';\n    display: block;\n    height: 16px;\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 16px;\n}\n\n@-webkit-keyframes hotspot {\n    from {\n        box-shadow: inset 0 0 12px 6px rgba(var(--f7-theme-color-rgb), 0.6);\n    }\n    to {\n        box-shadow: inset 0 0 4px 2px rgba(var(--f7-theme-color-rgb), 0.4);\n    }\n}\n\n@keyframes hotspot {\n    from {\n        box-shadow: inset 0 0 12px 6px rgba(var(--f7-theme-color-rgb), 0.6);\n    }\n    to {\n        box-shadow: inset 0 0 4px 2px rgba(var(--f7-theme-color-rgb), 0.4);\n    }\n}\n\n/*\n|------------------------------------------------------------------------------\n| Infinite Scroll\n|------------------------------------------------------------------------------\n*/\n\n.infinite-scroll-preloader.preloader {\n    display: block;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Integrations\n|------------------------------------------------------------------------------\n*/\n\n.disqus-thread {\n    background-color: #FFFFFF;\n    border-radius: var(--f7-block-inset-border-radius);\n    padding: calc(var(--f7-typography-padding) / 4) var(--f7-typography-padding);\n}\n\n.embedly-card {\n    background-color: #FFFFFF;\n    border-radius: var(--f7-block-inset-border-radius);\n    padding: calc(var(--f7-typography-padding) / 4) var(--f7-typography-padding);\n}\n\n.fb-comments {\n    background-color: #FFFFFF;\n    border-radius: var(--f7-block-inset-border-radius);\n    box-sizing: border-box;\n    padding: calc(var(--f7-typography-padding) / 2);\n}\n\niframe[id*='comments-app-'] {\n    border-radius: var(--f7-block-inset-border-radius);\n}\n\n.pac-container {\n    background-color: var(--f7-list-bg-color);\n    border-radius: var(--f7-list-inset-border-radius);\n    border-top: none;\n    font-family: var(--f7-font-family);\n    z-index: 9999;\n}\n\n.pac-item {\n    border-top: none;\n    color: var(--f7-list-item-text-text-color);\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.pac-item:hover {\n    background-color: var(--f7-list-link-pressed-bg-color);\n}\n\n.pac-item-query {\n    color: var(--f7-text-color);\n    font-size: 14px;\n}\n\n.pac-matched {\n    font-weight: bold;\n}\n\n.pac-logo:after {\n    margin: 4px 8px;\n    padding: 0;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Keypad\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-keypad-inline-height: 210px;\n    --f7-keypad-landscape-height: 260px;\n    --f7-keypad-bg-color: #CED4DC;\n    --f7-keypad-button-bg-color: #FFFFFF;\n    --f7-keypad-button-pressed-bg-color: #ADBBCA;\n    --f7-keypad-button-dark-bg-color: transparent;\n    --f7-keypad-button-dark-pressed-bg-color: var(--f7-keypad-button-pressed-bg-color);\n    --f7-keypad-button-number-font-size: 22px;\n    --f7-keypad-button-letters-font-size: 10px;\n    --f7-keypad-button-spacing: 4px;\n}\n\n:root .dark, :root.dark {\n    --f7-keypad-bg-color: #292930;\n    --f7-keypad-button-bg-color: #6A6E71;\n    --f7-keypad-button-pressed-bg-color: #464646;\n    --f7-keypad-button-text-color: #FFFFFF;\n}\n\n.keypad {\n    background-color: var(--f7-keypad-bg-color);\n}\n\n.keypad-buttons {\n    padding: var(--f7-keypad-button-spacing);\n}\n\n.keypad-button {\n    border-radius: 6px;\n    height: calc(25% - calc(var(--f7-keypad-button-spacing) * 2));\n    margin: var(--f7-keypad-button-spacing);\n    width: calc(calc(100% / 3) - calc(var(--f7-keypad-button-spacing) * 2));\n}\n\n.keypad-button:before, .keypad-button:after {\n    content: none;\n}\n\n.keypad-button-letters {\n    font-weight: 600;\n    height: 16px;\n    letter-spacing: 1px;\n    line-height: 16px;\n}\n\n.dark i.icon-keypad-delete {\n    background-image: url(\"data:image/svg+xml;charset=utf-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 16'><path d='M18,0h-8C8.9,0,7.9,0.5,7.1,1.2c0,0,0,0,0,0L1,7.2C0.6,7.7,0.6,8.4,1,8.8l4.9,4.7L7,14.6c0,0,0,0,0,0c0.7,0.9,1.8,1.4,3,1.4 h8c2.2,0,4-1.8,4-4V4C22,1.8,20.2,0,18,0z M17.3,11.2l-0.7,0.7l-3.2-3.2l-3.2,3.2l-0.7-0.7L12.8,8L9.6,4.8l0.7-0.7l3.2,3.2l3.2-3.2 l0.7,0.7L14.2,8L17.3,11.2z' fill='%23FFFFFF'/></svg>\");\n}\n\n[dir=rtl] i.icon-keypad-delete {\n    transform: scaleX(-1);\n}\n\n.keypad-inline {\n    --f7-keypad-bg-color: transparent;\n}\n\n.keypad-inline .keypad-buttons {\n    height: calc(var(--f7-keypad-inline-height) - calc(var(--f7-keypad-button-spacing) * 2));\n}\n\n.keypad-popover .popover-angle.on-bottom:after {\n    background: var(--f7-keypad-bg-color);\n}\n\n.keypad-popover .popover-angle.on-top:after {\n    background: var(--f7-bars-bg-color);\n}\n\n.keypad-popover .toolbar {\n    border-radius: var(--f7-popover-border-radius) var(--f7-popover-border-radius) 0 0;\n}\n\n.ios .keypad-popover .toolbar {\n    background-color: var(--f7-bars-bg-color);\n}\n\n.keypad-popover .keypad {\n    border-radius: var(--f7-popover-border-radius);\n    overflow: hidden;\n    position: relative;\n}\n\n@media (orientation: landscape) and (max-height: 415px) {\n    .keypad-sheet {\n        height: calc(var(--f7-safe-area-bottom) + var(--f7-keypad-landscape-height));\n    }\n}\n\n.keypad-inline .toolbar ~ .keypad-buttons, .keypad-popover .keypad .toolbar ~ .keypad-buttons, .keypad-sheet .toolbar ~ .keypad-buttons {\n    height: calc(100% - var(--f7-toolbar-height) - calc(var(--f7-keypad-button-spacing) * 2));\n}\n\n.keypad-inline .keypad-buttons, .keypad-sheet .keypad-buttons {\n    padding-left: calc(var(--f7-keypad-button-spacing) + var(--f7-safe-area-left));\n    padding-right: calc(var(--f7-keypad-button-spacing) + var(--f7-safe-area-right));\n}\n\n.keypad-type-custom .keypad-buttons {\n    overflow-y: auto;\n}\n\n.keypad-type-calculator {\n    --f7-keypad-button-dark-bg-color: var(--color-gray-300);\n    --f7-keypad-button-dark-pressed-bg-color: var(--color-gray-400);\n}\n\n.keypad-type-calculator .keypad-button.keypad-button-dark {\n    color: #000000;\n}\n\n.keypad-type-calculator .keypad-button {\n    height: calc(20% - calc(var(--f7-keypad-button-spacing) * 2));\n    width: calc(calc(100% / 4) - calc(var(--f7-keypad-button-spacing) * 2));\n}\n\n.keypad-type-calculator .keypad-button.keypad-button-double {\n    width: calc(50% - calc(var(--f7-keypad-button-spacing) * 2));\n}\n\n.keypad-button.calc-operator-button.calc-operator-active {\n    background-color: #FFFFFF;\n    border: none;\n    color: var(--f7-keypad-calc-button-bg-color);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Line Divider\n|------------------------------------------------------------------------------\n*/\n\n.line-divider {\n    align-items: center;\n    border: none;\n    color: var(--f7-color-gray);\n    display: flex;\n    flex-direction: row;\n    font-size: 14px;\n    justify-content: center;\n    text-align: center;\n}\n\n.line-divider[class*='color-'] {\n    color: var(--f7-theme-color);\n}\n\n.line-divider:before, .line-divider:after {\n    border-top-color: var(--f7-list-border-color);\n    border-top-style: solid;\n    border-top-width: 1px;\n    content: '';\n    flex-grow: 1;\n    margin: 0.75em 0;\n    position: relative;\n}\n\n.line-divider.line-dashed:before, .line-divider.line-dashed:after {\n    border-top-style: dashed;\n}\n\n.line-divider.line-dotted:before, .line-divider.line-dotted:after {\n    border-top-style: dotted;\n}\n\n.line-divider[class*='color-']:before, .line-divider[class*='color-']:after {\n    border-top-color: var(--f7-theme-color);\n}\n\n.line-divider > * {\n    margin: 0 var(--f7-typography-margin);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Link\n|------------------------------------------------------------------------------\n*/\n\n.link-button {\n    border-radius: var(--f7-button-border-radius);\n    overflow: hidden;\n    padding: 0 4px;\n}\n\n.cursor-default {\n    cursor: default;\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n/*\n|------------------------------------------------------------------------------\n| List Index\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-list-index-font-size: 11px;\n    --f7-list-index-skip-dot-size: 4px;\n}\n\n[dir=rtl] .list-index:before {\n    left: 100%;\n    right: auto;\n}\n\n[dir=rtl] .list-index .list-index-label {\n    left: 100%;\n    right: auto;\n}\n\n[dir=rtl].aurora .list-index .list-index-label {\n    margin-left: calc(var(--f7-list-index-width) - 4px);\n    margin-right: 0;\n}\n\n[dir=rtl].ios .list-index .list-index-label {\n    margin-left: calc(var(--f7-list-index-width) - 2px);\n    margin-right: 0;\n}\n\n[dir=rtl].md .list-index .list-index-label {\n    border-radius: 50% 50% 50% 0;\n}\n\n[dir=rtl].aurora .list-index .list-index-label:before {\n    border-radius: 50% 50% 50% 1px;\n}\n\n[dir=rtl].ios .list-index .list-index-label:before {\n    border-radius: 50% 50% 50% 0;\n}\n\n/*\n|------------------------------------------------------------------------------\n| List View\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-list-item-title-white-space: normal;\n    --f7-list-item-text-max-lines: unset;\n}\n\n.aurora, .ios, .md {\n    --f7-list-font-size: var(--f7-font-size);\n    --f7-list-item-after-font-size: 14px;\n    --f7-list-item-subtitle-font-size: 14px;\n    --f7-list-item-text-font-size: 14px;\n    --f7-list-media-item-padding-vertical: 16px;\n    --f7-list-media-item-title-font-weight: 600;\n    --f7-list-group-title-font-size: inherit;\n    --f7-list-group-title-font-weight: normal;\n    --f7-list-group-title-height: var(--f7-list-item-min-height);\n    --f7-list-item-divider-border-color: transparent;\n    --f7-list-item-divider-font-size: inherit;\n    --f7-list-item-divider-font-weight: normal;\n    --f7-list-item-divider-height: var(--f7-list-item-min-height);\n    --f7-list-item-header-text-color: var(--f7-block-header-text-color);\n    --f7-list-item-footer-text-color: var(--f7-block-footer-text-color);\n}\n\n.aurora, .ios, .md {\n    --f7-list-item-border-color: rgba(0, 0, 0, 0.12);\n}\n\n.aurora .dark, .aurora.dark, .ios .dark, .ios.dark, .md .dark, .md.dark {\n    --f7-list-item-border-color: rgba(255, 255, 255, 0.12);\n    --f7-list-item-divider-border-color: transparent;\n    --f7-list-item-header-text-color: var(--f7-block-header-text-color);\n    --f7-list-item-footer-text-color: var(--f7-block-footer-text-color);\n}\n\nul {\n    padding-inline-start: 32px;\n}\n\n.list .item-after {\n    flex-shrink: 1;\n    text-align: right;\n    white-space: normal;\n}\n\n[dir=rtl] .list .item-after {\n    text-align: left;\n}\n\n.list .item-subtitle {\n    white-space: normal;\n}\n\n.aurora .list .item-media, .ios .list .item-media, .md .list .item-media {\n    justify-content: center;\n    min-width: 24px;\n}\n\n.list.inset .item-divider:first-child {\n    border-radius: var(--f7-list-inset-border-radius) var(--f7-list-inset-border-radius) 0 0;\n}\n\n.list.inset .item-divider:last-child {\n    border-radius: 0 0 var(--f7-list-inset-border-radius) var(--f7-list-inset-border-radius);\n}\n\n.list.inset .list-group ul {\n    border-radius: 0;\n}\n\n.list.inset .list-group:first-child ul {\n    border-radius: var(--f7-list-inset-border-radius) var(--f7-list-inset-border-radius) 0 0;\n}\n\n.list.inset .list-group:last-child ul {\n    border-radius: 0 0 var(--f7-list-inset-border-radius) var(--f7-list-inset-border-radius);\n}\n\n.list.inset .list-group:first-child .list-group-title:first-child {\n    border-radius: var(--f7-list-inset-border-radius) var(--f7-list-inset-border-radius) 0 0;\n}\n\n.simple-list li {\n    height: auto;\n    line-height: inherit;\n    padding-bottom: 8px;\n    padding-top: 8px;\n    white-space: normal;\n}\n\n.cards-list li {\n    background-color: var(--f7-list-bg-color);\n    border-radius: inherit;\n    margin: calc(var(--f7-typography-margin) / 2) 0;\n}\n\n.cards-list li:first-child {\n    margin-top: 0;\n}\n\n.cards-list li:last-child {\n    margin-bottom: 0;\n}\n\n.cards-list.inset li {\n    border-radius: var(--f7-list-inset-border-radius);\n}\n\n.cards-list > ul.row > li {\n    margin: calc(var(--f7-typography-margin) / 2) 0;\n}\n\n.cards-list .item-link.active-state {\n    border-radius: inherit !important;\n}\n\n.aurora.device-desktop .links-list a:hover:not(.active-state):not(.no-hover), .aurora.device-desktop .list .item-link:not(.item-selected):hover:not(.active-state):not(.no-hover) {\n    border-radius: inherit;\n}\n\n.cards-list .item-inner:after {\n    display: none !important;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Margin & Padding\n|------------------------------------------------------------------------------\n*/\n\n.margin-bottom-auto {\n    margin-bottom: auto !important;\n}\n\n.margin-left-auto {\n    margin-left: auto !important;\n}\n\n.margin-right-auto {\n    margin-right: auto !important;\n}\n\n.margin-top-auto {\n    margin-top: auto !important;\n}\n\n.margin-horizontal-auto {\n    margin-left: auto !important;\n    margin-right: auto !important;\n}\n\n@media (min-width: 768px) {\n    .medium-margin-vertical {\n        margin-top: var(--f7-typography-margin) !important;\n        margin-bottom: var(--f7-typography-margin) !important;\n    }\n    .medium-margin-top {\n        margin-top: var(--f7-typography-margin) !important;\n    }\n    .medium-margin-bottom {\n        margin-bottom: var(--f7-typography-margin) !important;\n    }\n    .medium-no-margin-vertical {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n    }\n    .medium-no-margin-top {\n        margin-top: 0 !important;\n    }\n    .medium-no-margin-bottom {\n        margin-bottom: 0 !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .medium-padding-vertical {\n        padding-top: var(--f7-typography-padding) !important;\n        padding-bottom: var(--f7-typography-padding) !important;\n    }\n    .medium-no-padding-horizontal {\n        padding-left: 0 !important;\n        padding-right: 0 !important;\n    }\n}\n\n/*\n|------------------------------------------------------------------------------\n| Marquee\n|------------------------------------------------------------------------------\n*/\n\n.marquee {\n    overflow: hidden;\n}\n\n[dir=rtl] .marquee[data-direction=left] .js-marquee, [dir=rtl] .marquee[data-direction=right] .js-marquee {\n    float: right !important;\n    margin-left: 0 !important;\n    margin-right: unset !important;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Menu\n|------------------------------------------------------------------------------\n*/\n\n:root .dark, :root.dark {\n    --f7-menu-bg-color: rgba(255, 255, 255, 0.9);\n    --f7-menu-text-color: #000000;\n    --f7-menu-dropdown-divider-color: rgba(0, 0, 0, 0.2);\n    --f7-menu-item-dropdown-icon-color: rgba(0, 0, 0, 0.4);\n}\n\n.menu-inner:after {\n    width: 0;\n}\n\n.menu[class*='color-'], .menu-item[class*='color-'] {\n    --f7-menu-bg-color: rgba(var(--f7-theme-color-rgb), 0.9);\n    --f7-menu-text-color: #FFFFFF;\n    --f7-menu-dropdown-divider-color: rgba(255, 255, 255, 0.2);\n    --f7-menu-item-dropdown-icon-color: rgba(255, 255, 255, 0.4);\n}\n\n.dark .menu-item.active-state:not(.menu-item-dropdown-opened), .dark.menu-item.active-state:not(.menu-item-dropdown-opened) {\n    background-color: rgba(255, 255, 255, 0.7);\n}\n\n.menu[class*='color-'] .menu-item.active-state:not(.menu-item-dropdown-opened), .menu-item[class*='color-'].active-state:not(.menu-item-dropdown-opened) {\n    background-color: rgba(var(--f7-theme-color-rgb), 0.7);\n}\n\n.menu-dropdown-link:before {\n    background: rgba(0, 0, 0, 0.8);\n}\n\n.dark .menu-dropdown-link:before {\n    background: rgba(255, 255, 255, 0.8);\n}\n\n.menu[class*='color-'] .menu-dropdown-link:before, .menu-item[class*='color-'] .menu-dropdown-link:before {\n    background: rgba(var(--f7-theme-color-rgb), 0.8);\n}\n\n[dir=rtl] .menu-dropdown-left:after, [dir=rtl] .menu-item-dropdown-left .menu-dropdown:after {\n    background-image: radial-gradient(ellipse at 0% 0%,transparent 0%,transparent 70%,var(--f7-menu-bg-color) 72%);\n    left: 0;\n    right: 100%;\n}\n\n[dir=rtl] .menu-dropdown-right:before, [dir=rtl] .menu-item-dropdown-right .menu-dropdown:before {\n    background-image: radial-gradient(ellipse at 100% 0%, transparent 0%, transparent 70%, var(--f7-menu-bg-color) 72%);\n    left: 100%;\n    right: 0;\n}\n\n[dir=rtl] .menu-dropdown-left .menu-dropdown-content, [dir=rtl] .menu-item-dropdown-left .menu-dropdown-content {\n    border-top-left-radius: var(--f7-menu-item-border-radius);\n    border-top-right-radius: 0;\n    left: auto;\n    right: 0;\n}\n\n[dir=rtl] .menu-dropdown-right .menu-dropdown-content, [dir=rtl] .menu-item-dropdown-right .menu-dropdown-content {\n    border-top-left-radius: 0;\n    border-top-right-radius: var(--f7-menu-item-border-radius);\n    left: 0;\n    right: auto;\n}\n\n.menu-dropdown-content {\n    max-height: 256px;\n    max-width: 144px;\n}\n\n.menu-overlay {\n    bottom: var(--f7-typography-margin);\n    position: absolute;\n    right: var(--f7-typography-margin);\n}\n\n[dir=rtl] .menu-overlay {\n    left: var(--f7-typography-margin);\n    right: auto;\n}\n\n.menu-overlay .menu-inner {\n    padding: 0;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Menu List\n|------------------------------------------------------------------------------\n*/\n\n.menu-list[class*='color-'] .item-selected .item-link,\n.menu-list[class*='color-'] .item-selected.item-link,\n.menu-list[class*='color-'] .tab-link-active .item-link,\n.menu-list[class*='color-'] .tab-link-active.item-link {\n    --f7-menu-list-selected-text-color: var(--f7-theme-color);\n    --f7-menu-list-selected-bg-color: rgba(var(--f7-theme-color-rgb), 0.15);\n}\n\n.menu-list .item-selected .item-link[class*='color-'],\n.menu-list .item-selected.item-link[class*='color-'],\n.menu-list .tab-link-active .item-link[class*='color-'],\n.menu-list .tab-link-active.item-link[class*='color-'] {\n    --f7-menu-list-selected-text-color: var(--f7-theme-color);\n    --f7-menu-list-selected-bg-color: rgba(var(--f7-theme-color-rgb), 0.15);\n}\n\n.item-selected .icons .icon + .icon-active, .item-selected .icons .icon-active + .icon {\n    margin: 0;\n}\n\n.menu-list .item-link:not(.item-selected):not(.tab-link-active) .icons .icon-active {\n    display: none;\n}\n\n.menu-list .item-selected .icons .icon:not(.icon-active), .menu-list .tab-link-active .icons .icon:not(.icon-active) {\n    display: none;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Message\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-message-bubble-font-size: 14px;\n    --f7-message-name-font-size: 12px;\n    --f7-messagebar-textarea-font-size: 14px;\n    --f7-messagebar-textarea-line-height: 20px;\n}\n\n.aurora, .ios {\n    --f7-message-bubble-border-radius: 12px;\n}\n\n.aurora .message-text-footer, .ios .message-text-footer, .md .message-text-footer {\n    margin-top: 4px;\n}\n\n.messagebar a.link {\n    align-self: center;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Navbar\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-navbar-title-line-height: normal;\n}\n\n.aurora, .ios, .md {\n    --f7-navbar-font-size: 20px;\n    --f7-navbar-title-font-weight: bold;\n    --f7-navbar-title-text-align: center;\n    --f7-navbar-subtitle-line-height: 1.3;\n    --f7-navbar-large-title-font-size: 30px;\n    --f7-navbar-large-title-font-weight: bold;\n    --f7-navbar-large-title-letter-spacing: 0px;\n}\n\n.ios {\n    --f7-navbar-height: 52px;\n    --f7-navbar-tablet-height: 52px;\n    --f7-navbar-inner-padding-left: 16px;\n    --f7-navbar-inner-padding-right: 16px;\n    --f7-navbar-subtitle-font-size: 12px;\n}\n\n.aurora .navbar .title img, .aurora .navbar .title svg {\n    height: calc(var(--f7-navbar-tablet-height) - 32px);\n}\n\n.ios .navbar .title img, .ios .navbar .title svg {\n    height: calc(var(--f7-navbar-tablet-height) - 24px);\n}\n\n.md .navbar .title img, .md .navbar .title svg {\n    height: calc(var(--f7-navbar-tablet-height) - 40px);\n}\n\n.aurora .navbar a.icon-only, .ios .navbar a.icon-only {\n    width: 32px;\n}\n\n.navbars, .navbar {\n    z-index: 1500;\n}\n\n.tabs-routable .navbars .navbar:first-of-type .link.back,\n.tabs-routable .page:first-of-type .navbar .link.back {\n    display: none;\n}\n\n.views .navbars .navbar:first-of-type .link.back,\n.views .page:first-of-type .navbar .link.back {\n    display: none;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Note\n|------------------------------------------------------------------------------\n*/\n\n.note {\n    align-items: flex-start;\n    background-color: var(--f7-block-strong-bg-color);\n    box-sizing: border-box;\n    color: var(--f7-text-color);\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin: calc(var(--f7-block-margin-vertical) / 2) 0;\n    padding-bottom: calc(var(--f7-block-padding-vertical) / 1.5);\n    padding-left: calc(var(--f7-block-padding-horizontal) / 1.5 + var(--f7-safe-area-left));\n    padding-right: calc(var(--f7-block-padding-horizontal) / 1.5 + var(--f7-safe-area-right));\n    padding-top: calc(var(--f7-block-padding-vertical) / 1.5);\n}\n\n.block-strong .note {\n    border: 2px solid var(--f7-color-mono);\n    border-radius: var(--f7-block-inset-border-radius);\n}\n\n.block-strong .note[class*='color-'] {\n    border-color: var(--f7-theme-color);\n}\n\n.note.inset {\n    border-radius: var(--f7-block-inset-border-radius);\n    margin-left: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-left));\n    margin-right: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-right));\n    --f7-safe-area-left: 0px;\n    --f7-safe-area-right: 0px;\n}\n\n.note-fade[class*='color-'] {\n    background-color: rgba(var(--f7-theme-color-rgb), 0.15);\n}\n\n.note-fill[class*='color-'] {\n    background-color: var(--f7-theme-color);\n}\n\n.note-outline {\n    border: 2px solid var(--f7-color-mono);\n}\n\n.note-outline[class*='color-'] {\n    border-color: var(--f7-theme-color);\n}\n\n.note > * + * {\n    margin-left: 8px;\n    margin-right: 0;\n}\n\n[dir=rtl] .note > * + * {\n    margin-left: 0;\n    margin-right: 8px;\n}\n\n.note > .note-media i, .note > .note-media .icon {\n    font-size: 40px;\n}\n\n.note[class*='color-'] > .note-media i, .note[class*='color-'] > .note-media .icon {\n    color: var(--f7-theme-color);\n}\n\n.note-fill[class*='color-'] > .note-media i, .note-fill[class*='color-'] > .note-media .icon {\n    color: #FFFFFF;\n}\n\n.note-media img, .note-media > svg {\n    height: auto;\n    width: 40px;\n}\n\n.note-content {\n    flex: 1;\n    font-size: 16px;\n    width: 100%;\n}\n\n.note[class*='color-'] .note-content {\n    color: var(--f7-theme-color);\n}\n\n.note-fill[class*='color-'] .note-content {\n    color: #FFFFFF;\n}\n\n.note-title {\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.note[class*='color-'] .note-title {\n    color: var(--f7-theme-color);\n}\n\n.note-fill[class*='color-'] .note-title {\n    color: #FFFFFF;\n}\n\n.note-title + .note-message {\n    color: var(--f7-block-header-text-color);\n    font-size: 14px;\n}\n\n.note[class*='color-'] .note-title + .note-message {\n    color: rgba(var(--f7-theme-color-rgb), 0.75);\n}\n\n.note-fill[class*='color-'] .note-title + .note-message {\n    color: rgba(255, 255, 255, 0.75);\n}\n\n.note-actions {\n    align-self: center;\n    display: flex;\n}\n\n.note-content .note-actions {\n    margin-top: 8px;\n}\n\n.note-action + .note-action {\n    margin-left: 8px;\n    margin-right: 0;\n}\n\n[dir=rtl] .note-action + .note-action {\n    margin-left: 0;\n    margin-right: 8px;\n}\n\n.note-close {\n    color: var(--f7-color-mono);\n    height: 18px;\n    line-height: 1;\n    --f7-touch-ripple-color: rgba(var(--f7-color-black-rgb), 0.25);\n}\n\n.note[class*='color-'] .note-close {\n    color: var(--f7-theme-color);\n    --f7-touch-ripple-color: rgba(var(--f7-theme-color-rgb), 0.25);\n}\n\n.note-fill[class*='color-'] .note-close {\n    color: #FFFFFF;\n}\n\n.note-close:after {\n    color: inherit;\n    content: 'notification_close_ios';\n    font-family: 'framework7-core-icons';\n    font-size: 8px;\n}\n\n.note-actions + .note-close:after {\n    content: 'delete_md';\n    font-size: 12px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Notification\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-notification-subtitle-line-height: 1.4;\n}\n\n.aurora, .ios, .md {\n    --f7-notification-icon-size: 24px;\n    --f7-notification-subtitle-font-size: var(--f7-notification-title-font-size);\n    --f7-notification-subtitle-font-weight: 600;\n    --f7-notification-text-font-size: 14px;\n    --f7-notification-text-line-height: 1.4;\n}\n\n.ios {\n    --f7-notification-title-font-size: 15px;\n    --f7-notification-title-font-weight: 600;\n    --f7-notification-title-right-font-size: 14px;\n}\n\n.md {\n    --f7-notification-title-color: #000000;\n    --f7-notification-title-font-size: 16px;\n    --f7-notification-title-font-weight: 600;\n}\n\n.md .dark, .md.dark {\n    --f7-notification-title-color: #FFFFFF;\n}\n\n[dir=rtl] .notification {\n    direction: rtl;\n}\n\n.notification-icon {\n    flex-shrink: 0;\n    font-size: var(--f7-notification-title-font-size);\n}\n\n[dir=rtl].aurora .notification-icon, [dir=rtl].ios .notification-icon, [dir=rtl].md .notification-icon {\n    margin-left: 8px;\n    margin-right: 0;\n}\n\n.notification-icon i {\n    vertical-align: baseline;\n}\n\n[dir=rtl] .notification-title {\n    margin-left: 8px;\n}\n\n.md .notification-title-right-text {\n    margin-top: 2px;\n}\n\n[dir=rtl].aurora .notification-title-right-text,\n[dir=rtl].ios .notification-title-right-text {\n    margin-right: auto;\n    margin-left: 0;\n}\n\n[dir=rtl].md .notification-title-right-text:before {\n    margin-left: 4px;\n    margin-right: 0;\n}\n\n.aurora .notification-subtitle + .notification-text,\n.ios .notification-subtitle + .notification-text,\n.md .notification-subtitle + .notification-text {\n    margin-top: 4px;\n}\n\n[dir=rtl] .notification-close-button {\n    margin-left: unset;\n    margin-right: auto;\n}\n\n.md .notification-close-button.active-state:before {\n    opacity: 0;\n}\n\n[dir=rtl].aurora .notification-title-right-text + .notification-close-button,\n[dir=rtl].ios .notification-title-right-text + .notification-close-button {\n    margin-left: 0;\n    margin-right: 8px;\n}\n\n.notification-media {\n    margin-top: var(--f7-notification-padding);\n}\n\n.notification-media img {\n    max-height: 288px;\n    width: 100%;\n}\n\n.notification-actions {\n    display: flex;\n    justify-content: flex-start;\n    margin-top: var(--f7-notification-padding);\n}\n\n.notification-action {\n    min-width: 128px;\n    width: auto;\n}\n\n.notification-action + .notification-action {\n    margin-left: 8px;\n    margin-right: 0;\n}\n\n[dir=rtl] .notification-action + .notification-action {\n    margin-left: 0;\n    margin-right: 8px;\n}\n\n.notification-action.button {\n    background-color: rgba(var(--f7-theme-color-rgb), 0.125);\n    color: var(--f7-theme-color);\n}\n\n.notification-input {\n    margin-top: var(--f7-notification-padding);\n}\n\n.notification-input .list {\n    margin: 0;\n}\n\n.notification-input .list ul {\n    background: transparent;\n}\n\n.notification-input .list .item-content, .notification-input .list .item-inner {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Overlay Container\n|------------------------------------------------------------------------------\n*/\n\n.overlay-container {\n    position: relative;\n}\n\n.overlay-container:after {\n    border-radius: inherit;\n    bottom: 0;\n    content: '';\n    height: 100%;\n    left: 0;\n    position: absolute;\n    width: 100%;\n    z-index: 10;\n}\n\n.overlay-container > img, .overlay-container > video {\n    border-radius: inherit;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n    width: 100%;\n}\n\n.overlay-content {\n    align-items: center;\n    border-radius: inherit;\n    box-sizing: border-box;\n    color: #FFFFFF;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: center;\n    position: absolute;\n    padding: var(--f7-block-padding-vertical) var(--f7-block-padding-horizontal);\n    text-align: center;\n    top: 0;\n    width: 100%;\n    z-index: 100;\n}\n\n.bg-overlay:after {\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 25%, rgba(0, 0, 0, 0.5) 50%, rgba(0, 0, 0, 0.75) 75%, rgba(0, 0, 0, 1) 100%);\n    border-radius: inherit;\n    bottom: 0;\n    content: '';\n    height: 100%;\n    left: 0;\n    position: absolute;\n    width: 100%;\n    z-index: 10;\n}\n\n.no-overlay:after {\n    content: none;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Page\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-page-bg-color: #ECEFF1;\n}\n\n.aurora .dark, .ios .dark, .md .dark,\n.aurora.dark, .ios.dark, .md.dark {\n    --f7-page-bg-color: #000000;\n}\n\n.page.no-tabbar {\n    --f7-page-toolbar-bottom-offset: 0px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Pagination\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-pagination-item-size: 36px;\n}\n\n.paginated-list li.visible {\n    display: list-item !important;\n}\n\n.paginated-data-table tr.visible {\n    display: table-row !important;\n}\n\n.pagination {\n    box-sizing: border-box;\n    color: var(--f7-theme-color);\n    font-size: 14px;\n    margin: var(--f7-block-margin-vertical) 0;\n    padding-bottom: 0;\n    padding-left: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-left));\n    padding-right: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-right));\n    padding-top: 0;\n    position: relative;\n    z-index: 1;\n}\n\n.pagination ul {\n    display: flex;\n    flex-wrap: nowrap;\n    list-style: none;\n    margin: 0;\n    overflow-x: auto;\n    padding: 0;\n}\n\n.pagination li {\n    display: inline-block;\n}\n\n.pagination li:first-child {\n    margin-left: auto;\n}\n\n.pagination li:last-child {\n    margin-right: auto;\n}\n\n[dir=rtl] .pagination li:first-child {\n    margin-left: initial;\n    margin-right: auto;\n}\n\n[dir=rtl] .pagination li:last-child {\n    margin-left: auto;\n}\n\n.pagination li + li {\n    margin-left: 12px;\n}\n\n[dir=rtl] .pagination li + li {\n    margin-left: 0;\n    margin-right: 12px;\n}\n\n.pagination li a {\n    align-items: center;\n    background-color: #FFFFFF;\n    border-radius: 4px;\n    box-sizing: border-box;\n    display: flex;\n    height: var(--f7-pagination-item-size);\n    justify-content: center;\n    min-width: var(--f7-pagination-item-size);\n    padding: 4px 8px;\n    text-align: center;\n    white-space: nowrap;\n}\n\n.dark .pagination li a, .dark.pagination li a {\n    background-color: #1C1C1D;\n}\n\n.pagination li.active a {\n    background-color: var(--f7-theme-color);\n    color: #FFFFFF;\n}\n\n.pagination-round li a {\n    border-radius: var(--f7-pagination-item-size);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Photo Browser\n|------------------------------------------------------------------------------\n*/\n\n.photo-browser {\n    position: absolute;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Picker\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-picker-column-font-size: 18px;\n}\n\n[dir=rtl] .picker-columns {\n    text-align: left;\n}\n\n[dir=rtl] .picker-column.picker-column-left {\n    text-align: right;\n}\n\n[dir=rtl] .picker-column.picker-column-right {\n    text-align: left;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Popover\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-popover-width: auto;\n}\n\n.popover {\n    min-width: 128px;\n    max-width: 384px;\n}\n\n.popover-inner {\n    max-height: 75vh;\n    overflow-y: auto;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Popup\n|------------------------------------------------------------------------------\n*/\n\n.popup-router-open-in .row:first-of-type > [class*='col-'],\n.popup-router-open-in .row:first-of-type > [class*='xsmall-'],\n.popup-router-open-in .row:first-of-type > [class*='small-'],\n.popup-router-open-in .row:first-of-type > [class*='medium-'],\n.popup-router-open-in .row:first-of-type > [class*='large-'],\n.popup-router-open-in .row:first-of-type > [class*='xlarge-'] {\n    --f7-cols-per-row: 1 !important;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Position\n|------------------------------------------------------------------------------\n*/\n\n.position-relative {\n    position: relative !important;\n}\n\n.position-absolute {\n    position: absolute;\n    z-index: 9999;\n}\n\n.position-left-top,\n.position-left-center,\n.position-left-bottom {\n    left: 0;\n}\n\n.position-right-top,\n.position-right-center,\n.position-right-bottom {\n    right: 0;\n}\n\n.position-left-top,\n.position-center-top,\n.position-right-top {\n    top: 0;\n}\n\n.position-left-bottom,\n.position-center-bottom,\n.position-right-bottom {\n    bottom: 0;\n}\n\n.position-center-top,\n.position-center-center,\n.position-center-bottom {\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.position-left-center,\n.position-center-center,\n.position-right-center {\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.position-center-center {\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-50%);\n}\n\n.sticky {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0px;\n    z-index: 1000;\n}\n\n.sticky.sticky-top {\n    top: 0px;\n}\n\n.sticky.sticky-bottom {\n    bottom: 0px;\n}\n\n@media (min-width: 768px) {\n    .medium-sticky {\n        position: -webkit-sticky;\n        position: sticky;\n        top: 0px;\n        z-index: 1000;\n    }\n}\n\n/*\n|------------------------------------------------------------------------------\n| Preloader\n|------------------------------------------------------------------------------\n*/\n\n.preloader-backdrop {\n    border-radius: inherit;\n}\n\n.with-modal-preloader:not(html) .preloader-backdrop {\n    background: rgba(0, 0, 0, 0.4);\n    opacity: 1;\n}\n\n.dark .with-modal-preloader:not(html) .preloader-backdrop, .dark.with-modal-preloader:not(html) .preloader-backdrop {\n    background: rgba(0, 0, 0, 0.6);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Progress Bar\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-progressbar-bg-color: rgba(0, 0, 0, 0.15);\n    --f7-progressbar-border-radius: 4px;\n    --f7-progressbar-height: 8px;\n}\n\n.aurora .dark, .aurora.dark, .ios .dark, .ios.dark, .md .dark, .md.dark {\n    --f7-progressbar-bg-color: rgba(255, 255, 255, 0.15);\n}\n\n.aurora .progressbar, .aurora .progressbar-infinite, .aurora .progressbar span, .aurora .progressbar-infinite:before {\n    box-shadow: none;\n}\n\n.progressbar[class*='color-'] {\n    --f7-progressbar-bg-color: rgba(var(--f7-theme-color-rgb), 0.15);\n}\n\n.progressbar:after {\n    align-items: center;\n    color: #FFFFFF;\n    content: attr(data-label);\n    display: flex;\n    font-size: 10px;\n    height: 100%;\n    letter-spacing: 0.5px;\n    justify-content: center;\n    padding: 0 4px;\n}\n\n.progressbar span {\n    z-index: -1;\n}\n\n.progressbar-round {\n    border-radius: var(--f7-progressbar-height);\n}\n\n.progressbar-round:after {\n    padding: 0 8px;\n}\n\n.progressbar[data-label] {\n    --f7-progressbar-height: 16px;\n}\n\n.progressbar[data-label-position=start]:after {\n    justify-content: flex-start;\n}\n\n.progressbar[data-label-position=end]:after {\n    justify-content: flex-end;\n}\n\n.framework7-root > .progressbar, .framework7-root > .progressbar-infinite,\n.page > .progressbar, .page > .progressbar-infinite,\n.panel > .progressbar, .panel > .progressbar-infinite,\n.popup > .progressbar, .popup > .progressbar-infinite,\n.view > .progressbar, .view > .progressbar-infinite,\n.views > .progressbar, .views > .progressbar-infinite,\nbody > .progressbar, body > .progressbar-infinite {\n    --f7-progressbar-height: 4px;\n}\n\n[dir=rtl].ios .progressbar-infinite.color-multi:before {\n    animation: rtl-ios-progressbar-infinite-multicolor 3s linear infinite;\n}\n\n@keyframes rtl-ios-progressbar-infinite-multicolor {\n    0% {\n        transform: translate3d(0%, 0, 0);\n    }\n    100% {\n        transform: translate3d(50%, 0, 0);\n    }\n}\n\n/*\n|------------------------------------------------------------------------------\n| Pull-to-Refresh\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-ptr-preloader-size: 24px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Quote\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-quote-border-width: 6px;\n}\n\nq {\n    font-style: italic;\n}\n\nblockquote, .quote {\n    background-color: var(--f7-block-strong-bg-color);\n    border-color: var(--f7-color-mono);\n    border-style: solid;\n    border-width: 0 0 0 var(--f7-quote-border-width);\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    font-size: inherit;\n    font-style: italic;\n    margin: calc(var(--f7-block-margin-vertical) / 2) 0;\n    padding-bottom: var(--f7-block-padding-vertical);\n    padding-left: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-left));\n    padding-right: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-right));\n    padding-top: 4em;\n    position: relative;\n}\n\n[dir=rtl] blockquote, [dir=rtl] .quote {\n    border-width: 0 var(--f7-quote-border-width) 0 0;\n}\n\n.block-strong blockquote, .block-strong .quote {\n    margin: 0;\n}\n\nblockquote.inset, .quote.inset {\n    border-radius: 0 var(--f7-block-inset-border-radius) var(--f7-block-inset-border-radius) 0;\n    margin-left: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-left));\n    margin-right: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-right));\n    --f7-safe-area-left: 0px;\n    --f7-safe-area-right: 0px;\n}\n\n[dir=rtl] blockquote.inset, [dir=rtl] .quote.inset {\n    border-radius: var(--f7-block-inset-border-radius) 0 0 var(--f7-block-inset-border-radius);\n}\n\nblockquote.pull-quote, .quote.pull-quote {\n    border-width: 0;\n    text-align: center;\n}\n\nblockquote.inset.pull-quote, .quote.inset.pull-quote {\n    border-radius: var(--f7-block-inset-border-radius);\n}\n\nblockquote.pull-quote:before, .quote.pull-quote:before {\n    left: 0;\n    right: 0;\n}\n\nblockquote.border-left, .quote.border-left {\n    border-width: 0 0 0 var(--f7-quote-border-width);\n}\n\nblockquote.inset.border-left, .quote.inset.border-left {\n    border-radius: 0 var(--f7-block-inset-border-radius) var(--f7-block-inset-border-radius) 0;\n}\n\nblockquote.border-right, .quote.border-right {\n    border-width: 0 var(--f7-quote-border-width) 0 0;\n}\n\nblockquote.inset.border-right, .quote.inset.border-right {\n    border-radius: var(--f7-block-inset-border-radius) 0 0 var(--f7-block-inset-border-radius);\n}\n\nblockquote.border-vertical, .quote.border-vertical {\n    border-width: 0 var(--f7-quote-border-width) 0 var(--f7-quote-border-width);\n}\n\nblockquote.inset.border-vertical, .quote.inset.border-vertical {\n    border-radius: 0;\n}\n\nblockquote.border-top, .quote.border-top {\n    border-width: var(--f7-quote-border-width) 0 0 0;\n}\n\nblockquote.inset.border-top, .quote.inset.border-top {\n    border-radius: 0 0 var(--f7-block-inset-border-radius) var(--f7-block-inset-border-radius);\n}\n\nblockquote.border-bottom, .quote.border-bottom {\n    border-width: 0 0 var(--f7-quote-border-width) 0;\n}\n\nblockquote.inset.border-bottom, .quote.inset.border-bottom {\n    border-radius: var(--f7-block-inset-border-radius) var(--f7-block-inset-border-radius) 0 0;\n}\n\nblockquote.border-horizontal, .quote.border-horizontal {\n    border-width: var(--f7-quote-border-width) 0 var(--f7-quote-border-width) 0;\n}\n\nblockquote.inset.border-horizontal, .quote.inset.border-horizontal {\n    border-radius: 0;\n}\n\nblockquote.border-outline, .quote.border-outline {\n    border-radius: 0;\n    border-width: var(--f7-quote-border-width);\n}\n\nblockquote.inset.border-outline, .quote.inset.border-outline {\n    border-radius: var(--f7-block-inset-border-radius);\n}\n\nblockquote[class*='color-'], .quote[class*='color-'] {\n    border-color: var(--f7-theme-color);\n}\n\nblockquote:before, .quote:before {\n    content: '\\201C';\n    font-family: 'Georgia', 'Times New Roman', serif;\n    font-size: 8em;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 0;\n    position: absolute;\n}\n\n[dir=rtl] blockquote:before, [dir=rtl] .quote:before {\n    content: '\\201D';\n}\n\nblockquote[class*='color-']:before, .quote[class*='color-']:before {\n    color: var(--f7-theme-color);\n}\n\nblockquote .quote-text, .quote .quote-text {\n    font-style: italic;\n}\n\nblockquote .quote-cite, .quote .quote-cite {\n    font-size: 0.85em;\n    font-style: normal;\n}\n\nblockquote .quote-text + .quote-cite, .quote .quote-text + .quote-cite {\n    margin-top: 12px;\n}\n\nblockquote .quote-cite .cite-title, .quote .quote-cite .cite-title {\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n}\n\nblockquote .quote-cite .cite-subtitle, .quote .quote-cite .cite-subtitle {\n    color: var(--f7-block-footer-text-color);\n    font-size: 0.95em;\n}\n\nblockquote[class*='color-'] .quote-cite .cite-title, .quote[class*='color-'] .quote-cite .cite-title {\n    color: var(--f7-theme-color);\n}\n\nblockquote.quote-fade[class*='color-'], .quote.quote-fade[class*='color-'] {\n    background-color: rgba(var(--f7-theme-color-rgb), 0.15);\n}\n\nblockquote.quote-fill[class*='color-'], .quote.quote-fill[class*='color-'] {\n    background-color: var(--f7-theme-color);\n    border-color: rgba(0, 0, 0, 0.25);\n    color: #FFFFFF;\n}\n\nblockquote.quote-fill[class*='color-']:before, .quote.quote-fill[class*='color-']:before {\n    color: #FFFFFF;\n}\n\nblockquote.quote-fill[class*='color-'] .quote-cite, .quote.quote-fill[class*='color-'] .quote-cite,\nblockquote.quote-fill[class*='color-'] .quote-cite .cite-title, .quote.quote-fill[class*='color-'] .quote-cite .cite-title,\nblockquote.quote-fill[class*='color-'] .quote-cite .cite-subtitle, .quote.quote-fill[class*='color-'] .quote-cite .cite-subtitle {\n    color: #FFFFFF;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Range Slider\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-range-label-bg-color: var(--f7-theme-color);\n    --f7-range-label-text-color: #FFFFFF;\n}\n\n.range-slider[class*='color-'] {\n    --f7-range-label-bg-color: var(--f7-theme-color);\n}\n\n[dir=rtl] .range-slider-vertical .range-scale-step {\n    justify-content: flex-start;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Rating\n|------------------------------------------------------------------------------\n*/\n\n.jq-ry-container {\n    padding: 0;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Responsive Container\n|------------------------------------------------------------------------------\n*/\n\n.responsive-wrapper {\n    border-radius: inherit;\n    max-width: 100%;\n    overflow: hidden;\n}\n\n.responsive-container {\n    clear: both;\n    float: none;\n    height: 0;\n    overflow: hidden;\n    padding-bottom: 56.25%;\n    position: relative;\n    width: 100%;\n}\n\n.responsive-container .responsive-content {\n    border: none;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    right: auto;\n    top: 0;\n    width: 100%;\n}\n\n[dir=rtl] .responsive-container .responsive-content {\n    left: auto;\n    right: 0;\n}\n\n.responsive-container.aspect-ratio-1-1 {\n    padding-bottom: 100%;\n}\n\n.responsive-container.aspect-ratio-6-5 {\n    padding-bottom: 83.33%;\n}\n\n.responsive-container.aspect-ratio-5-4 {\n    padding-bottom: 80%;\n}\n\n.responsive-container.aspect-ratio-4-3 {\n    padding-bottom: 75%;\n}\n\n.responsive-container.aspect-ratio-11-8 {\n    padding-bottom: 72.73%;\n}\n\n.responsive-container.aspect-ratio-3-2 {\n    padding-bottom: 66.67%;\n}\n\n.responsive-container.aspect-ratio-8-5 {\n    padding-bottom: 62.5%;\n}\n\n.responsive-container.aspect-ratio-5-3 {\n    padding-bottom: 60%;\n}\n\n.responsive-container.aspect-ratio-16-9 {\n    padding-bottom: 56.25%;\n}\n\n.responsive-container.aspect-ratio-2-1 {\n    padding-bottom: 50%;\n}\n\n.responsive-container.aspect-ratio-21-9 {\n    padding-bottom: 42.86%;\n}\n\n.responsive-container.aspect-ratio-3-1 {\n    padding-bottom: 33.33%;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Ribbon\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-ribbon-border-radius: 0.475rem;\n    --f7-ribbon-clip-color: rgba(0, 0, 0, 0.75);\n    --f7-ribbon-spacing: 8px;\n}\n\n:root .dark, :root.dark {\n    --f7-ribbon-clip-color: rgba(255, 255, 255, 0.25);\n}\n\n.ribbon {\n    align-items: center;\n    background-color: var(--f7-theme-color);\n    color: #FFFFFF;\n    display: flex;\n    font-size: 12px;\n    font-weight: normal;\n    justify-content: center;\n    max-width: 100%;\n    overflow: hidden;\n    padding: 4px 8px;\n    position: absolute;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    z-index: 100;\n}\n\n.ribbon.ribbon-left-top {\n    left: 0;\n    top: 0;\n    right: auto;\n    bottom: auto;\n    transform: translateX(calc(var(--f7-ribbon-spacing) * -1)) translateY(calc(var(--f7-ribbon-spacing) * 1));\n}\n\n.ribbon.ribbon-right-top {\n    right: 0;\n    top: 0;\n    left: auto;\n    bottom: auto;\n    transform: translateX(calc(var(--f7-ribbon-spacing) * 1)) translateY(calc(var(--f7-ribbon-spacing) * 1));\n}\n\n.ribbon.ribbon-right-bottom {\n    right: 0;\n    bottom: 0;\n    left: auto;\n    top: auto;\n    transform: translateX(calc(var(--f7-ribbon-spacing) * 1)) translateY(calc(var(--f7-ribbon-spacing) * -1));\n}\n\n.ribbon.ribbon-left-bottom {\n    left: 0;\n    bottom: 0;\n    right: auto;\n    top: auto;\n    transform: translateX(calc(var(--f7-ribbon-spacing) * -1)) translateY(calc(var(--f7-ribbon-spacing) * -1));\n}\n\n.ribbon.ribbon-left-center {\n    left: 0;\n    top: 50%;\n    right: auto;\n    bottom: auto;\n    transform: translateX(calc(var(--f7-ribbon-spacing) * -1)) translateY(-50%);\n}\n\n.ribbon.ribbon-top-center {\n    top: 0;\n    left: 50%;\n    bottom: auto;\n    right: auto;\n    transform: translateY(calc(var(--f7-ribbon-spacing) * -1)) translateX(-50%);\n}\n\n.ribbon.ribbon-right-center {\n    right: 0;\n    top: 50%;\n    left: auto;\n    bottom: auto;\n    transform: translateX(calc(var(--f7-ribbon-spacing) * 1)) translateY(-50%)\n}\n\n.ribbon.ribbon-bottom-center {\n    bottom: 0;\n    left: 50%;\n    top: auto;\n    right: auto;\n    transform: translateY(calc(var(--f7-ribbon-spacing) * 1)) translateX(-50%);\n}\n\n.ribbon.ribbon-top-left {\n    top: 0;\n    left: 0;\n    bottom: auto;\n    right: auto;\n    transform: translateY(calc(var(--f7-ribbon-spacing) * -1)) translateX(calc(var(--f7-ribbon-spacing) * 1));\n}\n\n.ribbon.ribbon-top-right {\n    top: 0;\n    right: 0;\n    bottom: auto;\n    left: auto;\n    transform: translateY(calc(var(--f7-ribbon-spacing) * -1)) translateX(calc(var(--f7-ribbon-spacing) * -1));\n}\n\n.ribbon.ribbon-bottom-right {\n    bottom: 0;\n    right: 0;\n    top: auto;\n    left: auto;\n    transform: translateY(calc(var(--f7-ribbon-spacing) * 1)) translateX(calc(var(--f7-ribbon-spacing) * -1));\n}\n\n.ribbon.ribbon-bottom-left {\n    bottom: 0;\n    left: 0;\n    top: auto;\n    right: auto;\n    transform: translateY(calc(var(--f7-ribbon-spacing) * 1)) translateX(calc(var(--f7-ribbon-spacing) * 1));\n}\n\n.ribbon-round.ribbon-left-top, .ribbon-round.ribbon-left-center, .ribbon-round.ribbon-left-bottom {\n    border-radius: 0 var(--f7-ribbon-border-radius) var(--f7-ribbon-border-radius) 0;\n}\n\n.ribbon-round.ribbon-right-top, .ribbon-round.ribbon-right-center, .ribbon-round.ribbon-right-bottom {\n    border-radius: var(--f7-ribbon-border-radius) 0 0 var(--f7-ribbon-border-radius);\n}\n\n.ribbon-round.ribbon-top-left, .ribbon-round.ribbon-top-center, .ribbon-round.ribbon-top-right {\n    border-radius: 0 0 var(--f7-ribbon-border-radius) var(--f7-ribbon-border-radius);\n}\n\n.ribbon-round.ribbon-bottom-left, .ribbon-round.ribbon-bottom-center, .ribbon-round.ribbon-bottom-right {\n    border-radius: var(--f7-ribbon-border-radius) var(--f7-ribbon-border-radius) 0 0;\n}\n\n.ribbon.ribbon-clip {\n    overflow: visible;\n}\n\n.ribbon.ribbon-clip:before {\n    border-style: solid;\n    content: '';\n    position: absolute;\n}\n\n.ribbon.ribbon-clip:after {\n    border-style: solid;\n    content: '';\n    position: absolute;\n}\n\n.ribbon.ribbon-clip.ribbon-left-top:before {\n    content: none;\n}\n\n.ribbon.ribbon-clip.ribbon-left-top:after {\n    left: 0;\n    right: auto;\n    bottom: calc(var(--f7-ribbon-spacing) * -1);\n    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;\n    border-width: 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0;\n}\n\n.ribbon.ribbon-clip.ribbon-right-top:before {\n    content: none;\n}\n\n.ribbon.ribbon-clip.ribbon-right-top:after {\n    left: auto;\n    right: 0;\n    bottom: calc(var(--f7-ribbon-spacing) * -1);\n    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);\n    border-width: 0 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing);\n}\n\n.ribbon.ribbon-clip.ribbon-right-bottom:before {\n    left: auto;\n    right: 0;\n    top: calc(var(--f7-ribbon-spacing) * -1);\n    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);\n    border-width: var(--f7-ribbon-spacing) 0 0 var(--f7-ribbon-spacing);\n}\n\n.ribbon.ribbon-clip.ribbon-right-bottom:after {\n    content: none;\n}\n\n.ribbon.ribbon-clip.ribbon-left-bottom:before {\n    left: 0;\n    right: auto;\n    top: calc(var(--f7-ribbon-spacing) * -1);\n    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;\n    border-width: var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0 0;\n}\n\n.ribbon.ribbon-clip.ribbon-left-bottom:after {\n    content: none;\n}\n\n.ribbon.ribbon-clip.ribbon-left-center:before {\n    left: 0;\n    right: auto;\n    top: calc(var(--f7-ribbon-spacing) * -1);\n    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;\n    border-width: var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0 0;\n}\n\n.ribbon.ribbon-clip.ribbon-left-center:after {\n    left: 0;\n    right: auto;\n    bottom: calc(var(--f7-ribbon-spacing) * -1);\n    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;\n    border-width: 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0;\n}\n\n.ribbon.ribbon-clip.ribbon-top-center:before {\n    left: calc(var(--f7-ribbon-spacing) * -1);\n    right: auto;\n    top: 0;\n    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;\n    border-width: var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0 0;\n}\n\n.ribbon.ribbon-clip.ribbon-top-center:after {\n    left: auto;\n    right: calc(var(--f7-ribbon-spacing) * -1);\n    top: 0;\n    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);\n    border-width: var(--f7-ribbon-spacing) 0 0 var(--f7-ribbon-spacing);\n}\n\n.ribbon.ribbon-clip.ribbon-right-center:before {\n    left: auto;\n    right: 0;\n    top: calc(var(--f7-ribbon-spacing) * -1);\n    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);\n    border-width: var(--f7-ribbon-spacing) 0 0 var(--f7-ribbon-spacing);\n}\n\n.ribbon.ribbon-clip.ribbon-right-center:after {\n    left: auto;\n    right: 0;\n    bottom: calc(var(--f7-ribbon-spacing) * -1);\n    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);\n    border-width: 0 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing);\n}\n\n.ribbon.ribbon-clip.ribbon-bottom-center:before {\n    left: calc(var(--f7-ribbon-spacing) * -1);\n    right: auto;\n    bottom: 0;\n    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;\n    border-width: 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0;\n}\n\n.ribbon.ribbon-clip.ribbon-bottom-center:after {\n    left: auto;\n    right: calc(var(--f7-ribbon-spacing) * -1);\n    bottom: 0;\n    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);\n    border-width: 0 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing);\n}\n\n.ribbon.ribbon-clip.ribbon-top-left:before {\n    content: none;\n}\n\n.ribbon.ribbon-clip.ribbon-top-left:after {\n    left: auto;\n    right: calc(var(--f7-ribbon-spacing) * -1);\n    top: 0;\n    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);\n    border-width: var(--f7-ribbon-spacing) 0 0 var(--f7-ribbon-spacing);\n}\n\n.ribbon.ribbon-clip.ribbon-top-right:before {\n    left: calc(var(--f7-ribbon-spacing) * -1);\n    right: auto;\n    top: 0;\n    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;\n    border-width: var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0 0;\n}\n\n.ribbon.ribbon-clip.ribbon-top-right:after {\n    content: none;\n}\n\n.ribbon.ribbon-clip.ribbon-bottom-right:before {\n    left: calc(var(--f7-ribbon-spacing) * -1);\n    right: auto;\n    bottom: 0;\n    border-color: transparent var(--f7-ribbon-clip-color) transparent transparent;\n    border-width: 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing) 0;\n}\n\n.ribbon.ribbon-clip.ribbon-bottom-right:after {\n    content: none;\n}\n\n.ribbon.ribbon-clip.ribbon-bottom-left:before {\n    content: none;\n}\n\n.ribbon.ribbon-clip.ribbon-bottom-left:after {\n    left: auto;\n    right: calc(var(--f7-ribbon-spacing) * -1);\n    bottom: 0;\n    border-color: transparent transparent transparent var(--f7-ribbon-clip-color);\n    border-width: 0 0 var(--f7-ribbon-spacing) var(--f7-ribbon-spacing);\n}\n\n.ribbon-corner {\n    align-items: flex-end;\n    background: none;\n    border-style: solid;\n    border-width: 2rem;\n    box-shadow: none;\n    height: 0;\n    justify-content: flex-start;\n    overflow: visible;\n    padding: 0;\n    transform: none !important;\n    width: 0;\n}\n\n.ribbon-corner {\n    bottom: auto;\n    left: auto;\n    right: 0;\n    top: 0;\n    border-bottom-color: transparent;\n    border-left-color: transparent;\n    border-right-color: var(--f7-theme-color);\n    border-top-color: var(--f7-theme-color);\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: 0;\n    border-top-right-radius: inherit;\n}\n\n[dir=rtl] .ribbon-corner {\n    bottom: auto;\n    left: 0;\n    right: auto;\n    top: 0;\n    border-bottom-color: transparent;\n    border-left-color: var(--f7-theme-color);\n    border-right-color: transparent;\n    border-top-color: var(--f7-theme-color);\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: inherit;\n    border-top-right-radius: 0;\n}\n\n.ribbon-corner.ribbon-corner-top-left {\n    bottom: auto;\n    left: 0;\n    right: auto;\n    top: 0;\n    border-bottom-color: transparent;\n    border-left-color: var(--f7-theme-color);\n    border-right-color: transparent;\n    border-top-color: var(--f7-theme-color);\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: inherit;\n    border-top-right-radius: 0;\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n[dir=rtl] .ribbon-corner.ribbon-corner-top-left {\n    justify-content: flex-start;\n}\n\n.ribbon-corner.ribbon-corner-top-right {\n    bottom: auto;\n    left: auto;\n    right: 0;\n    top: 0;\n    border-bottom-color: transparent;\n    border-left-color: transparent;\n    border-right-color: var(--f7-theme-color);\n    border-top-color: var(--f7-theme-color);\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: 0;\n    border-top-right-radius: inherit;\n    align-items: flex-end;\n    justify-content: flex-start;\n}\n\n[dir=rtl] .ribbon-corner.ribbon-corner-top-right {\n    justify-content: flex-end;\n}\n\n.ribbon-corner.ribbon-corner-bottom-right {\n    bottom: 0;\n    left: auto;\n    right: 0;\n    top: auto;\n    border-bottom-color: var(--f7-theme-color);\n    border-left-color: transparent;\n    border-right-color: var(--f7-theme-color);\n    border-top-color: transparent;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: inherit;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n[dir=rtl] .ribbon-corner.ribbon-corner-bottom-right {\n    justify-content: flex-end;\n}\n\n.ribbon-corner.ribbon-corner-bottom-left {\n    bottom: 0;\n    left: 0;\n    right: auto;\n    top: auto;\n    border-bottom-color: var(--f7-theme-color);\n    border-left-color: var(--f7-theme-color);\n    border-right-color: transparent;\n    border-top-color: transparent;\n    border-bottom-left-radius: inherit;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    align-items: flex-start;\n    justify-content: flex-end;\n}\n\n[dir=rtl] .ribbon-corner.ribbon-corner-bottom-left {\n    justify-content: flex-start;\n}\n\n.ribbon-vertical {\n    min-height: 48px;\n    min-width: 24px;\n    text-align: center;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Scroll Bar\n|------------------------------------------------------------------------------\n*/\n\n.device-desktop * {\n    scrollbar-color: var(--color-gray-500) var(--color-gray-300);\n    scrollbar-width: auto;\n}\n\n.device-desktop .dark *, .device-desktop.dark * {\n    scrollbar-color: var(--color-gray-800) var(--color-gray-700);\n}\n\n.device-desktop *::-webkit-scrollbar {\n    height: 4px;\n    width: 8px;\n}\n\n.device-desktop *::-webkit-scrollbar-track {\n    background-color: var(--color-gray-300);\n}\n\n.device-desktop .dark *::-webkit-scrollbar-track, .device-desktop.dark *::-webkit-scrollbar-track {\n    background-color: var(--color-gray-700);\n}\n\n.device-desktop *::-webkit-scrollbar-thumb {\n    background-color: var(--color-gray-500);\n    border-color: var(--color-gray-500);\n    border-radius: 0;\n    border-style: none;\n    border-width: 0;\n}\n\n.device-desktop .dark *::-webkit-scrollbar-thumb, .device-desktop.dark *::-webkit-scrollbar-thumb {\n    background-color: var(--color-gray-800);\n    border-color: var(--color-gray-800);\n}\n\n.no-scrollbar::-webkit-scrollbar {\n    display: none;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Searchbar\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-searchbar-input-font-size: 16px;\n    --f7-searchbar-in-page-content-input-border-radius: var(--f7-searchbar-input-border-radius);\n}\n\n.md {\n    --f7-searchbar-input-border-radius: 4px;\n}\n\n.md .searchbar-icon {\n    --f7-safe-area-left: 0px;\n    --f7-safe-area-right: 0px;\n}\n\n[dir=rtl].md .searchbar-icon {\n    right: calc(8px + var(--f7-safe-area-right));\n}\n\n/*\n|------------------------------------------------------------------------------\n| Shape & Size\n|------------------------------------------------------------------------------\n*/\n\n.shape-container {\n    align-items: center;\n    box-sizing: border-box;\n    display: inline-flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: hidden;\n    padding: 12px;\n    text-align: center;\n}\n\n.shape-circle {\n    border-radius: 50%;\n}\n\n.shape-rounded-square {\n    border-radius: var(--f7-block-inset-border-radius);\n}\n\n.aurora .shape-auto {\n    border-radius: var(--f7-block-inset-border-radius);\n}\n\n.ios .shape-auto {\n    border-radius: var(--f7-block-inset-border-radius);\n}\n\n.md .shape-auto {\n    border-radius: 50%;\n}\n\n.shape-inherit {\n    border-radius: inherit !important;\n}\n\n.shape-none {\n    border-radius: 0 !important;\n}\n\n.size-8 {\n    height: 8px;\n    width: 8px;\n}\n\n.size-12 {\n    height: 12px;\n    width: 12px;\n}\n\n.size-16 {\n    height: 16px;\n    width: 16px;\n}\n\n.size-20 {\n    height: 20px;\n    width: 20px;\n}\n\n.size-24 {\n    height: 24px;\n    width: 24px;\n}\n\n.size-32 {\n    height: 32px;\n    width: 32px;\n}\n\n.size-40 {\n    height: 40px;\n    width: 40px;\n}\n\n.size-48 {\n    height: 48px;\n    width: 48px;\n}\n\n.size-56 {\n    height: 56px;\n    width: 56px;\n}\n\n.size-64 {\n    height: 64px;\n    width: 64px;\n}\n\n.size-72 {\n    height: 72px;\n    width: 72px;\n}\n\n.size-80 {\n    height: 80px;\n    width: 80px;\n}\n\n.size-96 {\n    height: 96px;\n    width: 96px;\n}\n\n.size-112 {\n    height: 112px;\n    width: 112px;\n}\n\n.size-128 {\n    height: 128px;\n    width: 128px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Sheet Modal\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-sheet-height: auto;\n}\n\n.aurora, .ios, .md {\n    --f7-sheet-border-color: transparent;\n}\n\n.sheet-modal {\n    border-radius: 16px 16px 0 0px;\n    overflow: hidden;\n}\n\n.sheet-modal-top {\n    border-radius: 0 0 16px 16px;\n}\n\n.sheet-modal-top .toolbar-bottom + .sheet-modal-inner {\n    padding-bottom: var(--f7-toolbar-height);\n}\n\n.sheet-modal-bottom:before, .sheet-modal:not(.sheet-modal-top):before {\n    background-color: transparent;\n}\n\n.sheet-modal .sheet-modal-inner {\n    max-height: 75vh;\n    overflow-y: auto;\n}\n\n.swipe-handler {\n    background-color: inherit;\n    cursor: pointer;\n    height: 16px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    transform: translate3d(0, 0, 1px);\n    width: 100%;\n    z-index: 999;\n}\n\n.swipe-handler:after {\n    background-color: var(--f7-color-gray);\n    border-radius: 3px;\n    content: '';\n    height: 6px;\n    left: 50%;\n    position: absolute;\n    top: 50%;\n    transform: translateX(-18px) translateY(-3px);\n    width: 36px;\n}\n\n.sheet-modal .list ul {\n    --f7-list-bg-color: transparent;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Show More/Less\n|------------------------------------------------------------------------------\n*/\n\n.show-more-less .hidden {\n    display: none;\n}\n\n.show-more-less > p:first-child {\n    margin-top: 0;\n}\n\n.show-more-less > p:last-child {\n    margin-bottom: 0;\n}\n\n.block ul.show-more-less {\n    margin: 0;\n}\n\ndiv.show-more-wrapper {\n    margin-top: calc(var(--f7-typography-margin) / 2);\n}\n\nspan.show-more-wrapper {\n    margin-left: calc(var(--f7-typography-margin) / 2);\n}\n\n[dir=rtl] span.show-more-wrapper {\n    margin-right: calc(var(--f7-typography-margin) / 2);\n}\n\n.show-more-btn {\n    background: transparent;\n    border: 0;\n    color: var(--f7-theme-color);\n    cursor: pointer;\n    display: inline-flex;\n    font-size: inherit;\n    margin: auto;\n    outline: 0;\n    padding: 0;\n    white-space: nowrap;\n    width: auto;\n}\n\n.data-table .show-more-less + .show-more-btn {\n    margin: var(--f7-table-label-cell-padding-horizontal);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Side Panel\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-panel-bg-color: var(--color-gray-50);\n}\n\n:root .dark, :root.dark {\n    --f7-panel-bg-color: var(--color-gray-900);\n}\n\n.aurora, .ios, .md {\n    --f7-panel-collapsed-width: 56px;\n}\n\n.panel {\n    box-shadow: var(--f7-elevation-1);\n}\n\n.panel-in-collapsed {\n    transform: translate3d(0, 0, 0) !important;\n    transition-duration: 0s;\n}\n\n.panel-left.panel-in-collapsed {\n    --f7-panel-width: calc(var(--f7-safe-area-left) + var(--f7-panel-collapsed-width));\n}\n\n.panel-right.panel-in-collapsed {\n    --f7-panel-width: calc(var(--f7-safe-area-right) + var(--f7-panel-collapsed-width));\n}\n\n.panel-in .panel-in-hide {\n    display: none;\n}\n\n.panel-in-collapsed .panel-collapsed-hide {\n    display: none;\n}\n\n.panel-in-breakpoint .panel-breakpoint-hide,\n.panel-in-swipe .panel-breakpoint-hide {\n    display: none;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Signature Pad\n|------------------------------------------------------------------------------\n*/\n\n.signature-pad {\n    border: 2px dashed var(--f7-text-color);\n    border-radius: var(--f7-block-inset-border-radius);\n    clear: both;\n    float: none;\n    height: 0;\n    padding-bottom: 56.25%;\n    position: relative;\n    width: 100%;\n}\n\n.signature-pad[class*='color-'] {\n    border-color: var(--f7-theme-color);\n}\n\n.signature-pad .signature-pad-canvas {\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Skeleton\n|------------------------------------------------------------------------------\n*/\n\n[dir=rtl] .skeleton-effect-blink, [dir=rtl] .skeleton-effect-wave {\n    animation-direction: reverse;\n}\n\n.skeleton-block[class*='color-'] {\n    --skeleton-color: rgba(var(--f7-theme-color-rgb), 0.125);\n}\n\n.skeleton-text[class*='color-'], .skeleton-text[class*='color-'] * {\n    --skeleton-color: rgba(var(--f7-theme-color-rgb), 0.125);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Smart Select\n|------------------------------------------------------------------------------\n*/\n\n.smart-select-page .list {\n    border-radius: var(--f7-list-inset-border-radius);\n    margin-bottom: var(--f7-typography-margin);\n    margin-left: calc(var(--f7-list-inset-side-margin) + var(--f7-safe-area-outer-left));\n    margin-right: calc(var(--f7-list-inset-side-margin) + var(--f7-safe-area-outer-right));\n    margin-top: var(--f7-typography-margin);\n    --f7-safe-area-left: 0px;\n    --f7-safe-area-right: 0px;\n}\n\n.smart-select-page .list ul {\n    border-radius: var(--f7-list-inset-border-radius);\n}\n\n.smart-select-page .list ul:before, .smart-select-page .list ul:after {\n    display: none !important;\n}\n\n.smart-select-page .list .item-media img {\n    height: auto;\n    width: 32px;\n}\n\n.smart-select-page .searchbar-not-found {\n    margin: 0;\n    padding: 0;\n}\n\n.smart-select-sheet {\n    --f7-sheet-height: 256px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Sortable List\n|------------------------------------------------------------------------------\n*/\n\n.aurora .sortable-handler:after, .ios .sortable-handler:after, .md .sortable-handler:after {\n    content: 'sort_md';\n}\n\n/*\n|------------------------------------------------------------------------------\n| State Toggle\n|------------------------------------------------------------------------------\n*/\n\n.state-toggle .state-active, .state-toggle .state-inactive {\n    margin: 0 !important;\n}\n\n.state-toggle:not(.state-toggle-active) .state-active {\n    display: none;\n}\n\n.state-toggle.state-toggle-active .state-inactive {\n    display: none;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Stepper\n|------------------------------------------------------------------------------\n*/\n\n.ios {\n    --f7-stepper-border-radius: 8px;\n    --f7-stepper-height: 36px;\n    --f7-stepper-large-height: 48px;\n    --f7-stepper-small-height: 28px;\n    --f7-stepper-value-font-size: 14px;\n}\n\n.stepper {\n    --f7-stepper-vertical-width: var(--f7-stepper-height);\n}\n\n.stepper-small {\n    --f7-stepper-vertical-width: var(--f7-stepper-small-height);\n}\n\n.stepper-large {\n    --f7-stepper-vertical-width: var(--f7-stepper-large-height);\n}\n\n[dir=rtl] .stepper .stepper-button-minus {\n    order: 2;\n}\n\n[dir=rtl] .stepper .stepper-input-wrap, [dir=rtl] .stepper .stepper-value {\n    order: 1;\n}\n\n[dir=rtl] .stepper .stepper-button-plus {\n    order: 0;\n}\n\n[dir=rtl] .stepper-button-minus:first-child, [dir=rtl] .stepper-button-plus:first-child, [dir=rtl] .stepper-button:first-child {\n    border-radius: 0 var(--f7-stepper-border-radius) var(--f7-stepper-border-radius) 0;\n}\n\n[dir=rtl] .stepper-button-minus:last-child, [dir=rtl] .stepper-button-plus:last-child, [dir=rtl] .stepper-button:last-child {\n    border-radius: var(--f7-stepper-border-radius) 0 0 var(--f7-stepper-border-radius);\n}\n\n.stepper .stepper-input-wrap input::-webkit-inner-spin-button, .stepper .stepper-input-wrap input::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    appearance: none;\n    margin: 0;\n}\n\n.stepper .stepper-input-wrap input,\n.stepper-value {\n    box-sizing: border-box;\n    padding-left: 4px;\n    padding-right: 4px;\n}\n\n.stepper .stepper-input-wrap input[type=number] {\n    -moz-appearance: textfield;\n}\n\n.stepper-vertical {\n    flex-direction: column;\n    height: auto;\n    width: var(--f7-stepper-vertical-width);\n}\n\n[dir=rtl] .stepper-vertical .stepper-input-wrap, [dir=rtl] .stepper-vertical .stepper-value,\n[dir=rtl] .stepper-vertical .stepper-button-minus, [dir=rtl] .stepper-vertical .stepper-button-plus {\n    order: unset;\n}\n\n.stepper-vertical .stepper-input-wrap, .stepper-vertical .stepper-value {\n    border-bottom: none;\n    border-left: var(--f7-stepper-border-width) solid var(--f7-theme-color);\n    border-right: var(--f7-stepper-border-width) solid var(--f7-theme-color);\n    border-top: none;\n    box-sizing: border-box;\n}\n\n.stepper-vertical .stepper-input-wrap, .stepper-vertical .stepper-value,\n.stepper-vertical .stepper-button-minus, .stepper-vertical .stepper-button-plus, .stepper-vertical .stepper-button {\n    height: 28px;\n    width: var(--f7-stepper-vertical-width);\n}\n\n.stepper-vertical .stepper-button-minus:first-child, .stepper-vertical .stepper-button-plus:first-child, .stepper-vertical .stepper-button:first-child {\n    border-radius: var(--f7-stepper-border-radius) var(--f7-stepper-border-radius) 0 0;\n}\n\n.stepper-vertical .stepper-button-minus:last-child, .stepper-vertical .stepper-button-plus:last-child, .stepper-vertical .stepper-button:last-child {\n    border-radius: 0 0 var(--f7-stepper-border-radius) var(--f7-stepper-border-radius);\n}\n\n.stepper-vertical .stepper-input-wrap input {\n    width: calc(var(--f7-stepper-vertical-width) - (var(--f7-stepper-border-width) * 2));\n}\n\n[dir=rtl] .stepper-button + .stepper-button,\n[dir=rtl] .stepper-button + .stepper-button-minus,\n[dir=rtl] .stepper-button + .stepper-button-plus,\n[dir=rtl] .stepper-button-minus + .stepper-button,\n[dir=rtl] .stepper-button-minus + .stepper-button-minus,\n[dir=rtl] .stepper-button-minus + .stepper-button-plus,\n[dir=rtl] .stepper-button-plus + .stepper-button,\n[dir=rtl] .stepper-button-plus + .stepper-button-minus,\n[dir=rtl] .stepper-button-plus + .stepper-button-plus {\n    border-left: var(--f7-stepper-border-width) solid var(--f7-theme-color);\n    border-right: 0;\n}\n\n.stepper-button.custom-icon:before, .stepper-button.custom-icon:after,\n.stepper-button-minus.custom-icon:before, .stepper-button-minus.custom-icon:after,\n.stepper-button-plus.custom-icon:before, .stepper-button-plus.custom-icon:after {\n    content: none;\n}\n\n.stepper.custom-style .stepper-value,\n.stepper.custom-style .stepper-input-wrap  {\n    border: none;\n    min-width: var(--f7-stepper-height);\n    width: auto;\n}\n\n.stepper.custom-style .stepper-input-wrap input {\n    min-width: var(--f7-stepper-height);\n}\n\n.stepper.custom-style .stepper-button, .stepper.custom-style .stepper-button-minus, .stepper.custom-style .stepper-button-plus {\n    border: none;\n    border-radius: 50%;\n    width: var(--f7-stepper-height);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Subnavbar\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-subnavbar-height: 48px;\n    --f7-subnavbar-title-font-size: 24px;\n    --f7-subnavbar-title-font-weight: bold;\n    --f7-subnavbar-title-letter-spacing: 0em;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Swipeout\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-swipeout-delete-button-bg-color: var(--f7-color-red);\n}\n\n.aurora, .ios, .md {\n    --f7-swipeout-button-font-size: 14px;\n    --f7-swipeout-button-font-weight: 500;\n}\n\n.swipeout-actions-left {\n    transform: translateX(-101%);\n}\n\n.swipeout-actions-right {\n    transform: translateX(101%);\n}\n\n.swipeout-actions-left > a, .swipeout-actions-right > a {\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n.swipeout-actions-left > a > *, .swipeout-actions-right > a > * {\n    margin-left: 3px;\n    margin-right: 3px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Swiper Slider\n|------------------------------------------------------------------------------\n*/\n\n.swiper-button-disabled {\n    cursor: auto;\n    opacity: 0.35;\n    pointer-events: none;\n}\n\n.swiper-navigation-button-next,\n.swiper-navigation-button-previous {\n    align-items: center;\n    color: #FFFFFF;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    position: absolute;\n    top: calc(50% - var(--f7-button-height) / 2);\n    z-index: 10;\n}\n\n.swiper-navigation-button-next,\n.swiper-rtl .swiper-navigation-button-previous {\n    right: 8px;\n    left: auto;\n}\n\n.swiper-navigation-button-previous,\n.swiper-rtl .swiper-navigation-button-next {\n    right: auto;\n    left: 8px;\n}\n\n.swiper-vertical .swiper-navigation-button-next {\n    bottom: 4px;\n    left: calc(50% - var(--f7-button-height) / 2);\n    right: calc(50% - var(--f7-button-height) / 2);\n    top: auto;\n}\n\n.swiper-vertical .swiper-navigation-button-previous {\n    bottom: auto;\n    left: calc(50% - var(--f7-button-height) / 2);\n    right: calc(50% - var(--f7-button-height) / 2);\n    top: 4px;\n}\n\n.swiper-thumbs .swiper-slide {\n    filter: grayscale(1);\n}\n\n.swiper-thumbs .swiper-slide-thumb-active {\n    filter: grayscale(0);\n}\n\n.swiper-pagination {\n    --swiper-pagination-bullet-inactive-color: var(--f7-color-gray);\n    --swiper-pagination-bullet-size: 8px;\n    --swiper-pagination-bullet-height: 8px;\n    --swiper-pagination-bullet-width: 8px;\n}\n\n.swiper-pagination-bullets .swiper-pagination-bullet {\n    border-radius: var(--swiper-pagination-bullet-size);\n}\n\n.swiper-pagination-bullets.swiper-pagination-pills {\n    --swiper-pagination-bullet-width: 24px;\n}\n\n.swiper-pagination-bullets.swiper-pagination-active-pill .swiper-pagination-bullet-active {\n    --swiper-pagination-bullet-width: 24px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Syntax Hightlighter\n|------------------------------------------------------------------------------\n*/\n\npre, code {\n    direction: ltr;\n    font-size: 0.87em;\n}\n\npre.inline {\n    display: inline;\n}\n\npre.inline code, pre.inline code.hljs {\n    display: inline;\n    padding: 3px 6px;\n}\n\npre .hljs {\n    background-color:#F3F3F3;\n    color: #545454;\n}\n\n.dark pre .hljs {\n    background-color: #2B2B2B;\n    color: #F8F8F2;\n}\n\npre .hljs-comment, pre .hljs-quote {\n    color: #696969;\n}\n\n.dark pre .hljs-comment, .dark pre .hljs-quote {\n    color: #D4D0AB;\n}\n\npre .hljs-deletion, pre .hljs-name, pre .hljs-regexp, pre .hljs-selector-class, pre .hljs-selector-id, pre .hljs-tag, pre .hljs-template-variable, pre .hljs-variable {\n    color: #D91E18;\n}\n\n.dark pre .hljs-deletion, .dark pre .hljs-name, .dark pre .hljs-regexp, .dark pre .hljs-selector-class, .dark pre .hljs-selector-id, .dark pre .hljs-tag, .dark pre .hljs-template-variable, .dark pre .hljs-variable {\n    color: #FFA07A;\n}\n\npre .hljs-tag .hljs-attr, pre .hljs-tag .hljs-name {\n    color: #D91E18;\n}\n\n.dark pre .hljs-tag .hljs-attr, .dark pre .hljs-tag .hljs-name {\n    color: #FFA07A;\n}\n\npre .hljs-attribute, pre .hljs-built_in, pre .hljs-link, pre .hljs-literal, pre .hljs-meta, pre .hljs-number, pre .hljs-params, pre .hljs-type {\n    color: #AA5D00;\n}\n\n.dark pre .hljs-attribute {\n    color: #FFD700;\n}\n\n.dark pre .hljs-built_in, .dark pre .hljs-link, .dark pre .hljs-literal, .dark pre .hljs-meta, .dark pre .hljs-number, .dark pre .hljs-params, .dark pre .hljs-type {\n    color: #F5AB35;\n}\n\npre .hljs-addition, pre .hljs-bullet, pre .hljs-string, pre .hljs-symbol {\n    color: #008000;\n}\n\n.dark pre .hljs-addition, .dark pre .hljs-bullet, .dark pre .hljs-string, .dark pre .hljs-symbol {\n    color: #ABE338;\n}\n\npre .hljs-section, pre .hljs-title {\n    color: #007FAA;\n}\n\n.dark pre .hljs-section, .dark pre .hljs-title {\n    color: #00E0E0;\n}\n\npre .hljs-keyword, pre .hljs-selector-tag {\n    color: #7928A1;\n}\n\n.dark pre .hljs-keyword, .dark pre .hljs-selector-tag {\n    color: #DCC6E0;\n}\n\n[dir=rtl] pre .menu-overlay {\n    left: auto;\n    right: var(--f7-typography-margin);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Tab\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-tabbar-icon-size: 20px;\n    --f7-tabbar-label-font-size: 12px;\n    --f7-tabbar-label-tablet-font-size: 12px;\n}\n\n.tabbar-labels .link, .tabbar-labels .tab-link {\n    justify-content: center;\n}\n\n@media (min-width: 768px) and (min-height: 600px) {\n    .ios .tabbar .link, .ios .tabbar .tab-link, .ios .tabbar-labels .link, .ios .tabbar-labels .tab-link {\n        flex-direction: column;\n    }\n}\n\n.tabbar-labels .tabbar-label {\n    margin-top: 4px;\n}\n\n.no-tab-link-highlight .tab-link-highlight {\n    display: none;\n}\n\n.tab-link .icons .icon + .icon-active, .tab-link .icons .icon-active + .icon {\n    margin: 0;\n}\n\n.tab-link:not(.tab-link-active) .icons .icon-active {\n    display: none;\n}\n\n.tab-link-active .icons .icon:not(.icon-active) {\n    display: none;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Text Editor\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-text-editor-bg-color: var(--f7-block-strong-bg-color);\n    --f7-text-editor-height: 256px;\n    --f7-text-editor-padding: 12px 16px;\n}\n\n:root .dark, :root.dark {\n    --f7-text-editor-bg-color: var(--f7-block-strong-bg-color);\n}\n\n.ios .dark, .ios.dark {\n    --f7-text-editor-toolbar-bg-color: var(--f7-bars-bg-color);\n}\n\n.text-editor.inset {\n    border: none;\n    border-radius: var(--f7-block-inset-border-radius);\n    margin-left: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-left));\n    margin-right: calc(var(--f7-block-inset-side-margin) + var(--f7-safe-area-outer-right));\n    overflow: hidden;\n    --f7-safe-area-left: 0px;\n    --f7-safe-area-right: 0px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Theme\n|------------------------------------------------------------------------------\n*/\n\nhtml.dark .if-not-dark {\n    display: none !important;\n}\n\nhtml:not(.dark) .if-dark {\n    display: none !important;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Timeline\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-timeline-item-inner-border-radius: var(--f7-card-border-radius);\n    --f7-timeline-item-inner-box-shadow: var(--f7-card-box-shadow);\n    --f7-timeline-item-title-font-size: var(--f7-font-size);\n    --f7-timeline-item-title-font-weight: 600;\n    --f7-timeline-item-subtitle-font-size: 14px;\n    --f7-timeline-item-text-color: var(--f7-list-item-text-text-color);\n    --f7-timeline-item-text-font-size: 14px;\n    --f7-timeline-year-font-size: 18px;\n    --f7-timeline-year-font-weight: bold;\n    --f7-timeline-month-font-size: 12px;\n    --f7-timeline-month-font-weight: 600;\n}\n\n.timeline {\n    --f7-timeline-divider-size: 12px;\n}\n\n.timeline-item-date {\n    line-height: 1;\n}\n\n.timeline-item-media, .timeline-item-title, .timeline-item-subtitle, .timeline-item-text {\n    margin: 4px 0;\n}\n\n.timeline-year-title {\n    color: var(--f7-theme-color);\n}\n\n.timeline-month-title {\n    color: rgba(var(--f7-theme-color-rgb), 0.75);\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n}\n\n.timeline-horizontal .timeline-item-date {\n    color: var(--f7-theme-color);\n    font-weight: 600;\n}\n\n[dir=rtl] .timeline-horizontal > .timeline-item:last-child:after,\n[dir=rtl] .timeline-horizontal .timeline-month:last-child .timeline-item:last-child:after {\n    display: block !important;\n}\n\n.timeline-item-day {\n    color: rgba(var(--f7-theme-color-rgb), 0.75);\n    font-size: 10px;\n    font-weight: 500;\n    text-transform: uppercase;\n}\n\n.timeline-item-divider {\n    align-items: center;\n    background-color: #CCCCCC;\n    color: #FFFFFF;\n    display: flex;\n    height: var(--f7-timeline-divider-size);\n    justify-content: center;\n    text-align: center;\n    width: var(--f7-timeline-divider-size);\n}\n\n.timeline-item-divider:after, .timeline-item-divider:before {\n    background-color: #CCCCCC;\n}\n\n.timeline-item-divider[class*='color-'] {\n    background-color: var(--f7-theme-color);\n}\n\n.timeline-item-divider[class*='color-']:after, .timeline-item-divider[class*='color-']:before {\n    background-color: var(--f7-theme-color);\n}\n\n.timeline.timeline-divider-icons {\n    --f7-timeline-divider-size: 24px;\n}\n\n.timeline.timeline-divider-icons .timeline-item-divider:after, .timeline.timeline-divider-icons .timeline-item-divider:before {\n    width: 2px;\n}\n\n.timeline-divider-icons .timeline-item-divider i, .timeline-divider-icons .timeline-item-divider .icon {\n    font-size: 16px;\n}\n\n.timeline-sides .timeline-item-right,\n.timeline-sides .timeline-item {\n    margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n    margin-right: 0;\n}\n\n.timeline-sides .timeline-item-left,\n.timeline-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {\n    margin-left: 0;\n    margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n}\n\n@media (min-width: 480px) {\n    .xsmall-sides .timeline-item-right,\n    .xsmall-sides .timeline-item {\n        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-right: 0;\n    }\n    .xsmall-sides .timeline-item-left,\n    .xsmall-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {\n        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-left: 0;\n    }\n}\n\n@media (min-width: 568px) {\n    .small-sides .timeline-item-right,\n    .small-sides .timeline-item {\n        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-right: 0;\n    }\n    .small-sides .timeline-item-left,\n    .small-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {\n        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-left: 0;\n    }\n}\n\n@media (min-width: 768px) {\n    .medium-sides .timeline-item-right,\n    .medium-sides .timeline-item {\n        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-right: 0;\n    }\n    .medium-sides .timeline-item-left,\n    .medium-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {\n        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-left: 0;\n    }\n}\n\n@media (min-width: 1024px) {\n    .large-sides .timeline-item-right,\n    .large-sides .timeline-item {\n        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-right: 0;\n    }\n    .large-sides .timeline-item-left,\n    .large-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {\n        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-left: 0;\n    }\n}\n\n@media (min-width: 1200px) {\n    .xlarge-sides .timeline-item-right,\n    .xlarge-sides .timeline-item {\n        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-right: 0;\n    }\n    .xlarge-sides .timeline-item-left,\n    .xlarge-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {\n        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-left: 0;\n    }\n}\n\n[dir=rtl] .timeline-sides .timeline-item-right,\n[dir=rtl] .timeline-sides .timeline-item {\n    margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n    margin-left: 0;\n}\n\n[dir=rtl] .timeline-sides .timeline-item-left,\n[dir=rtl] .timeline-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {\n    margin-right: 0;\n    margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n}\n\n@media (min-width: 480px) {\n    [dir=rtl] .xsmall-sides .timeline-item-right,\n    [dir=rtl] .xsmall-sides .timeline-item {\n        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-left: 0;\n    }\n    [dir=rtl] .xsmall-sides .timeline-item-left,\n    [dir=rtl] .xsmall-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {\n        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-right: 0;\n    }\n}\n\n@media (min-width: 568px) {\n    [dir=rtl] .small-sides .timeline-item-right,\n    [dir=rtl] .small-sides .timeline-item {\n        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-left: 0;\n    }\n    [dir=rtl] .small-sides .timeline-item-left,\n    [dir=rtl] .small-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {\n        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-right: 0;\n    }\n}\n\n@media (min-width: 768px) {\n    [dir=rtl] .medium-sides .timeline-item-right,\n    [dir=rtl] .medium-sides .timeline-item {\n        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-left: 0;\n    }\n    [dir=rtl] .medium-sides .timeline-item-left,\n    [dir=rtl] .medium-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {\n        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-right: 0;\n    }\n}\n\n@media (min-width: 1024px) {\n    [dir=rtl] .large-sides .timeline-item-right,\n    [dir=rtl] .large-sides .timeline-item {\n        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-left: 0;\n    }\n    [dir=rtl] .large-sides .timeline-item-left,\n    [dir=rtl] .large-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {\n        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-right: 0;\n    }\n}\n\n@media (min-width: 1200px) {\n    [dir=rtl] .xlarge-sides .timeline-item-right,\n    [dir=rtl] .xlarge-sides .timeline-item {\n        margin-right: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-left: 0;\n    }\n    [dir=rtl] .xlarge-sides .timeline-item-left,\n    [dir=rtl] .xlarge-sides .timeline-item:not(.timeline-item-right):nth-child(2n) {\n        margin-left: calc(50% - (var(--f7-timeline-divider-margin-horizontal) * 2 + var(--f7-timeline-divider-size)) / 2 - 50px);\n        margin-right: 0;\n    }\n}\n\n/*\n|------------------------------------------------------------------------------\n| Timer\n|------------------------------------------------------------------------------\n*/\n\n.timer-countdown .countdown-result {\n    display: none;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Toast\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-toast-icon-size: 1.75em;\n}\n\n:root .dark, :root.dark {\n    --f7-toast-text-color: #000000;\n}\n\n.aurora, .ios, .md {\n    --f7-toast-bg-color: #323232;\n    --f7-toast-button-min-width: auto;\n}\n\n.aurora .dark, .aurora.dark, .ios .dark, .ios.dark, .md .dark, .md.dark {\n    --f7-toast-bg-color: #FAFAFA;\n}\n\n.ios .dark, .ios.dark {\n    --f7-toast-bg-color-rgb: 250, 250, 250;\n}\n\n.md {\n    --f7-toast-padding-horizontal: 16px;\n}\n\n.aurora .toast.toast-round, .ios .toast.toast-round, .md .toast.toast-round {\n    border-radius: calc(var(--f7-toast-border-radius) * 8);\n}\n\n.toast[class*='color-'] {\n    background-color: var(--f7-theme-color);\n    color: #FFFFFF;\n}\n\n.ios .toast {\n    border-radius: var(--f7-toast-border-radius);\n}\n\n@media (max-width: 568px) {\n    .ios .toast {\n        left: 8px;\n        width: calc(100% - 16px);\n    }\n\n    .ios .toast.toast-top {\n        margin-top: var(--f7-safe-area-top);\n        top: 8px;\n    }\n\n    .ios .toast.toast-bottom {\n        bottom: calc(8px + var(--f7-safe-area-bottom));\n    }\n\n    .ios .toast.toast-top .toast-content {\n        padding-top: var(--f7-toast-padding-vertical);\n    }\n\n    .ios .toast.toast-bottom .toast-content {\n        padding-bottom: var(--f7-toast-padding-vertical);\n    }\n}\n\n.toast-button {\n    text-transform: uppercase;\n}\n\n.ios .toast-button, .md .toast-button {\n    margin-left: 16px;\n    margin-right: 0;\n}\n\n[dir=rtl].ios .toast-button, [dir=rtl].md .toast-button {\n    margin-left: 0;\n    margin-right: 16px;\n}\n\n.toast[class*='color-'] .toast-button {\n    color: #FFFFFF;\n}\n\n.toast .toast-button[class*='color-'] {\n    color: var(--f7-theme-color);\n}\n\n.toast-with-icon.icon-position-start .toast-content {\n    display: flex;\n    justify-content: flex-start;\n}\n\n.toast-with-icon.icon-position-start .toast-icon + .toast-text {\n    margin-left: 6px;\n    margin-right: 0;\n}\n\n[dir=rtl] .toast-with-icon.icon-position-start .toast-icon + .toast-text {\n    margin-left: 0;\n    margin-right: 6px;\n}\n\n.toast-center .toast-text {\n    text-align: center;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Toggle\n|------------------------------------------------------------------------------\n*/\n\n.ios {\n    --f7-toggle-height: 28px;\n    --f7-toggle-width: 52px;\n}\n\n.toggle .toggle-label {\n    align-items: center;\n    box-sizing: border-box;\n    color: #FFFFFF;\n    cursor: pointer;\n    display: flex;\n    font-size: 8px;\n    height: var(--f7-toggle-height);\n    line-height: 1;\n    overflow: hidden;\n    padding: 0 4px;\n    position: absolute;\n    text-overflow: ellipsis;\n    text-transform: uppercase;\n    top: 0;\n    white-space: nowrap;\n    width: var(--f7-toggle-width);\n}\n\n.ios .toggle .toggle-label {\n    font-size: 10px;\n}\n\n.md .toggle .toggle-label {\n    padding: 0 3px;\n}\n\n.toggle .toggle-label i {\n    font-size: 16px;\n}\n\n.toggle input:not(:checked) ~ .toggle-label {\n    justify-content: flex-end;\n}\n\n.toggle input:checked ~ .toggle-label {\n    justify-content: flex-start;\n}\n\n.md .toggle input:not(:checked) ~ .toggle-label {\n    justify-content: flex-start;\n}\n\n.md .toggle input:checked ~ .toggle-label {\n    justify-content: flex-end;\n}\n\n.ios .toggle input:not(:checked) ~ .toggle-label, .md .toggle input:not(:checked) ~ .toggle-label {\n    color: var(--f7-color-gray);\n}\n\n.toggle input:not(:checked) ~ .toggle-label .toggle-label-on {\n    display: none;\n}\n\n.toggle input:checked ~ .toggle-label .toggle-label-off {\n    display: none;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Toolbar\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-toolbar-hide-show-transition-duration: 0ms;\n}\n\n.toolbar {\n    position: relative;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Tooltip\n|------------------------------------------------------------------------------\n*/\n\n:root {\n    --f7-tooltip-bg-color: rgba(0, 0, 0, 0.95);\n}\n\n:root .dark, :root.dark {\n    --f7-tooltip-bg-color: rgba(255, 255, 255, 0.95);\n    --f7-tooltip-text-color: #000000;\n}\n\n.tooltip {\n    max-width: 256px;\n}\n\n.tooltip[class*='color-'] {\n    --f7-tooltip-bg-color: rgba(var(--f7-theme-color-rgb), 0.95);\n    --f7-tooltip-text-color: #FFFFFF;\n}\n\n.tooltip[class*='text-color-'] {\n    --f7-tooltip-text-color: var(--f7-theme-color);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Tour Guide\n|------------------------------------------------------------------------------\n*/\n\n.shepherd-element {\n    background-color: var(--f7-popover-bg-color) !important;\n    border-radius: var(--f7-popover-border-radius) !important;\n    box-shadow: var(--f7-popover-box-shadow) !important;\n    max-width: 384px !important;\n}\n\n.shepherd-element .shepherd-arrow:before {\n    background-color: var(--f7-popover-bg-color) !important;\n}\n\n.shepherd-element.shepherd-has-title[data-popper-placement^=bottom] > .shepherd-arrow:before {\n    background-color: var(--f7-popover-bg-color) !important;\n}\n\n.shepherd-enabled.shepherd-target {\n    background-color: var(--f7-popover-bg-color);\n}\n\n.shepherd-element .shepherd-content {\n    background-color: var(--f7-popover-bg-color);\n    border-radius: var(--f7-popover-border-radius);\n}\n\n.shepherd-element .shepherd-header {\n    align-items: center;\n    border-top-left-radius: var(--f7-popover-border-radius);\n    border-top-right-radius: var(--f7-popover-border-radius);\n    justify-content: space-between;\n    line-height: var(--f7-line-height);\n    padding: 8px 16px;\n    position: relative;\n}\n\n.shepherd-element.shepherd-has-title .shepherd-content .shepherd-header {\n    background: var(--f7-popover-bg-color);\n    padding: 8px 16px;\n}\n\n.shepherd-element .shepherd-header:after {\n    background-color: var(--f7-card-header-border-color);\n    bottom: 0;\n    content: '';\n    display: block;\n    height: 1px;\n    left: 0;\n    position: absolute;\n    right: auto;\n    top: auto;\n    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));\n    transform-origin: 50% 100%;\n    width: 100%;\n    z-index: 15;\n}\n\n.shepherd-element .shepherd-title {\n    color: var(--f7-card-header-text-color);\n    flex: auto;\n    font-size: var(--f7-card-header-font-size);\n    font-weight: var(--f7-card-header-font-weight);\n}\n\n.shepherd-element .shepherd-cancel-icon {\n    background-color: rgba(0, 0, 0, 0.25);\n    border-radius: 50%;\n    color: rgba(255, 255, 255, 0.90);\n    font-size: 11px;\n    font-weight: bold;\n    height: 24px;\n    width: 24px;\n}\n\n.shepherd-element .shepherd-cancel-icon:after {\n    font-family: 'framework7-core-icons';\n    content: 'delete_md';\n}\n\n.dark .shepherd-element .shepherd-cancel-icon {\n    background-color: rgba(255, 255, 255, 0.25);\n    color: rgba(255, 255, 255, 0.50);\n}\n\n.shepherd-element .shepherd-cancel-icon:hover {\n    background-color: rgba(0, 0, 0, 0.30);\n    color: rgba(255, 255, 255, 0.95);\n}\n\n.dark .shepherd-element .shepherd-cancel-icon:hover {\n    background-color: rgba(255, 255, 255, 0.30);\n    color: rgba(255, 255, 255, 0.55);\n}\n\n.shepherd-element.shepherd-has-title .shepherd-content .shepherd-cancel-icon {\n    color: rgba(255, 255, 255, 0.90);\n}\n\n.dark .shepherd-element.shepherd-has-title .shepherd-content .shepherd-cancel-icon {\n    color: rgba(255, 255, 255, 0.50);\n}\n\n.shepherd-element.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {\n    color: rgba(255, 255, 255, 0.95);\n}\n\n.dark .shepherd-element.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {\n    color: rgba(255, 255, 255, 0.55);\n}\n\n.shepherd-element .shepherd-cancel-icon span {\n    display: none;\n}\n\n.shepherd-element .shepherd-text {\n    color: inherit;\n    font-size: inherit;\n    line-height: inherit;\n    padding: var(--f7-card-content-padding-vertical) var(--f7-card-content-padding-horizontal);\n}\n\n.shepherd-element .shepherd-footer {\n    border-bottom-left-radius: var(--f7-popover-border-radius);\n    border-bottom-right-radius: var(--f7-popover-border-radius);\n    justify-content: space-between;\n    padding: calc(var(--f7-card-footer-padding-horizontal) / 1.5) var(--f7-card-footer-padding-horizontal);\n    position: relative;\n}\n\n.shepherd-element .shepherd-footer:before {\n    background-color: var(--f7-card-footer-border-color);\n    bottom: auto;\n    content: '';\n    display: block;\n    height: 1px;\n    left: 0;\n    position: absolute;\n    right: auto;\n    top: 0;\n    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));\n    transform-origin: 50% 0%;\n    width: 100%;\n    z-index: 15;\n}\n\n.shepherd-element .shepherd-button {\n    align-items: center;\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: var(--f7-theme-color);\n    border-radius: var(--f7-button-border-radius);\n    box-shadow: var(--f7-button-box-shadow);\n    box-sizing: border-box;\n    color: #FFFFFF;\n    display: flex;\n    font-family: inherit;\n    font-size: var(--f7-button-font-size);\n    font-weight: var(--f7-button-font-weight);\n    height: var(--f7-button-height);\n    justify-content: center;\n    letter-spacing: var(--f7-button-letter-spacing);\n    line-height: calc(var(--f7-button-height) - var(--f7-button-border-width, 0) * 2);\n    margin: 0;\n    min-width: var(--f7-button-min-width);\n    outline: 0;\n    overflow: hidden;\n    padding: var(--f7-button-padding-vertical) var(--f7-button-padding-horizontal);\n    position: relative;\n    text-align: center;\n    text-decoration: none;\n    text-overflow: ellipsis;\n    text-transform: var(--f7-button-text-transform);\n    transition: none;\n    vertical-align: middle;\n    white-space: nowrap;\n}\n\n.shepherd-element .shepherd-button + .shepherd-button {\n    margin-left: 16px;\n    margin-right: 0;\n}\n\n[dir=rtl] .shepherd-element .shepherd-button + .shepherd-button {\n    margin-left: 0;\n    margin-right: 16px;\n}\n\n.shepherd-element .shepherd-button:not(:disabled):hover {\n    background-color: var(--f7-theme-color-tint);\n    color: #FFFFFF;\n}\n\n.shepherd-element .shepherd-button.shepherd-button-secondary {\n    background-color: var(--f7-color-gray);\n    color: #FFFFFF;\n}\n\n.shepherd-element .shepherd-button.shepherd-button-secondary:not(:disabled):hover {\n    background-color: var(--f7-color-gray-tint);\n    color: #FFFFFF;\n}\n\n.shepherd-element .shepherd-button.shepherd-button-secondary[class*='color-'] {\n    background-color: var(--f7-theme-color);\n}\n\n.shepherd-element .shepherd-button.shepherd-button-secondary[class*='color-']:not(:disabled):hover {\n    background-color: var(--f7-theme-color-tint);\n}\n\n/*\n|------------------------------------------------------------------------------\n| Tree View\n|------------------------------------------------------------------------------\n*/\n\n.aurora, .ios, .md {\n    --f7-treeview-label-font-size: 16px;\n}\n\n.treeview-item-content .icon[class*='color-'] {\n    color: var(--f7-theme-color);\n}\n\n.treeview-preloader {\n    --f7-preloader-size: 20px;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Video\n|------------------------------------------------------------------------------\n*/\n\nvideo {\n    background-color: #000000;\n    max-width: 100%;\n    vertical-align: bottom;\n}\n\n.dark video {\n    background-color: #111111;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Virtual List\n|------------------------------------------------------------------------------\n*/\n\n.virtual-list {\n    position: relative;\n}\n\n/*\n|------------------------------------------------------------------------------\n| Utilities\n|------------------------------------------------------------------------------\n*/\n\n[class*='text-gradient-'] { -webkit-background-clip: text; -webkit-text-fill-color: transparent; }\n\n.bg-transparent { background: transparent !important; }\n.bg-translucent { background-color: rgba(255, 255, 255, 0.75); -webkit-backdrop-filter: blur(24px); backdrop-filter: blur(24px); }\n.dark .bg-translucent, .dark.bg-translucent { background-color: rgba(45, 45, 45, 0.75); }\n\n.bg-color-chrome { --f7-theme-color-bg-color: rgba(var(--f7-color-gray-rgb), 0.25); }\n.border-color-chrome { --f7-theme-color-border-color: rgba(var(--f7-color-gray-rgb), 0.25); }\n\n.opacity-0 { opacity: 0; }\n.opacity-25 { opacity: 0.25; }\n.opacity-50 { opacity: 0.5; }\n.opacity-75 { opacity: 0.75; }\n.opacity-100 { opacity: 1; }\n\n.font-size-8 { font-size: 8px !important; }\n.font-size-10 { font-size: 10px !important; }\n.font-size-12 { font-size: 12px !important; }\n.font-size-14 { font-size: 14px !important; }\n.font-size-16 { font-size: 16px !important; }\n.font-size-18 { font-size: 18px !important; }\n.font-size-20 { font-size: 20px !important; }\n.font-size-22 { font-size: 22px !important; }\n.font-size-24 { font-size: 24px !important; }\n.font-size-26 { font-size: 26px !important; }\n.font-size-28 { font-size: 28px !important; }\n.font-size-30 { font-size: 30px !important; }\n.font-size-32 { font-size: 32px !important; }\n.font-size-40 { font-size: 40px !important; }\n.font-size-48 { font-size: 48px !important; }\n.font-size-56 { font-size: 56px !important; }\n.font-size-64 { font-size: 64px !important; }\n.font-size-72 { font-size: 72px !important; }\n.font-size-80 { font-size: 80px !important; }\n.font-size-88 { font-size: 88px !important; }\n.font-size-96 { font-size: 96px !important; }\n\n.font-weight-bold { font-weight: bold !important; }\n.font-weight-normal { font-weight: normal !important; }\n.font-weight-600 { font-weight: 600 !important; }\n.font-weight-800 { font-weight: 800 !important; }\n.font-weight-900 { font-weight: 900 !important; }\n\n.text-capitalize { text-transform: capitalize !important; }\n.text-uppercase { text-transform: uppercase !important; }\n.text-italic { font-style: italic; }\n.text-underline-dotted { cursor: pointer; text-decoration-line: underline; text-decoration-style: dotted; }\n\n.single-line-text { display: block !important; overflow: hidden !important; text-overflow: ellipsis !important; white-space: nowrap !important; }\n.multi-line-text { display: -webkit-box !important; -webkit-box-orient: vertical !important; -webkit-line-clamp: 2 !important; overflow: hidden !important; word-break: break-word !important; }\n.lines-1 { -webkit-line-clamp: 1 !important; }\n.lines-2 { -webkit-line-clamp: 2 !important; }\n.lines-3 { -webkit-line-clamp: 3 !important; }\n.lines-4 { -webkit-line-clamp: 4 !important; }\n.lines-5 { -webkit-line-clamp: 5 !important; }\n\n.overflow-hidden { overflow: hidden !important; }\n.overflow-visible { overflow: visible !important; }\n\n.height-100 { height: 100% !important; }\n.height-auto { height: auto !important; }\n.height-full { height: 100% !important; overflow-y: auto !important; }\n.width-100 { width: 100%; }\n\n.flexbox-centered {\n    align-items: center;\n    border-radius: inherit;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n}\n\n.flex-grow-1 { flex-grow: 1 !important; }\n.flex-wrap-wrap { flex-wrap: wrap !important; }\n\n.letter-spacing-1 { letter-spacing: 1px; }\n.line-height-1 { line-height: 1 !important; }\n\n.text-align-start { text-align: start !important; }\n.text-align-end { text-align: end !important; }\n\n.vertical-align-middle { vertical-align: middle !important; }\n\n.white-space-normal { white-space: normal !important; }\n.white-space-nowrap { white-space: nowrap !important; }\n\n.z-index-0 { z-index: 0 !important; }\n.z-index-1 { z-index: 1 !important; }\n.z-index-10 { z-index: 10 !important; }\n.z-index-100 { z-index: 100 !important; }\n.z-index-1000 { z-index: 1000 !important; }\n\n.user-select-none {\n    user-select: none;\n}\n\n.mask {\n    -webkit-mask-position: center;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    mask-repeat: no-repeat;\n    -webkit-mask-size: contain;\n    mask-size: contain;\n}\n\n.mask-squircle {\n    -webkit-mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjAwJyBoZWlnaHQ9JzIwMCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNMTAwIDBDMjAgMCAwIDIwIDAgMTAwczIwIDEwMCAxMDAgMTAwIDEwMC0yMCAxMDAtMTAwUzE4MCAwIDEwMCAwWicvPjwvc3ZnPg==);\n    mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjAwJyBoZWlnaHQ9JzIwMCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNMTAwIDBDMjAgMCAwIDIwIDAgMTAwczIwIDEwMCAxMDAgMTAwIDEwMC0yMCAxMDAtMTAwUzE4MCAwIDEwMCAwWicvPjwvc3ZnPg==);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
